/**
 * Workshop booking wizard — venue → (waitlist | calendar/time) → multi-variant cart.
 * Pricing: window.resolveWorkshopPrice (workshop-booking.js).
 */
(function () {
  'use strict';

  window.__wbwWizardScriptRev = '2026-07-08-promo-diag';
  window.__wbwPromoDiag = { scriptLoaded: true, phase: 'parsing' };

  if (window.__WB_INITIAL_VARIANT__ == null || String(window.__WB_INITIAL_VARIANT__).trim() === '') {
    try {
      var _wbVar = new URLSearchParams(window.location.search).get('variant');
      if (_wbVar && String(_wbVar).trim()) window.__WB_INITIAL_VARIANT__ = String(_wbVar).trim();
    } catch (_) {}
  }

  var Flow = window.WorkshopBookingWizardCalendar || window.WorkshopCityFlow;
  var LiveApi = window.WorkshopCityEvents;
  var WizardLive = window.WorkshopBookingWizardLive;
  var MONTHS = (Flow && Flow.MONTHS) || [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  var DOW_PICKER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DOW_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var VARIANT_ROW_MIN_PX = 86;
  var VARIANT_ROW_MIN_H_PX = 54;
  var VARIANT_GRID_GAP_PX = 4;

  function getLiveApi() {
    return window.WorkshopCityEvents || LiveApi || null;
  }

  function getWizardLive() {
    return window.WorkshopBookingWizardLive || WizardLive || null;
  }

  function parseData(root) {
    var sid = root.getAttribute('data-section-id');
    var el = sid ? document.getElementById('WorkshopWizardData-' + sid) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  var WB_WORKSHOP_TYPES = ['mosaic', 'resin', 'ceramic', 'flower'];

  function workshopTypeFromText(text) {
    var raw = String(text || '')
      .toLowerCase()
      .trim();
    if (!raw) return '';
    for (var i = 0; i < WB_WORKSHOP_TYPES.length; i++) {
      var t = WB_WORKSHOP_TYPES[i];
      if (raw === t || raw.indexOf(t) !== -1) return t;
    }
    return '';
  }

  function fetchWorkshopTypeFromProduct(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve('');
    if (!window.__WB_WORKSHOP_TYPE_BY_HANDLE) window.__WB_WORKSHOP_TYPE_BY_HANDLE = Object.create(null);
    if (window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] != null) {
      return Promise.resolve(window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        var tags = [];
        if (product && product.tags) {
          if (Array.isArray(product.tags)) tags = product.tags;
          else {
            tags = String(product.tags)
              .split(',')
              .map(function (t) {
                return String(t).trim();
              })
              .filter(Boolean);
          }
        }
        var found = '';
        for (var ti = 0; ti < tags.length; ti++) {
          found = workshopTypeFromText(tags[ti]);
          if (found) break;
        }
        if (!found) found = workshopTypeFromText(product && product.handle);
        window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] = found;
        return found;
      })
      .catch(function () {
        window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] = '';
        return '';
      });
  }

  function resolveWaitlistWorkshopType(wizardRoot, bookingRoot, data) {
    var fromBooking = bookingRoot ? workshopTypeFromText(bookingRoot.getAttribute('data-workshop-type')) : '';
    if (fromBooking) return Promise.resolve(fromBooking);
    var fromWizard = wizardRoot ? workshopTypeFromText(wizardRoot.getAttribute('data-workshop-type')) : '';
    if (fromWizard) return Promise.resolve(fromWizard);
    if (data && data.workshopType) {
      var fromData = workshopTypeFromText(data.workshopType);
      if (fromData) return Promise.resolve(fromData);
    }
    var handle = '';
    if (data && data.productHandle) handle = String(data.productHandle).trim();
    if (!handle && wizardRoot) handle = String(wizardRoot.getAttribute('data-product-handle') || '').trim();
    if (!handle && bookingRoot) handle = String(bookingRoot.getAttribute('data-product-handle') || '').trim();
    var fromHandle = workshopTypeFromText(handle);
    if (fromHandle) return Promise.resolve(fromHandle);
    return fetchWorkshopTypeFromProduct(handle);
  }

  function parseSiblingPromoData(sectionId) {
    var el = sectionId ? document.getElementById('WorkshopSiblingPromoData-' + sectionId) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function siblingPromoScope(wizardRoot, sectionId) {
    if (wizardRoot) {
      var slotHost = wizardRoot.querySelector('[data-wbw-promo-slot] [data-wbw-sibling-promo-wrap]');
      if (slotHost) {
        var embedded = slotHost.closest('[data-workshop-sibling-promo]');
        return embedded || wizardRoot;
      }
    }
    var sid = sectionId || (wizardRoot && wizardRoot.getAttribute('data-section-id'));
    if (sid) {
      var section = document.getElementById('shopify-section-' + sid);
      if (section && section.querySelector('[data-wbw-sibling-promo-wrap]')) return section;
      var host = document.querySelector(
        '[data-workshop-sibling-promo][data-section-id="' +
          String(sid).replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
          '"]'
      );
      if (host) return host.closest('.shopify-section') || host;
    }
    var near = wizardRoot && wizardRoot.closest('.shopify-section');
    if (near && near.querySelector('[data-wbw-sibling-promo-wrap]')) return near;
    return document;
  }

  function attachSiblingPromoHost(wizardRoot, sectionId) {
    if (!wizardRoot) return;
    var slot = wizardRoot.querySelector('[data-wbw-promo-slot]');
    if (!slot) return;
    var sid = String(sectionId || wizardRoot.getAttribute('data-section-id') || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
    var sel = '[data-workshop-sibling-promo][data-section-id="' + sid + '"]';
    var section = wizardRoot.closest('.shopify-section');
    var slotHost = slot.querySelector(sel);
    if (slotHost) {
      if (section) {
        section.querySelectorAll(sel).forEach(function (host) {
          if (host !== slotHost && !slot.contains(host)) host.remove();
        });
      }
      return;
    }
    var host = (section && section.querySelector(sel)) || document.querySelector(sel);
    if (host && host.parentNode !== slot) slot.appendChild(host);
  }

  function ensureSiblingPromoDom(wizardRoot, sectionId) {
    attachSiblingPromoHost(wizardRoot, sectionId);
    var slot = wizardRoot && wizardRoot.querySelector('[data-wbw-promo-slot]');
    if (!slot) return;
    var hosts = slot.querySelectorAll('[data-workshop-sibling-promo]');
    for (var hi = 1; hi < hosts.length; hi++) hosts[hi].remove();
    if (slot.querySelector('[data-wbw-sibling-promo-wrap]')) return;
    var host = document.createElement('div');
    host.className = 'wbw-sibling-promo-host';
    host.setAttribute('data-workshop-sibling-promo', '');
    host.setAttribute('data-section-id', String(sectionId || wizardRoot.getAttribute('data-section-id') || ''));
    host.innerHTML =
      '<div class="wbw-sibling-promo-wrap" data-wbw-sibling-promo-wrap hidden aria-hidden="true">' +
      '<div class="wbw-sibling-promo-list" data-wbw-sibling-promo-list></div></div>';
    slot.appendChild(host);
  }

  function siblingPromoHosts(wizardRoot, sectionId) {
    var sid = String(sectionId || (wizardRoot && wizardRoot.getAttribute('data-section-id')) || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
    if (!sid) return [];
    var sel = '[data-workshop-sibling-promo][data-section-id="' + sid + '"]';
    var section = wizardRoot && wizardRoot.closest('.shopify-section');
    var hosts = section ? section.querySelectorAll(sel) : document.querySelectorAll(sel);
    return Array.prototype.slice.call(hosts || []);
  }

  var WB_HANDLE_ALIAS_GROUPS = [
    ['mosaic-lamp-workshop', 'mosaic-workshop', 'mosaic-classes', 'mosaic-classess'],
    ['ceramic-painting-workshop', 'ceramic-painting-classes', 'ceramic-painting-classess'],
    ['flower-decorating', 'flower-decoration'],
    ['resin-art-workshop', 'resin-art', 'resin-workshop'],
  ];

  function handlesMatchForPromo(a, b) {
    a = String(a || '')
      .trim()
      .toLowerCase();
    b = String(b || '')
      .trim()
      .toLowerCase();
    if (!a || !b) return false;
    if (a === b) return true;
    for (var gi = 0; gi < WB_HANDLE_ALIAS_GROUPS.length; gi++) {
      var group = WB_HANDLE_ALIAS_GROUPS[gi];
      if (group.indexOf(a) >= 0 && group.indexOf(b) >= 0) return true;
    }
    return false;
  }

  function canonicalPromoHandle(h) {
    h = String(h || '')
      .trim()
      .toLowerCase();
    if (!h) return '';
    for (var gi = 0; gi < WB_HANDLE_ALIAS_GROUPS.length; gi++) {
      var group = WB_HANDLE_ALIAS_GROUPS[gi];
      if (group.indexOf(h) >= 0) return group[0];
    }
    return h;
  }

  function normalizeTimeLabel(raw) {
    var t = String(raw || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ');
    if (!t) return '';
    var m = t.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/);
    if (!m) return t;
    var h = parseInt(m[1], 10);
    var hh = h < 10 ? '0' + h : String(h);
    return hh + ':' + m[2] + ' ' + m[3];
  }

  function buildPromoVenueContext(venue, venueCard, slot) {
    var raw = slot && slot._raw;
    return {
      venue_ref_id: String((venue && venue.venue_ref_id) || (raw && raw.venue_ref_id) || '').trim(),
      venue_handle: String(
        (venue && (venue.venue_handle || venue.handle)) || (raw && raw.venue_handle) || ''
      )
        .trim()
        .toLowerCase(),
      venue_name: String(
        (venue && (venue.venue_name || venue.name)) || (raw && raw.venue_name) || ''
      ).trim(),
      city: String(
        (venue && (venue.city || venue.city_name)) || (raw && (raw.city || raw.city_name)) || ''
      ).trim(),
      state: String((venue && (venue.state || venue.state_code)) || (raw && (raw.state || raw.state_code)) || '')
        .trim()
        .toLowerCase(),
      cardLabel:
        venueCard && venueCard.getAttribute
          ? String(venueCard.getAttribute('data-wbw-city-label') || '').trim()
          : '',
    };
  }

  function venueRowMatchesContextScore(row, ctx) {
    if (!row || !ctx) return -1;
    if (
      refsOverlap(
        venueRefAliasKeys(ctx.venue_ref_id),
        venueRefAliasKeys(row.venue_ref_id)
      )
    ) {
      return 5;
    }
    var rowHandle = String(row.venue_handle || '')
      .trim()
      .toLowerCase();
    if (ctx.venue_handle && rowHandle && ctx.venue_handle === rowHandle) return 5;
    var labels = [ctx.venue_name, ctx.cardLabel];
    for (var li = 0; li < labels.length; li++) {
      if (venueNamesLooselyMatch(labels[li], row.venue_name)) return 4;
    }
    var ctxCity = venueNameLookupKey(ctx.city);
    var rowCity = venueNameLookupKey(row.city || '');
    if (ctxCity && rowCity && ctxCity === rowCity) return 2;
    if (ctxCity && ctxCity.length >= 4 && venueNamesLooselyMatch(row.venue_name, ctxCity)) return 1;
    return -1;
  }

  function resolvePromoDeepLinkFromIndex(targetHandle, currentHandle, venue, venueCard, slot, indexRows) {
    targetHandle = String(targetHandle || '')
      .trim()
      .toLowerCase();
    currentHandle = String(currentHandle || '')
      .trim()
      .toLowerCase();
    if (!targetHandle || !slot) return { eventId: '', venueHandle: '' };

    var ctx = buildPromoVenueContext(venue, venueCard, slot);
    var curDate = slotDateKey(slot);
    var curTime = normalizeTimeLabel(slot.time_label);
    indexRows = indexRows || [];
    var best = null;
    var bestScore = -1;

    function considerRow(row, score) {
      var eid = extractNumericEventIdForUrl(row.event_id || row.id || '');
      if (!eid || score <= bestScore) return;
      bestScore = score;
      best = row;
    }

    indexRows.forEach(function (row) {
      if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
      var dk = toIsoDateKey(row.date_key);
      if (curDate && dk && dk !== curDate) return;
      var rowTime = normalizeTimeLabel(row.time_label);
      var timeOk = !curTime || !rowTime || rowTime === curTime;
      var venueScore = venueRowMatchesContextScore(row, ctx);
      if (venueScore < 0) return;
      considerRow(row, venueScore + (timeOk ? 20 : 0));
    });

    if (!best && currentHandle) {
      var anchorNames = Object.create(null);
      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, currentHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var rowTime = normalizeTimeLabel(row.time_label);
        if (curTime && rowTime && rowTime !== curTime) return;
        var nk = venueNameLookupKey(row.venue_name);
        if (nk) anchorNames[nk] = true;
      });
      if (ctx.venue_name) anchorNames[venueNameLookupKey(ctx.venue_name)] = true;
      if (ctx.cardLabel) anchorNames[venueNameLookupKey(ctx.cardLabel)] = true;
      if (ctx.city) anchorNames[venueNameLookupKey(ctx.city)] = true;

      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var rowTime = normalizeTimeLabel(row.time_label);
        var timeOk = !curTime || !rowTime || rowTime === curTime;
        var rowNk = venueNameLookupKey(row.venue_name);
        var nameHit = !!(rowNk && anchorNames[rowNk]);
        if (!nameHit && rowNk) {
          Object.keys(anchorNames).forEach(function (ak) {
            if (!nameHit && venueNamesLooselyMatch(ak, rowNk)) nameHit = true;
          });
        }
        var cityHit = !!(ctx.city && venueNameLookupKey(row.city || '') === venueNameLookupKey(ctx.city));
        if (!nameHit && !cityHit) return;
        considerRow(row, (nameHit ? 15 : 10) + (timeOk ? 20 : 0) + (cityHit ? 5 : 0));
      });
    }

    if (!best) {
      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var venueScore = venueRowMatchesContextScore(row, ctx);
        if (venueScore < 1) return;
        considerRow(row, venueScore);
      });
    }

    if (!best) {
      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var rowTime = normalizeTimeLabel(row.time_label);
        if (curTime && rowTime && rowTime !== curTime) return;
        considerRow(row, 2);
      });
    }

    if (!best) return { eventId: '', venueHandle: '' };
    return {
      eventId: extractNumericEventIdForUrl(best.event_id || best.id || ''),
      venueHandle: extractNumericVenueRefForUrl(best.venue_ref_id) || '',
    };
  }

  var WB_SIBLING_HANDLE_FALLBACKS = {
    'mosaic-lamp-workshop': ['ceramic-painting-workshop', 'ceramic-painting-classes', 'ceramic-painting-classess'],
    'mosaic-workshop': ['ceramic-painting-workshop', 'ceramic-painting-classes', 'ceramic-painting-classess'],
    'mosaic-classess': ['ceramic-painting-classess', 'ceramic-painting-classes'],
    'mosaic-classes': ['ceramic-painting-classess', 'ceramic-painting-classes'],
    'ceramic-painting-classess': ['mosaic-lamp-workshop', 'mosaic-classess', 'mosaic-classes', 'mosaic-workshop'],
    'ceramic-painting-classes': ['mosaic-lamp-workshop', 'mosaic-classess', 'mosaic-classes', 'mosaic-workshop'],
    'ceramic-painting-workshop': ['mosaic-lamp-workshop', 'mosaic-workshop', 'mosaic-classes', 'mosaic-classess'],
  };

  var WB_SIBLING_LABELS = {
    'mosaic-lamp-workshop': 'Mosaic Lamp Workshop',
    'mosaic-classess': 'Mosaic Lamp Classes',
    'mosaic-classes': 'Mosaic Lamp Classes',
    'mosaic-workshop': 'Mosaic Workshop',
    'ceramic-painting-classess': 'Ceramic Painting Classes',
    'ceramic-painting-classes': 'Ceramic Painting Classes',
    'ceramic-painting-workshop': 'Ceramic Painting Workshop',
    'flower-decorating': 'Flower Decorating',
    'flower-decoration': 'Flower Decorating',
    'resin-art-workshop': 'Resin Art Workshop',
    'resin-art': 'Resin Art Workshop',
    'resin-workshop': 'Resin Art Workshop',
  };

  function parseVenueWaitlistCatalog(bookingRoot) {
    if (!bookingRoot) return [];
    var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function findCatalogVenueByToken(catalog, venueToken) {
    if (!catalog || !catalog.length || !venueToken) return null;
    var tokenNum = extractNumericVenueRefForUrl(venueToken);
    var tokenLower = String(venueToken).trim().toLowerCase();
    for (var i = 0; i < catalog.length; i++) {
      var row = catalog[i];
      if (!row) continue;
      if (tokenNum && extractNumericVenueRefForUrl(row.venue_ref_id) === tokenNum) return row;
      var venueHandle = String(row.venue_handle || '').trim().toLowerCase();
      var venueName = String(row.venue_name || '').trim().toLowerCase();
      if (tokenLower && (venueHandle === tokenLower || venueName === tokenLower)) return row;
      if (tokenLower && venueName && venueNamesLooselyMatch(venueName, tokenLower)) return row;
    }
    return null;
  }

  function parseVenueWorkshopIndex(sectionId) {
    var rows = [];
    var seen = Object.create(null);
    function absorb(el) {
      if (!el) return;
      try {
        var parsed = JSON.parse(el.textContent || '[]');
        if (!Array.isArray(parsed)) return;
        parsed.forEach(function (row) {
          if (!row) return;
          var eid = extractNumericEventIdForUrl(row.event_id || row.id || '');
          var ph = String(row.product_handle || '')
            .trim()
            .toLowerCase();
          var key = (eid || 'x') + '|' + (ph || 'x') + '|' + toIsoDateKey(row.date_key);
          if (seen[key]) return;
          seen[key] = true;
          rows.push(row);
        });
      } catch (_) {}
    }
    if (sectionId) absorb(document.getElementById('WorkshopVenueWorkshopIndex-' + sectionId));
    if (typeof document !== 'undefined') {
      document.querySelectorAll('script[id^="WorkshopVenueWorkshopIndex-"]').forEach(absorb);
    }
    return rows;
  }

  function findIndexRowByEventId(indexRows, eventId) {
    var num = extractNumericEventIdForUrl(eventId);
    if (!num || !indexRows || !indexRows.length) return null;
    for (var i = 0; i < indexRows.length; i++) {
      var row = indexRows[i];
      if (!row) continue;
      if (extractNumericEventIdForUrl(row.event_id || row.id || '') === num) return row;
    }
    return null;
  }

  function promoEventIdMatchesVenueContext(eventId, venue, venueCard, slot, indexRows) {
    var row = findIndexRowByEventId(indexRows, eventId);
    if (!row) return false;
    var ctx = buildPromoVenueContext(venue, venueCard, slot);
    return venueRowMatchesContextScore(row, ctx) >= 4;
  }

  function resolveVenueAnchoredPromoEventId(
    targetHandle,
    currentHandle,
    venue,
    venueCard,
    slot,
    indexRows,
    fallbackEventId
  ) {
    var eventId = '';
    if (slot) {
      eventId = resolveSiblingEventIdFromSessionAnchor(
        targetHandle,
        slot,
        venue,
        venueCard,
        indexRows
      );
    }
    if (!eventId) {
      var idx = resolvePromoDeepLinkFromIndex(
        targetHandle,
        currentHandle,
        venue,
        venueCard,
        slot,
        indexRows
      );
      eventId = idx.eventId || '';
    }
    if (
      !eventId &&
      fallbackEventId &&
      promoEventIdMatchesVenueContext(fallbackEventId, venue, venueCard, slot, indexRows)
    ) {
      eventId = extractNumericEventIdForUrl(fallbackEventId);
    }
    return eventId || '';
  }

  function resolveEventIdForProductAtVenue(productHandle, venue, venueCard, hintEventId, indexRows) {
    productHandle = String(productHandle || '')
      .trim()
      .toLowerCase();
    if (!productHandle || !venue) return '';
    var ctx = buildPromoVenueContext(venue, venueCard, null);
    var hintDate = '';
    var hintTime = '';
    if (hintEventId) {
      var hintRow = findIndexRowByEventId(indexRows, hintEventId);
      if (hintRow) {
        hintDate = toIsoDateKey(hintRow.date_key);
        hintTime = normalizeTimeLabel(hintRow.time_label);
      }
    }
    var best = null;
    var bestScore = -1;
    indexRows = indexRows || [];
    indexRows.forEach(function (row) {
      if (!row || !handlesMatchForPromo(row.product_handle, productHandle)) return;
      var venueScore = venueRowMatchesContextScore(row, ctx);
      if (venueScore < 4) return;
      var score = venueScore;
      var dk = toIsoDateKey(row.date_key);
      var rowTime = normalizeTimeLabel(row.time_label);
      if (hintDate && dk === hintDate) score += 20;
      if (hintTime && rowTime === hintTime) score += 20;
      if (score > bestScore) {
        bestScore = score;
        best = row;
      }
    });
    return best ? extractNumericEventIdForUrl(best.event_id || best.id || '') : '';
  }

  function slotListContainsEventId(slots, eventId) {
    var urlNum = extractNumericEventIdForUrl(eventId);
    if (!urlNum || !Array.isArray(slots)) return false;
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var raw = s && s._raw;
      var num = extractNumericEventIdForUrl(
        (raw && (raw.id || raw.event_metaobject_gid || raw.gid)) || (s && s.gid) || ''
      );
      if (num && num === urlNum) return true;
    }
    return false;
  }

  /** Match sibling event_id at same venue/session using the currently selected slot as anchor. */
  function resolveSiblingEventIdFromSessionAnchor(targetHandle, slot, venue, venueCard, indexRows) {
    targetHandle = String(targetHandle || '')
      .trim()
      .toLowerCase();
    if (!targetHandle || !slot || !indexRows || !indexRows.length) return '';

    var raw = slot._raw || {};
    var anchorRow = findIndexRowByEventId(
      indexRows,
      raw.id || raw.event_metaobject_gid || raw.gid || slot.gid || ''
    );
    var ctx = buildPromoVenueContext(venue, venueCard, slot);
    var sessionDate = slotDateKey(slot);
    var sessionTime = normalizeTimeLabel(slot.time_label);
    var sessionVenueKeys = venueRefAliasKeys(
      (anchorRow && anchorRow.venue_ref_id) || ctx.venue_ref_id || raw.venue_ref_id || ''
    );

    if (anchorRow) {
      if (!sessionDate) sessionDate = toIsoDateKey(anchorRow.date_key);
      if (!sessionTime) sessionTime = normalizeTimeLabel(anchorRow.time_label);
      if (!sessionVenueKeys.length) sessionVenueKeys = venueRefAliasKeys(anchorRow.venue_ref_id);
    }

    if (!sessionDate || !sessionTime) return '';

    var candidates = [];
    indexRows.forEach(function (row) {
      if (!row || !handlesMatchForPromo(row.product_handle, targetHandle)) return;
      var dk = toIsoDateKey(row.date_key);
      if (dk !== sessionDate) return;
      var rowTime = normalizeTimeLabel(row.time_label);
      if (!rowTime || rowTime !== sessionTime) return;
      var venueScore = sessionVenueKeys.length
        ? refsOverlap(sessionVenueKeys, venueRefAliasKeys(row.venue_ref_id))
          ? 5
          : venueRowMatchesContextScore(row, ctx) >= 1
            ? 2
            : -1
        : venueRowMatchesContextScore(row, ctx);
      if (venueScore < 0) return;
      candidates.push({ row: row, score: venueScore });
    });

    if (!candidates.length) return '';

    candidates.sort(function (a, b) {
      return b.score - a.score;
    });

    return extractNumericEventIdForUrl(candidates[0].row.event_id || candidates[0].row.id || '');
  }

  function venueRefAliasKeys(id) {
    var keys = [];
    var seen = Object.create(null);
    function add(k) {
      k = String(k || '').trim();
      if (!k || seen[k]) return;
      seen[k] = true;
      keys.push(k);
    }
    var raw = String(id == null ? '' : id).trim();
    if (!raw) return keys;
    add(raw);
    add(normalizeVenueRefId(raw));
    var m = raw.match(/(\d+)\s*$/);
    if (m) {
      add(m[1]);
      add('gid://shopify/Metaobject/' + m[1]);
    }
    if (raw.indexOf('v_') === 0) add(raw);
    return keys;
  }

  function venueNameLookupKey(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function buildVenueWorkshopMaps(rows) {
    var byRef = Object.create(null);
    var byName = Object.create(null);
    (rows || []).forEach(function (row) {
      if (!row) return;
      var h = String(row.product_handle || '')
        .trim()
        .toLowerCase();
      if (!h) return;
      venueRefAliasKeys(row.venue_ref_id).forEach(function (vid) {
        if (!byRef[vid]) byRef[vid] = Object.create(null);
        byRef[vid][h] = true;
      });
      var nameKey = venueNameLookupKey(row.venue_name);
      if (nameKey) {
        if (!byName[nameKey]) byName[nameKey] = Object.create(null);
        byName[nameKey][h] = true;
      }
    });
    return { byRef: byRef, byName: byName };
  }

  function normalizeVenueRefId(id) {
    var s = String(id == null ? '' : id).trim();
    if (!s) return '';
    if (s.indexOf('gid://') === 0) return s;
    var m = s.match(/Metaobject\/(\d+)$/i);
    if (m) return 'gid://shopify/Metaobject/' + m[1];
    if (/^\d+$/.test(s)) return 'gid://shopify/Metaobject/' + s;
    return s;
  }

  function ensureSiblingWorkshops(list, productHandle) {
    var out = Array.isArray(list) ? list.slice() : [];
    if (out.length) return out;
    var current = String(productHandle || '')
      .trim()
      .toLowerCase();
    var fallbacks = WB_SIBLING_HANDLE_FALLBACKS[current] || [];
    for (var i = 0; i < fallbacks.length; i++) {
      var h = String(fallbacks[i] || '').trim();
      if (!h || h === current) continue;
      out.push({
        handle: h,
        title: WB_SIBLING_LABELS[h] || h,
        label: WB_SIBLING_LABELS[h] || h,
        url: '/products/' + encodeURIComponent(h),
        image: null,
      });
      break;
    }
    return out;
  }

  function collectAlsoAvailableHandles(source, out) {
    if (!source) return;
    var aa = source.also_available_products;
    if (!Array.isArray(aa)) return;
    aa.forEach(function (p) {
      var h = String((p && (p.handle || p.product_handle || p.productHandle)) || '')
        .trim()
        .toLowerCase();
      if (h) out[h] = true;
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function extractNumericEventIdForUrl(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function extractNumericVariantIdForUrl(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var varGid = /^gid:\/\/shopify\/ProductVariant\/(\d+)$/i.exec(s);
    if (varGid) return varGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function extractNumericVenueRefForUrl(val) {
    return extractNumericEventIdForUrl(val);
  }

  function extractEventIdFromUrl(url) {
    if (!url) return '';
    try {
      return extractNumericEventIdForUrl(new URL(String(url), window.location.origin).searchParams.get('event_id') || '');
    } catch (_) {
      return '';
    }
  }

  function extractPromoEventIdFromProduct(p) {
    if (!p || typeof p !== 'object') return '';
    return (
      extractNumericEventIdForUrl(
        p.event_id ||
          p.eventId ||
          p.id ||
          p.gid ||
          p.event_metaobject_gid ||
          p.eventMetaobjectGid ||
          p.metaobject_gid ||
          p.metaobjectGid ||
          p.workshop_event_id ||
          p.workshopEventId ||
          p.linked_event_id ||
          p.linkedEventId ||
          ''
      ) ||
      extractEventIdFromUrl(p.url) ||
      ''
    );
  }

  function refsOverlap(aKeys, bKeys) {
    if (!aKeys || !bKeys) return false;
    var seen = Object.create(null);
    for (var i = 0; i < aKeys.length; i++) {
      if (aKeys[i]) seen[aKeys[i]] = true;
    }
    for (var j = 0; j < bKeys.length; j++) {
      if (bKeys[j] && seen[bKeys[j]]) return true;
    }
    return false;
  }

  function venueNamesLooselyMatch(a, b) {
    a = venueNameLookupKey(a);
    b = venueNameLookupKey(b);
    if (!a || !b) return false;
    if (a === b) return true;
    if (a.length >= 4 && (a.indexOf(b) >= 0 || b.indexOf(a) >= 0)) return true;
    return false;
  }

  function venueMatchesIndexRow(venue, row, venueCard) {
    if (!venue || !row) return false;
    if (
      refsOverlap(
        venueRefAliasKeys(venue.venue_ref_id),
        venueRefAliasKeys(row.venue_ref_id)
      )
    ) {
      return true;
    }
    var venueHandle = String(venue.venue_handle || venue.handle || '').trim().toLowerCase();
    var rowHandle = String(row.venue_handle || '').trim().toLowerCase();
    if (venueHandle && rowHandle && venueHandle === rowHandle) return true;
    var cardLabel =
      venueCard && venueCard.getAttribute
        ? String(venueCard.getAttribute('data-wbw-city-label') || '').trim()
        : '';
    var venueNames = [venue.venue_name, venue.name, venue.city_name, cardLabel];
    for (var ni = 0; ni < venueNames.length; ni++) {
      if (venueNamesLooselyMatch(venueNames[ni], row.venue_name)) return true;
    }
    var cityKey = venueNameLookupKey(venue.city || venue.city_name || '');
    if (cityKey && cityKey.length >= 4 && venueNamesLooselyMatch(row.venue_name, cityKey)) return true;
    return false;
  }

  function readInitialVariantIdFromUrl() {
    if (window.__WB_INITIAL_VARIANT__ != null && String(window.__WB_INITIAL_VARIANT__).trim() !== '') {
      return vQtyKey(window.__WB_INITIAL_VARIANT__);
    }
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      return v && String(v).trim() ? vQtyKey(v) : '';
    } catch (_) {
      return '';
    }
  }

  function getEventIdFromUrl() {
    if (window.__WB_INITIAL_EVENT_ID__ != null && String(window.__WB_INITIAL_EVENT_ID__).trim() !== '') {
      return String(window.__WB_INITIAL_EVENT_ID__).trim();
    }
    try {
      return (new URLSearchParams(window.location.search).get('event_id') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function getVenueTokenFromUrl() {
    try {
      return (new URLSearchParams(window.location.search).get('venue') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function urlHasWizardDeepLink() {
    return !!(getVenueTokenFromUrl() || getEventIdFromUrl());
  }

  function venueCardIsWaitlistOnly(card) {
    if (!card) return false;
    if (card.getAttribute('data-wb-waitlist-venue') === '1') return true;
    return !!(card._wbVenue && card._wbVenue._wbWaitlistVenue === true);
  }

  function getWbwStepFromUrl() {
    try {
      return (new URLSearchParams(window.location.search).get('wbw_step') || '').trim().toLowerCase();
    } catch (_) {
      return '';
    }
  }

  function clearWbwStepFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('wbw_step')) return;
      params.delete('wbw_step');
      var qs = params.toString();
      var nextUrl =
        window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (_) {}
  }

  function isVenueHandleToken(val) {
    var s = String(val == null ? '' : val).trim();
    return s.length > 0 && !/^\d+$/.test(s);
  }

  function venueUrlToken(venue) {
    if (!venue) return '';
    var ref = extractNumericVenueRefForUrl(venue.venue_ref_id);
    if (ref) return ref;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      if (!evs[i]) continue;
      ref = extractNumericVenueRefForUrl(evs[i].venue_ref_id);
      if (ref) return ref;
    }
    var h = String(venue.venue_handle || venue.handle || '').trim();
    if (h) return h;
    for (var j = 0; j < evs.length; j++) {
      if (!evs[j]) continue;
      h = String(evs[j].venue_handle || '').trim();
      if (h) return h;
    }
    return '';
  }

  function venueHandleFromSlotRaw(raw) {
    if (!raw) return '';
    var ref = extractNumericVenueRefForUrl(raw.venue_ref_id);
    if (ref) return ref;
    var h = String(raw.venue_handle || '').trim();
    return h || '';
  }

  function venueMatchesUrlToken(venue, token) {
    token = String(token || '').trim().toLowerCase();
    if (!token || !venue) return false;
    if (String(venue.venue_handle || venue.handle || '').trim().toLowerCase() === token) return true;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      if (String((evs[i] && evs[i].venue_handle) || '').trim().toLowerCase() === token) return true;
    }
    var ref = extractNumericVenueRefForUrl(venue.venue_ref_id);
    if (ref && ref.toLowerCase() === token) return true;
    var nameFields = [venue.venue_name, venue.name, venue.city_name, venue.city];
    for (var ni = 0; ni < nameFields.length; ni++) {
      var n = String(nameFields[ni] || '').trim().toLowerCase();
      if (!n) continue;
      if (n === token) return true;
      if (venueNamesLooselyMatch(n, token)) return true;
    }
    var matched = false;
    venueRefAliasKeys(venue.venue_ref_id).forEach(function (k) {
      if (String(k).trim().toLowerCase() === token) matched = true;
    });
    return matched;
  }

  function updateWizardBookingUrl(patch) {
    if (!patch) return;
    try {
      var params = new URLSearchParams(window.location.search);
      if (Object.prototype.hasOwnProperty.call(patch, 'eventId')) {
        var eid = extractNumericEventIdForUrl(patch.eventId);
        if (eid) {
          window.__WB_STRIP_EVENT_ID_PARAM__ = false;
          params.set('event_id', eid);
          window.__WB_URL_EVENT_ID_NUMERIC__ = eid;
        } else {
          window.__WB_STRIP_EVENT_ID_PARAM__ = true;
          window.__WB_URL_EVENT_ID_NUMERIC__ = '';
          window.__WB_INITIAL_EVENT_ID__ = null;
          params.delete('event_id');
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'variantId')) {
        var vid = extractNumericVariantIdForUrl(patch.variantId);
        if (vid) {
          params.set('variant', vid);
          window.__WB_URL_VARIANT_NUMERIC__ = vid;
        } else {
          params.delete('variant');
          window.__WB_URL_VARIANT_NUMERIC__ = '';
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'venue')) {
        var vt = String(patch.venue == null ? '' : patch.venue).trim();
        if (vt) {
          window.__WB_STRIP_VENUE_PARAM__ = false;
          params.set('venue', vt);
        } else {
          window.__WB_STRIP_VENUE_PARAM__ = true;
          params.delete('venue');
        }
      }
      var qs = params.toString();
      var nextUrl =
        window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (_) {}
  }

  function formatMoney(cents) {
    if (Flow && typeof Flow.formatMoney === 'function') return Flow.formatMoney(cents);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function slotBookable(slot) {
    var liveApi = getLiveApi();
    if (liveApi && typeof liveApi.isSlotBookable === 'function') return liveApi.isSlotBookable(slot);
    if (Flow && Flow.slotBookable) return Flow.slotBookable(slot);
    if (!slot || slotHidden(slot) || slotSoldOut(slot)) return false;
    return true;
  }

  function slotStatus(slot) {
    return String((slot && slot.status) || '')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
  }

  function slotDisplayStatus(slot) {
    return String((slot && slot.display_status) || '')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
  }

  function slotHidden(slot) {
    if (!slot) return true;
    var displayStatus = slotDisplayStatus(slot);
    if (displayStatus === 'hidden' || displayStatus === 'ended') return true;
    var st = slotStatus(slot);
    if (st === 'draft' || st === 'completed') return true;
    if (st === 'cancelled') {
      var cap = slot.capacity_remaining;
      if (cap == null || cap === '') {
        cap = slot._raw && slot._raw.capacity_remaining;
      }
      var capNum = cap != null && cap !== '' ? Number(cap) : null;
      return !(capNum != null && capNum > 0);
    }
    return false;
  }

  function slotSoldOut(slot) {
    if (!slot || slotHidden(slot)) return false;
    var liveApi = getLiveApi();
    if (liveApi && typeof liveApi.isSlotBookable === 'function') {
      return !liveApi.isSlotBookable(slot);
    }
    var st = slotStatus(slot);
    var displayStatus = slotDisplayStatus(slot);
    var cap = slot.capacity_remaining;
    if (cap == null || cap === '') {
      cap = slot._raw && slot._raw.capacity_remaining;
    }
    var capNum = cap != null && cap !== '' ? Number(cap) : null;
    if (
      (displayStatus === 'bookable' || displayStatus === 'active' || displayStatus === 'available') &&
      capNum != null &&
      capNum > 0
    ) {
      return false;
    }
    if (st === 'sold_out' || displayStatus === 'sold_out') return true;
    return capNum != null && capNum <= 0;
  }

  function slotVisible(slot) {
    return !!slot && !slotHidden(slot);
  }

  function formatSlotOptionText(slot) {
    if (!slot) return 'Session';
    var label = String(slot.time_label || '').trim();
    if (!label) {
      var dl = String(slot.display_label || '').trim();
      if (dl) {
        var pipe = dl.split('|');
        label = pipe.length > 1 ? pipe[pipe.length - 1].trim() : dl;
      }
    }
    if (!label) label = 'Session';
    if (slotSoldOut(slot)) return label + ' — Sold out';
    return label;
  }

  function slotDateKey(slot) {
    if (Flow && Flow.slotDateKey) return Flow.slotDateKey(slot);
    if (!slot) return '';
    if (slot.date_key) return String(slot.date_key).slice(0, 10);
    if (slot.schema_start) return String(slot.schema_start).slice(0, 10);
    return '';
  }

  function toIsoDateKey(raw) {
    if (raw == null || raw === '') return '';
    var s = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    return '';
  }

  function normalizeEventToSlot(ev) {
    if (!ev || typeof ev !== 'object') return null;
    var status = String(ev.status || ev.booking_status || ev.event_status || 'active')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
    if (status !== 'sold_out' && status !== 'cancelled' && status !== 'draft' && status !== 'completed') status = 'active';
    var displayStatus = String(ev.display_status || ev.displayStatus || status)
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');

    var gid = ev.event_metaobject_gid || ev.gid || ev.metaobject_gid || ev.id || ev.event_id || ev.canonical_event_id || '';

    var dateKey = toIsoDateKey(ev.date_key);
    if (!dateKey && ev.schema_start) dateKey = toIsoDateKey(ev.schema_start);
    if (!dateKey && ev.starts_at) dateKey = toIsoDateKey(ev.starts_at);

    var timeLabel = String(ev.time_label || '').trim();
    var displayLabel = String(ev.display_label || '').trim();
    if (!displayLabel) {
      displayLabel = dateKey || '';
      if (timeLabel) displayLabel = displayLabel ? displayLabel + ' | ' + timeLabel : timeLabel;
    }

    var capTot =
      ev.capacity_total != null && ev.capacity_total !== '' ? Number(ev.capacity_total) : null;
    if (!(capTot != null && Number.isFinite(capTot) && capTot > 0)) capTot = null;

    return {
      gid: gid,
      handle: String(ev.handle || ev.system_handle || ev.event_handle || ''),
      canonical_event_id:
        ev.canonical_event_id ||
        ev.event_id ||
        ev.event_metaobject_gid ||
        ev.id ||
        gid ||
        '',
      capacity_group_id: ev.capacity_group_id || ev.capacityGroupId || '',
      status: status,
      display_status: displayStatus,
      capacity_remaining: ev.capacity_remaining != null ? ev.capacity_remaining : ev.capacity,
      capacity_total: capTot,
      variant_id: ev.variant_id != null ? ev.variant_id : ev.variantId,
      schema_start: ev.schema_start || ev.starts_at || '',
      schema_end: ev.schema_end || ev.ends_at || '',
      date_key: dateKey,
      time_label: timeLabel,
      display_label: displayLabel,
      _raw: ev,
    };
  }

  function eventsToSlots(events) {
    var out = [];
    (events || []).forEach(function (ev) {
      var s = normalizeEventToSlot(ev);
      if (s && s.date_key) out.push(s);
    });
    return out;
  }

  function buildDaysMap(slots) {
    slots = (slots || []).filter(slotVisible);
    if (Flow && Flow.buildDaysMap) return Flow.buildDaysMap(slots, false);
    var map = {};
    slots.forEach(function (s) {
      var dk = slotDateKey(s);
      if (!dk) return;
      if (!map[dk]) map[dk] = { bookable: false, any: true };
      if (slotBookable(s)) map[dk].bookable = true;
    });
    return map;
  }

  function wizardViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function calendarDowLabels() {
    return wizardViewportWidth() < 750 ? DOW_SHORT : DOW_PICKER;
  }

  function calDateKey(y, m, d) {
    return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  function formatBookingSubLabel(slot) {
    if (!slot) return '';
    var dk = slot.date_key || '';
    var tl = String(slot.time_label || '').trim();
    if (dk && tl) return dk + ' | ' + tl;
    return dk || tl || '';
  }

  /** Permanent stores for this shop: Carrollton, Dallas, Orlando. All others are popup. */
  function isStoreVenue(venue) {
    if (!venue || typeof venue !== 'object') return false;
    var parts = [
      venue.venue_name,
      venue.name,
      venue.city_name,
      venue.city,
      venue.venue_handle,
      venue.handle,
      venue.city_key,
    ];
    for (var i = 0; i < parts.length; i++) {
      var s = String(parts[i] || '')
        .trim()
        .toLowerCase();
      if (!s) continue;
      if (s === 'dallas' || s === 'carrollton' || s === 'orlando') return true;
      /* city_key: us-tx-dallas / us-fl-orlando; names: "Orlando, FL" */
      if (/(^|-)(dallas|carrollton|orlando)$/.test(s)) return true;
      if (/\b(dallas|carrollton|orlando)\b/.test(s)) return true;
    }
    return false;
  }

  function formatPopupDateLabel(dateKey) {
    var dk = String(dateKey || '').slice(0, 10);
    var p = dk.split('-').map(Number);
    if (p.length < 3 || !p[0]) return dk;
    var d = new Date(p[0], p[1] - 1, p[2]);
    if (isNaN(d.getTime())) return dk;
    try {
      return d.toLocaleDateString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    } catch (_) {
      return dk;
    }
  }

  function vQtyKey(id) {
    return String(id == null ? '' : id).trim();
  }

  function normalizeOptionValue(val) {
    return String(val || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function styleValueFromVariant(v, styleIdx) {
    if (!v) return '';
    if (styleIdx === 0) return v.option1 || '';
    if (styleIdx === 1) return v.option2 || '';
    return v.option3 || '';
  }

  function getSectionRoot(wizardRoot, data) {
    var sid = (data && data.sectionId) || (wizardRoot && wizardRoot.getAttribute('data-section-id')) || '';
    var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
    if (!sectionRoot && wizardRoot && wizardRoot.closest) {
      sectionRoot = wizardRoot.closest('[id^="shopify-section-"]');
    }
    return sectionRoot;
  }

  function isSessionOptionHandle(handle) {
    var h = String(handle || '').toLowerCase();
    return (
      h.indexOf('date') !== -1 ||
      h.indexOf('time') !== -1 ||
      h.indexOf('session') !== -1 ||
      h.indexOf('event') !== -1
    );
  }

  function parseVariantsJson(sectionRoot) {
    if (!sectionRoot) return [];
    var el = sectionRoot.querySelector('[data-variant-json]');
    if (!el || !el.textContent) return [];
    try {
      var list = JSON.parse(el.textContent);
      return Array.isArray(list) ? list : [];
    } catch (_) {
      return [];
    }
  }

  function ensureVariantMediaMeta(variant, sectionRoot, styleIdx) {
    if (!variant) return variant;
    if (variant.featured_media_id) return variant;
    var shopifyVariant = findShopifyVariantByWizard(
      sectionRoot,
      variant,
      styleIdx != null ? styleIdx : 0
    );
    if (shopifyVariant && shopifyVariant.featured_media && shopifyVariant.featured_media.id != null) {
      variant.featured_media_id = shopifyVariant.featured_media.id;
    }
    return variant;
  }

  function findShopifyVariantByWizard(sectionRoot, wizardVariant, styleIdx) {
    if (!sectionRoot || !wizardVariant) return null;
    var list = parseVariantsJson(sectionRoot);
    if (!list.length) return null;
    var idx = styleIdx != null ? Number(styleIdx) : 0;
    var styleVal = normalizeOptionValue(
      styleValueFromVariant(wizardVariant, idx) || wizardVariant.label || ''
    );
    var optKey = 'option' + (idx + 1);
    var i;
    for (i = 0; i < list.length; i++) {
      if (normalizeOptionValue(list[i][optKey]) === styleVal) return list[i];
    }
    for (i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(wizardVariant.id)) return list[i];
    }
    return null;
  }

  function findStyleFieldset(sectionRoot, styleIdx) {
    if (!sectionRoot) return null;
    var wraps = sectionRoot.querySelectorAll('.variant-input-wrap[data-handle]');
    var nonSession = [];
    var styleWrap = null;
    var i;
    for (i = 0; i < wraps.length; i++) {
      var handle = wraps[i].getAttribute('data-handle') || '';
      if (isSessionOptionHandle(handle)) continue;
      nonSession.push(wraps[i]);
      var idxAttr = wraps[i].getAttribute('data-index') || '';
      var num = parseInt(String(idxAttr).replace(/\D/g, ''), 10) - 1;
      if (num === styleIdx) styleWrap = wraps[i];
    }
    if (!styleWrap && nonSession.length) {
      styleWrap = nonSession[styleIdx] || nonSession[0];
    }
    return styleWrap;
  }

  function getProductContainer(sectionRoot, sectionId) {
    if (!sectionRoot) return null;
    if (sectionId) {
      var byId = sectionRoot.querySelector('#ProductSection-' + sectionId);
      if (byId) return byId;
    }
    return (
      sectionRoot.querySelector('[data-section-type="product"]') ||
      sectionRoot.querySelector('.product-section') ||
      sectionRoot
    );
  }

  function goToImpulseVariantMedia(sectionRoot, shopifyVariant) {
    if (!sectionRoot || !shopifyVariant) return false;
    var mediaId =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.id) ||
      shopifyVariant.featured_media_id;
    if (!mediaId && shopifyVariant.featured_image && shopifyVariant.featured_image.id) {
      mediaId = shopifyVariant.featured_image.id;
    }
    if (!mediaId) return false;
    mediaId = String(mediaId);

    var sectionIdMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
    var sectionId = sectionIdMatch ? sectionIdMatch[1] : '';
    if (!sectionId) {
      var mediaHost = sectionRoot.querySelector('[id^="x-product-"]');
      if (mediaHost && mediaHost.id) sectionId = String(mediaHost.id).replace(/^x-product-/, '');
    }
    if (!sectionId) return false;

    /* Media id is numeric — querySelector('.123-section') throws; match Impulse (getElementsByClassName). */
    var mediaClass = mediaId + '-' + sectionId;
    var slide = null;
    var byClass = sectionRoot.getElementsByClassName(mediaClass);
    /*
     * Theme liquid duplicates selected variant featured at the START of the list.
     * Prefer the last match so we land on the natural gallery position, not the clone.
     */
    if (byClass && byClass.length) slide = byClass[byClass.length - 1];
    if (!slide) {
      var slides = sectionRoot.querySelectorAll(
        '#media_product-' +
          sectionId +
          ' [data-media-id="' +
          sectionId +
          '-' +
          mediaId +
          '"], [data-media-id="' +
          sectionId +
          '-' +
          mediaId +
          '"].splide__slide'
      );
      if (slides && slides.length) slide = slides[slides.length - 1];
    }

    var slider = document.getElementById('x-product-' + sectionId);
    if (slider && slider.splide && slide) {
      var indexAttr = slide.getAttribute('index');
      var index = Number(indexAttr);
      if (!Number.isFinite(index) && slide.getAttribute('x-slide-index') != null) {
        index = Number(slide.getAttribute('x-slide-index')) - 1;
      }
      if (Number.isFinite(index)) {
        try {
          slider.splide.go(index);
        } catch (_) {}
        return true;
      }
    }

    /* Do not thumb.click() — Impulse handlers prepend/reorder media. */
    var stacked = document.getElementById('postion-image-' + sectionId + '-' + mediaId);
    if (stacked && typeof stacked.scrollIntoView === 'function') {
      stacked.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return true;
    }

    return false;
  }

  function parseZoomThumbMediaId(el, sectionId) {
    if (!el) return '';
    var sid = String(sectionId || '');
    var idAttr = String(el.id || '');
    var prefix = 'x-zoom-thumbnail-' + sid + '-';
    if (sid && idAttr.indexOf(prefix) === 0) return idAttr.slice(prefix.length);
    var p2 = 'x-thumbnail-' + sid + '-';
    if (sid && idAttr.indexOf(p2) === 0) return idAttr.slice(p2.length);
    var dm = String(el.getAttribute('data-media-id') || '');
    if (dm) {
      var mZoom = dm.match(/^zoom-(\d+)$/);
      if (mZoom) return mZoom[1];
      if (sid) {
        var pref = 'zoom-' + sid + '-';
        if (dm.indexOf(pref) === 0) return dm.slice(pref.length);
        var pref2 = sid + '-';
        if (dm.indexOf(pref2) === 0) return dm.slice(pref2.length);
      }
      var mTail = dm.match(/(\d+)$/);
      if (mTail) return mTail[1];
    }
    if (sid && el.className) {
      var classMatch = String(el.className).match(new RegExp('(?:^|\\s)(\\d+)-' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:\\s|$)'));
      if (classMatch) return classMatch[1];
    }
    return '';
  }

  function parseZoomSlideMediaId(slideEl, sectionId) {
    if (!slideEl) return '';
    var direct = parseZoomThumbMediaId(slideEl, sectionId);
    if (direct) return direct;
    var tagged = slideEl.querySelector('[data-media-id]');
    if (tagged) {
      var fromTagged = parseZoomThumbMediaId(tagged, sectionId);
      if (fromTagged) return fromTagged;
    }
    var host = slideEl.closest && slideEl.closest('[id$="-image-zoom-' + sectionId + '"]');
    if (host) {
      var inner = host.querySelector('[data-media-id]');
      if (inner) {
        var fromHost = parseZoomThumbMediaId(inner, sectionId);
        if (fromHost) return fromHost;
      }
    }
    return '';
  }

  /** Move zoom modal gallery only — never touch main PDP order. */
  function goToZoomGalleryByMediaId(sectionId, mediaId) {
    if (!sectionId || !mediaId) return false;
    mediaId = String(mediaId);
    var gallery = document.getElementById('media-gallery-' + sectionId);
    if (!gallery || !gallery.splide) return false;
    var thumbsRoot = document.getElementById('x-zoom-thumbnail-' + sectionId);
    var thumbs = thumbsRoot ? thumbsRoot.getElementsByClassName('x-thumbnail') : [];
    var first = -1;
    var last = -1;
    var i;
    for (i = 0; i < thumbs.length; i++) {
      if (parseZoomThumbMediaId(thumbs[i], sectionId) === mediaId) {
        if (first < 0) first = i;
        last = i;
      }
    }
    if (first < 0) return false;
    /* Skip liquid clone at index 0 when the same media also exists later. */
    var idx = first === 0 && last > 0 ? last : first;
    try {
      gallery.splide.go(idx);
      return true;
    } catch (_) {
      return false;
    }
  }

  function findImpulseMediaSlide(sectionRoot, mediaId) {
    if (!sectionRoot || !mediaId) return null;
    mediaId = String(mediaId);
    var sectionIdMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
    var sectionId = sectionIdMatch ? sectionIdMatch[1] : '';
    if (!sectionId) {
      var mediaHost = sectionRoot.querySelector('[id^="x-product-"]');
      if (mediaHost && mediaHost.id) sectionId = String(mediaHost.id).replace(/^x-product-/, '');
    }
    if (!sectionId) return null;
    var byClass = sectionRoot.getElementsByClassName(mediaId + '-' + sectionId);
    if (byClass && byClass.length) return byClass[byClass.length - 1];
    var nodes = sectionRoot.querySelectorAll(
      '#media_product-' +
        sectionId +
        ' [data-media-id="' +
        sectionId +
        '-' +
        mediaId +
        '"], [data-media-id="' +
        sectionId +
        '-' +
        mediaId +
        '"].splide__slide'
    );
    if (nodes && nodes.length) return nodes[nodes.length - 1];
    return null;
  }

  function resolveImpulseMediaZoomPosition(sectionId, mediaId) {
    if (!sectionId || !mediaId) return null;
    mediaId = String(mediaId);
    var modal = document.getElementById('ProductModal-' + sectionId);
    if (modal) {
      var scoped =
        modal.querySelector('[data-media-id="zoom-' + mediaId + '"]') ||
        modal.querySelector('[data-media-id="zoom-' + sectionId + '-' + mediaId + '"]');
      var host = scoped
        ? scoped.closest('[id$="-image-zoom-' + sectionId + '"]') || scoped
        : null;
      if (host && host.id) {
        var fromHost = String(host.id).match(/^(\d+)-image-zoom-/);
        if (fromHost) return fromHost[1];
      }
      var zoomNodes = modal.querySelectorAll('[id$="-image-zoom-' + sectionId + '"]');
      for (var zi = 0; zi < zoomNodes.length; zi++) {
        var zn = zoomNodes[zi];
        if (
          zn.querySelector('[data-media-id*="' + mediaId + '"]') ||
          (zn.className && String(zn.className).indexOf(mediaId) !== -1)
        ) {
          var fromZn = String(zn.id).match(/^(\d+)-image-zoom-/);
          if (fromZn) return fromZn[1];
        }
      }
    }
    var slide = null;
    var byClass = document.getElementsByClassName(mediaId + '-' + sectionId);
    if (byClass && byClass.length) slide = byClass[0];
    if (!slide) {
      slide = document.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]');
    }
    if (slide) {
      var xsi = slide.getAttribute('x-slide-index');
      if (xsi != null && String(xsi).trim() !== '') return String(xsi);
      var idxAttr = slide.getAttribute('index');
      if (idxAttr != null && Number.isFinite(Number(idxAttr))) return String(Number(idxAttr) + 1);
    }
    return null;
  }

  function raiseImpulseProductModal(sectionId) {
    var modal = document.getElementById('ProductModal-' + sectionId);
    if (!modal) return null;
    modal.style.setProperty('z-index', '2147483646', 'important');
    return modal;
  }

  function openImpulseProductZoom(sectionRoot, shopifyVariant) {
    if (!sectionRoot || !shopifyVariant || !window.Alpine) return false;
    var mediaId =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.id) ||
      shopifyVariant.featured_media_id;
    if (!mediaId && shopifyVariant.featured_image && shopifyVariant.featured_image.id) {
      mediaId = shopifyVariant.featured_image.id;
    }
    if (!mediaId) return false;
    mediaId = String(mediaId);

    var sectionIdMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
    var sectionId = sectionIdMatch ? sectionIdMatch[1] : '';
    if (!sectionId) {
      var mediaHostProbe = sectionRoot.querySelector('[id^="product-media-"]');
      if (mediaHostProbe && mediaHostProbe.id) {
        sectionId = String(mediaHostProbe.id).replace(/^product-media-/, '');
      }
    }
    if (!sectionId) return false;

    if (!document.getElementById('ProductModal-' + sectionId)) return false;

    var mediaHost = document.getElementById('product-media-' + sectionId);
    if (!mediaHost) return false;
    var alpine = null;
    try {
      alpine = window.Alpine.$data(mediaHost);
    } catch (_) {
      alpine = null;
    }
    if (!alpine || typeof alpine.zoomOpen !== 'function') return false;

    /* Do not move/reorder main PDP gallery on zoom open. */
    var slide = findImpulseMediaSlide(sectionRoot, mediaId);
    var zoomBtn = slide && slide.querySelector('button[aria-label="Image zoom"]');
    var modal = raiseImpulseProductModal(sectionId);
    var isSplide = !!(modal && modal.querySelector('[id^="media-gallery-"]'));
    var position =
      (shopifyVariant.featured_media && shopifyVariant.featured_media.position) ||
      resolveImpulseMediaZoomPosition(sectionId, mediaId);

    function landOnZoomMedia() {
      goToZoomGalleryByMediaId(sectionId, mediaId);
    }

    function invoke() {
      raiseImpulseProductModal(sectionId);
      var openedOk = false;
      if (position == null) {
        position = resolveImpulseMediaZoomPosition(sectionId, mediaId);
      }
      if (position != null) {
        try {
          alpine.zoomOpen(String(position), isSplide);
          openedOk = true;
        } catch (_) {}
      }
      if (!openedOk && zoomBtn) {
        try {
          zoomBtn.click();
          openedOk = !!alpine.zoomIsOpen;
        } catch (_) {}
      }
      if (openedOk) {
        landOnZoomMedia();
        window.setTimeout(landOnZoomMedia, 80);
        window.setTimeout(landOnZoomMedia, 220);
      }
      return openedOk;
    }

    var opened = invoke();
    if (!opened) {
      window.setTimeout(invoke, 120);
      window.setTimeout(invoke, 280);
    }
    return true;
  }

  function closeImpulseProductZoom(sectionId) {
    if (!sectionId || !window.Alpine) return false;
    var mediaHost = document.getElementById('product-media-' + sectionId);
    if (!mediaHost) return false;
    var alpine = null;
    try {
      alpine = window.Alpine.$data(mediaHost);
    } catch (_) {
      alpine = null;
    }
    if (!alpine || typeof alpine.zoomClose !== 'function') return false;
    try {
      alpine.zoomClose();
      return true;
    } catch (_) {
      return false;
    }
  }

  function openWizardVariantImageFallback(imgUrl) {
    if (!imgUrl) return false;
    var existing = document.querySelector('[data-wbw-image-zoom]');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.className = 'wbw-image-zoom';
    overlay.setAttribute('data-wbw-image-zoom', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image zoom');
    overlay.innerHTML =
      '<button type="button" class="wbw-image-zoom__close" aria-label="Close">&times;</button>' +
      '<img class="wbw-image-zoom__img" src="' +
      escapeHtml(imgUrl) +
      '" alt="">';
    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
      document.dispatchEvent(new CustomEvent('wbw:image-zoom-closed'));
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.wbw-image-zoom__close')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(overlay);
    return true;
  }

  function syncImpulseStyleOption(sectionRoot, styleIdx, styleVal) {
    if (!sectionRoot || !styleVal) return false;
    var fieldset = findStyleFieldset(sectionRoot, styleIdx);
    if (!fieldset) return false;
    var want = normalizeOptionValue(styleVal);
    var inputs = fieldset.querySelectorAll('[data-variant-input]');
    var target = null;
    inputs.forEach(function (input) {
      if (normalizeOptionValue(input.value) === want) target = input;
    });
    if (!target) return false;
    inputs.forEach(function (input) {
      input.checked = input === target;
    });
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function syncImpulseOptionsByVariant(sectionRoot, shopifyVariant, options) {
    if (!sectionRoot || !shopifyVariant) return false;
    var fireChange = !!(options && options.fireChange);
    var optKeys = ['option1', 'option2', 'option3'];
    var fired = false;
    var lastChecked = null;
    for (var oi = 0; oi < optKeys.length; oi++) {
      var ok = optKeys[oi];
      var oval = shopifyVariant[ok];
      if (oval == null || String(oval).trim() === '') continue;
      var radios = sectionRoot.querySelectorAll(
        'input[type="radio"][data-variant-input][data-index="' + ok + '"]'
      );
      if (!radios || !radios.length) continue;
      radios.forEach(function (inp) {
        var isMatch = String(inp.value) === String(oval);
        inp.checked = isMatch;
        if (isMatch) lastChecked = inp;
      });
    }
    /* Firing change makes Impulse prepend/reorder gallery media — keep off unless asked. */
    if (fireChange && lastChecked) {
      lastChecked.dispatchEvent(new Event('change', { bubbles: true }));
      fired = true;
    }
    return fired;
  }

  function syncImpulseMasterVariantId(sectionRoot, shopifyVariant, options) {
    if (!sectionRoot || !shopifyVariant || shopifyVariant.id == null) return false;
    var fireChange = !!(options && options.fireChange);
    var vid = String(shopifyVariant.id);
    var changed = false;
    sectionRoot
      .querySelectorAll(
        'form[id*="product-form-"] input[name="id"], form[id*="product-form-"] select[name="id"]'
      )
      .forEach(function (el) {
        if (!el) return;
        if (String(el.value) !== vid) {
          el.value = vid;
          changed = true;
        }
        if (fireChange) {
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    var masterSelect = sectionRoot.querySelector(
      'select[data-product-select], form.product-single__form select[name="id"]'
    );
    if (masterSelect && String(masterSelect.value) !== vid) {
      masterSelect.value = vid;
      changed = true;
      if (fireChange) {
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    return changed;
  }

  function syncVariantToPdp(wizardRoot, data, variant, options) {
    if (!variant) return;
    var opts = options || {};
    /* Default false: Impulse change handlers prepend selected media and scramble gallery order. */
    var fireOptionChange = opts.fireOptionChange === true;
    var sectionRoot = getSectionRoot(wizardRoot, data);
    if (!sectionRoot) return;
    var sectionId = (data && data.sectionId) || wizardRoot.getAttribute('data-section-id') || '';
    var styleIdx =
      data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
    var styleVal =
      styleValueFromVariant(variant, styleIdx) || variant.label || '';
    var productEl = getProductContainer(sectionRoot, sectionId);
    var shopifyVariant = findShopifyVariantByWizard(sectionRoot, variant, styleIdx);

    var firedVariantInputs = false;
    if (shopifyVariant) {
      firedVariantInputs = syncImpulseOptionsByVariant(sectionRoot, shopifyVariant, {
        fireChange: fireOptionChange,
      });
      syncImpulseMasterVariantId(sectionRoot, shopifyVariant, {
        fireChange: fireOptionChange,
      });
    } else if (productEl && styleVal && fireOptionChange) {
      firedVariantInputs = syncImpulseStyleOption(productEl, styleIdx, styleVal);
    }

    variant = ensureVariantMediaMeta(variant, sectionRoot, styleIdx);
    var mediaTarget = shopifyVariant || {
      featured_media: variant.featured_media_id ? { id: variant.featured_media_id } : null,
      featured_media_id: variant.featured_media_id,
      featured_image: variant.image_url ? { src: variant.image_url } : null,
      id: variant.id,
    };
    if (mediaTarget && (mediaTarget.featured_media || mediaTarget.featured_media_id)) {
      goToImpulseVariantMedia(sectionRoot, mediaTarget);
      window.setTimeout(function () {
        goToImpulseVariantMedia(sectionRoot, mediaTarget);
      }, 120);
      if (!firedVariantInputs) {
        window.setTimeout(function () {
          goToImpulseVariantMedia(sectionRoot, mediaTarget);
        }, 260);
      }
    }
  }

  var timeDdPortalEl = null;

  function cleanupOrphanTimeDdPanels() {
    document.querySelectorAll('[data-wbw-time-dd-portal]').forEach(function (el) {
      el.remove();
    });
    timeDdPortalEl = null;
  }

  function ensureTimeDdPortal() {
    if (!timeDdPortalEl || !timeDdPortalEl.parentNode) {
      timeDdPortalEl = document.createElement('div');
      timeDdPortalEl.className = 'wbw-time-dd-portal';
      timeDdPortalEl.setAttribute('data-wbw-time-dd-portal', '');
      document.body.appendChild(timeDdPortalEl);
    }
    return timeDdPortalEl;
  }

  function getCalTimeDdParts(root) {
    var dd = root.querySelector('[data-wbw-cal-time-dd]');
    if (!dd) return null;
    var btn = dd.querySelector('[data-wbw-cal-time-dd-btn]');
    var panel = dd.querySelector('[data-wbw-cal-time-dd-panel]');
    if (!panel && timeDdPortalEl) {
      panel = timeDdPortalEl.querySelector('[data-wbw-cal-time-dd-panel]');
    }
    if (!panel) {
      var portal = document.querySelector('[data-wbw-time-dd-portal]');
      if (portal) panel = portal.querySelector('[data-wbw-cal-time-dd-panel]');
    }
    return { dd: dd, btn: btn, panel: panel };
  }

  function positionTimeDdPanel(parts) {
    if (!parts || !parts.panel || !parts.btn) return;
    var rect = parts.btn.getBoundingClientRect();
    var panel = parts.panel;
    var gap = 6;
    var maxH = 240;
    var spaceBelow = window.innerHeight - rect.bottom - gap;
    var spaceAbove = rect.top - gap;
    var openUp = spaceBelow < 120 && spaceAbove > spaceBelow;
    var avail = openUp ? spaceAbove : spaceBelow;
    panel.style.position = 'fixed';
    panel.style.left = rect.left + 'px';
    panel.style.width = Math.max(rect.width, 200) + 'px';
    panel.style.right = 'auto';
    panel.style.margin = '0';
    panel.style.zIndex = '2147483005';
    panel.style.maxHeight = Math.min(maxH, Math.max(80, avail - 8)) + 'px';
    if (openUp) {
      panel.style.top = 'auto';
      panel.style.bottom = window.innerHeight - rect.top + gap + 'px';
    } else {
      panel.style.bottom = 'auto';
      panel.style.top = rect.bottom + gap + 'px';
    }
  }

  function resetTimeDdPanelStyle(panel) {
    if (!panel) return;
    panel.style.position = '';
    panel.style.top = '';
    panel.style.bottom = '';
    panel.style.left = '';
    panel.style.width = '';
    panel.style.right = '';
    panel.style.maxHeight = '';
    panel.style.zIndex = '';
    panel.style.margin = '';
  }

  function bindTimeDdReposition(wizardRoot) {
    if (wizardRoot.__wbwTimeDdReflowBound) return;
    wizardRoot.__wbwTimeDdReflowBound = true;
    function onReflow() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || !parts.dd.classList.contains('is-open')) return;
      if (parts.panel && !parts.panel.hidden) positionTimeDdPanel(parts);
    }
    window.addEventListener('resize', onReflow, { passive: true });
    window.addEventListener('scroll', onReflow, { passive: true, capture: true });
  }

  function wbwEmitVenueReset(bookingRoot) {
    try {
      document.dispatchEvent(
        new CustomEvent('wbw:venue-reset', { detail: { bookingRoot: bookingRoot || null } })
      );
    } catch (_) {}
  }

  function bindWizardSearchLayout(bookingRoot) {
    if (!bookingRoot || bookingRoot.__wbwSearchLayoutBound) return;
    bookingRoot.__wbwSearchLayoutBound = true;

    function injectPlaceShadowStyles(place) {
      if (!place || !place.shadowRoot) return;
      var styleId = 'wbw-place-autocomplete-styles';
      if (place.shadowRoot.getElementById(styleId)) return;
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        ':host {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '  display: block !important;',
        '  width: 100% !important;',
        '}',
        'svg, [part="leading-icon"], [class*="leading-icon"], [class*="prefix-icon"], slot[name="icon"], [slot="input-icon"] {',
        '  display: none !important;',
        '  width: 0 !important;',
        '  height: 0 !important;',
        '  opacity: 0 !important;',
        '  pointer-events: none !important;',
        '}',
        'input, input:focus, input:focus-visible {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '  appearance: none !important;',
        '  -webkit-appearance: none !important;',
        '}',
        'div, form, [class*="container"], [class*="wrapper"], [class*="input"], [class*="field"] {',
        '  border: none !important;',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '  background: transparent !important;',
        '}',
        '*:focus, *:focus-within, *:focus-visible {',
        '  outline: none !important;',
        '  box-shadow: none !important;',
        '}'
      ].join('\n');
      place.shadowRoot.appendChild(style);
    }

    function styleGooglePlaceField(place) {
      if (!place) return;
      try {
        place.setAttribute('no-input-icon', '');
        place.noInputIcon = true;
      } catch (_) {}
      try {
        place.style.setProperty('color-scheme', 'light');
        place.style.setProperty('border', 'none');
        place.style.setProperty('border-radius', '0');
        place.style.setProperty('--gmp-mat-color-surface', 'transparent');
        place.style.setProperty('--gmp-mat-color-on-surface', '#111827');
        place.style.setProperty('--gmp-mat-color-on-surface-variant', '#6b7280');
        place.style.setProperty('outline', 'none');
        place.style.setProperty('box-shadow', 'none');
        place.style.setProperty('background', 'transparent');
        place.style.setProperty('background-color', 'transparent');
      } catch (_) {}
      injectPlaceShadowStyles(place);
      try {
        if (place.shadowRoot) {
          place.shadowRoot.querySelectorAll('label, [class*="label"]').forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
          });
          place.shadowRoot.querySelectorAll('svg, [part="leading-icon"], [class*="leading-icon"], [class*="prefix-icon"], [slot="input-icon"]').forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('width', '0', 'important');
            el.style.setProperty('height', '0', 'important');
            el.style.setProperty('opacity', '0', 'important');
          });
          place.shadowRoot.querySelectorAll('*').forEach(function (el) {
            try {
              el.style.setProperty('border', 'none', 'important');
              el.style.setProperty('outline', 'none', 'important');
              el.style.setProperty('box-shadow', 'none', 'important');
            } catch (_) {}
          });
        }
        var inner = place.shadowRoot && place.shadowRoot.querySelector('input');
        if (inner) {
          inner.style.setProperty('width', '100%');
          inner.style.setProperty('min-height', '52px');
          inner.style.setProperty('height', '52px');
          inner.style.setProperty('box-sizing', 'border-box');
          inner.style.setProperty('padding-left', '0');
          inner.style.setProperty('padding-right', '0');
          inner.style.setProperty('border', 'none');
          inner.style.setProperty('outline', 'none');
          inner.style.setProperty('background', 'transparent');
          inner.style.setProperty('box-shadow', 'none');
          inner.style.setProperty('font-size', '15px');
          inner.style.setProperty('line-height', '52px');
          if (!inner.getAttribute('placeholder')) {
            inner.setAttribute('placeholder', 'Find your venue');
          }
        }
      } catch (_) {}
    }

    function bindSearchTrigger(wrap) {
      if (!wrap) return;
      var btn = wrap.querySelector('[data-workshop-search-default]');
      if (!btn || btn.__wbwSearchTriggerBound) return;
      btn.__wbwSearchTriggerBound = true;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (typeof bookingRoot.__wbTriggerDefaultPrefetch === 'function') {
          bookingRoot.__wbTriggerDefaultPrefetch({ force: true });
          return;
        }
        try {
          bookingRoot.dispatchEvent(new CustomEvent('wbw:search-default', { bubbles: true }));
        } catch (_) {}
      });
    }

    function apply() {
      var panel = bookingRoot.querySelector('.wb-search-panel');
      var wrap = bookingRoot.querySelector('.wb-search-input-wrap');
      if (!wrap) return;
      var anchor = panel || wrap;
      var rect = anchor.getBoundingClientRect();
      var w = rect.width || wrap.getBoundingClientRect().width;

      var place = wrap.querySelector('gmp-place-autocomplete,[data-workshop-place-autocomplete],.wbw-search-place-host');
      var nativeInput = wrap.querySelector('#workshop-location-input');

      if (place) {
        wrap.classList.add('wbw-search-has-place');
        styleGooglePlaceField(place);
        if (nativeInput) nativeInput.classList.add('wbw-search-native-hidden');
      } else {
        wrap.classList.remove('wbw-search-has-place');
        if (nativeInput) nativeInput.classList.remove('wbw-search-native-hidden');
      }

      if (w) {
        try {
          document.querySelectorAll('.pac-container').forEach(function (pac) {
            pac.style.width = w + 'px';
            pac.style.minWidth = w + 'px';
            pac.style.maxWidth = w + 'px';
            if (rect.left) pac.style.left = rect.left + window.scrollX + 'px';
          });
        } catch (_) {}
      }

      bindSearchTrigger(wrap);
    }

    bookingRoot.addEventListener('wbw:places-mounted', apply);
    apply();
    window.addEventListener('resize', apply, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var wrap = bookingRoot.querySelector('.wb-search-input-wrap');
      if (wrap) {
        var ro = new ResizeObserver(apply);
        ro.observe(wrap);
        bookingRoot.__wbwSearchRo = ro;
      }
    }
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        apply();
      });
      mo.observe(bookingRoot, { childList: true, subtree: true });
      bookingRoot.__wbwSearchMo = mo;
    }
    window.setTimeout(apply, 400);
    window.setTimeout(apply, 1200);
    window.setTimeout(apply, 2500);
    window.setTimeout(apply, 5000);
  }

  function venueHasBookableEvents(venue) {
    var evs = venue && Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      var s = normalizeEventToSlot(evs[i]);
      if (s && s.date_key && slotBookable(s)) return true;
    }
    return false;
  }

  function venueHasVisibleEvents(venue) {
    if (!venue) return false;
    if (venue._wbWaitlistVenue === true) return false;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      var s = normalizeEventToSlot(evs[i]);
      if (s && s.date_key && slotVisible(s)) return true;
    }
    return false;
  }

  function venueIsWaitlistOnly(venue, card) {
    if (card && card.getAttribute('data-wb-waitlist-venue') === '1') return true;
    if (venue && venue._wbWaitlistVenue === true) return true;
    if (venue && venue.has_events === false) return true;
    if (venue && venue.has_events === true) return false;
    return true;
  }

  function variantCardLayout(root) {
    var layout = root && root.getAttribute('data-wbw-variant-layout');
    return layout === 'horizontal' ? 'horizontal' : 'stacked';
  }

  function wbwAddonDisplayTitle(root) {
    var t = (root && root.getAttribute('data-addon-title')) || 'Turkish Coffee';
    t = String(t).trim();
    t = t.replace(/^traditional\s+/i, '').trim();
    return t || 'Turkish Coffee';
  }

  function isMobileViewport() {
    return wizardViewportWidth() < 750;
  }

  function isDesktopViewport() {
    return wizardViewportWidth() >= 990;
  }

  function variantGridColsCap(root, count, width) {
    var useDesktop = wizardViewportWidth() >= 990;
    var inWizard =
      root &&
      root.getAttribute &&
      root.getAttribute('data-workshop-booking-wizard') != null;
    if (inWizard && isMobileViewport()) return Math.min(count, 2);
    var raw = root.getAttribute(useDesktop ? 'data-wbw-cols-desktop' : 'data-wbw-cols-mobile');
    var n = parseInt(String(raw), 10);
    var cap = useDesktop ? 4 : 3;
    if (Number.isFinite(n) && n >= 2) cap = Math.min(5, n);
    if (!useDesktop && width > 0 && width < 300) cap = Math.min(cap, 3);
    return Math.min(count, cap);
  }

  function pickStackedGridColumns(count, width, height, gap, root) {
    var cap = variantGridColsCap(root, count, width);
    var minColPx = wizardViewportWidth() >= 990 ? 72 : 64;
    while (cap > 2 && width > 0 && cap * minColPx > width + 6) cap -= 1;
    return Math.max(1, cap);
  }

  function variantGridGapPx() {
    if (isDesktopViewport()) return 2;
    return 4;
  }

  function stackedThumbPx(cols, width, height, count, gap, wizardRoot) {
    var mobile = isMobileViewport();
    var desktop = isDesktopViewport();
    var rows = Math.ceil(count / cols);
    var g = gap >= 0 ? gap : variantGridGapPx();
    var colW = width > 0 ? (width - g * Math.max(0, cols - 1)) / cols : 100;
    var inWizard =
      wizardRoot &&
      wizardRoot.getAttribute &&
      wizardRoot.getAttribute('data-workshop-booking-wizard') != null;
    var qtyReserve = inWizard ? 0 : desktop ? 28 : 26;
    var innerPad = desktop ? 10 : 12;
    var cardW = Math.max(44, colW - qtyReserve);
    var thumbByW;
    if (desktop) {
      thumbByW = Math.max(44, Math.min(104, Math.floor(cardW - innerPad)));
      if (inWizard) thumbByW = Math.min(thumbByW, 112);
    } else {
      var maxThumb = inWizard && mobile ? 86 : mobile ? 56 : 64;
      var minThumb = cols >= 4 ? 32 : 36;
      thumbByW = Math.max(minThumb, Math.min(maxThumb, Math.floor(colW - 30)));
      if (inWizard) thumbByW = Math.min(thumbByW, mobile ? 86 : 88);
    }
    if (height <= 0 || rows <= 0) return thumbByW;
    var rowBudget = Math.floor((height - Math.max(0, rows - 1) * g) / rows) - (desktop ? 32 : 34);
    var minThumb = desktop ? 44 : cols >= 4 ? 32 : 36;
    return Math.max(minThumb, Math.min(thumbByW, rowBudget));
  }

  function pickVariantGridColumns(count, containerWidth, containerHeight, layout) {
    if (count <= 0) return 1;
    if (count === 1) return 1;
    layout = layout === 'horizontal' ? 'horizontal' : 'stacked';
    var width = containerWidth || 0;
    var height = containerHeight || 0;
    var gap = VARIANT_GRID_GAP_PX;
    var bestCols = 1;
    var bestScore = -Infinity;
    var minColPx = VARIANT_ROW_MIN_PX;
    var maxCols = count;

    if (width > 0) {
      if (layout === 'horizontal' && width < 990) {
        maxCols = Math.min(count, isMobileViewport() ? 2 : 3);
        minColPx = 110;
      } else if (width >= 420 && count >= 6) {
        maxCols = Math.min(count, 4);
      }
    }

    for (var cols = maxCols; cols >= 1; cols--) {
      if (width > 0 && cols * minColPx > width) continue;
      var rows = Math.ceil(count / cols);
      var needH = rows * VARIANT_ROW_MIN_H_PX + Math.max(0, rows - 1) * gap;
      if (height > 0 && needH > height) continue;
      var lastRow = count % cols || cols;
      var fullness = lastRow / cols;
      var score = fullness * 400 + cols * 28 - rows * 18;
      if (width >= 420 && count >= 6 && cols >= 4) score += 120;
      if (height > 0) score += (height - needH) * 0.35;
      if (score > bestScore) {
        bestScore = score;
        bestCols = cols;
      }
    }
    return Math.max(1, bestCols);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function carouselSlideScrollLeft(wrap, row) {
    if (!wrap || !row) return 0;
    var maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
    var rows = wrap.querySelectorAll('.wcf-variant-row');
    var isLast = rows.length && rows[rows.length - 1] === row;
    if (isLast) {
      /* Last card flush right — previous peeks on the left. */
      return maxScroll;
    }
    /* Other cards: flush-left snap target — next peeks on the right. */
    return Math.max(0, Math.min(maxScroll, row.offsetLeft || 0));
  }

  function animateCarouselScrollLeft(el, toLeft, durationMs) {
    if (!el) return;
    var maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
    var to = Math.max(0, Math.min(maxScroll, toLeft));
    var from = el.scrollLeft || 0;
    var delta = to - from;
    if (Math.abs(delta) < 1) return;
    if (el.__wbwScrollAnim) {
      cancelAnimationFrame(el.__wbwScrollAnim);
      el.__wbwScrollAnim = 0;
    }
    var duration = durationMs || 420;
    el.style.scrollSnapType = 'none';
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      el.scrollLeft = from + delta * easeOutCubic(t);
      if (t < 1) {
        el.__wbwScrollAnim = requestAnimationFrame(frame);
        return;
      }
      el.__wbwScrollAnim = 0;
      el.scrollLeft = to;
      requestAnimationFrame(function () {
        el.style.scrollSnapType = '';
      });
    }
    el.__wbwScrollAnim = requestAnimationFrame(frame);
  }

  function syncVariantCarouselNav(wrap) {
    var carousel = wrap && wrap.closest('[data-wbw-variant-carousel]');
    if (!carousel) return;
    var prev = carousel.querySelector('[data-wbw-variant-prev]');
    var next = carousel.querySelector('[data-wbw-variant-next]');
    var rows = wrap.querySelectorAll('.wcf-variant-row');
    var show = rows.length > 1;
    if (prev) {
      prev.hidden = !show;
      if (!show) prev.disabled = true;
    }
    if (next) {
      next.hidden = !show;
      if (!show) next.disabled = true;
    }
    if (!show) return;

    function updateEdgeState() {
      var maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
      var left = wrap.scrollLeft || 0;
      var atStart = left <= 2;
      var atEnd = left >= maxScroll - 2;
      if (prev) {
        prev.disabled = atStart;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        next.disabled = atEnd;
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    function nearestSlideIndex() {
      var list = wrap.querySelectorAll('.wcf-variant-row');
      var left = wrap.scrollLeft || 0;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var dist = Math.abs(carouselSlideScrollLeft(wrap, list[i]) - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function slideBy(dir) {
      if (dir < 0 && prev && prev.disabled) return;
      if (dir > 0 && next && next.disabled) return;
      var list = wrap.querySelectorAll('.wcf-variant-row');
      if (!list.length) return;
      var idx = Math.max(0, Math.min(list.length - 1, nearestSlideIndex() + dir));
      var target = list[idx];
      if (!target) return;
      animateCarouselScrollLeft(wrap, carouselSlideScrollLeft(wrap, target), 440);
      window.setTimeout(updateEdgeState, 460);
    }

    updateEdgeState();

    if (!wrap.__wbwCarouselBound) {
      wrap.__wbwCarouselBound = true;
      wrap.addEventListener('scroll', updateEdgeState, { passive: true });
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          slideBy(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          slideBy(1);
        });
      }
    }
  }

  function applyVariantCarouselLayout(wrap, count) {
    if (!wrap || count < 1) return;
    wrap.classList.add('wcf-variants--carousel');
    wrap.classList.remove(
      'wcf-variants--fit',
      'wcf-variants--compact',
      'wcf-variants--layout-stacked',
      'wcf-variants--layout-horizontal'
    );
    wrap.style.removeProperty('--wcf-variant-cols');
    wrap.style.removeProperty('--wcf-variant-rows');
    wrap.style.removeProperty('--wcf-variant-thumb');
    wrap.removeAttribute('data-wcf-cols');
    wrap.removeAttribute('data-wcf-rows');
    wrap.removeAttribute('data-wcf-density');
    wrap.style.setProperty('--wcf-variant-gap', '0.3rem');
    syncVariantCarouselNav(wrap);
  }

  function clearVariantCarouselLayout(wrap) {
    if (!wrap) return;
    wrap.classList.remove('wcf-variants--carousel');
    var carousel = wrap.closest('[data-wbw-variant-carousel]');
    if (!carousel) return;
    var prev = carousel.querySelector('[data-wbw-variant-prev]');
    var next = carousel.querySelector('[data-wbw-variant-next]');
    if (prev) prev.hidden = true;
    if (next) next.hidden = true;
  }

  function applyVariantGridLayout(wrap, count, wizardRoot) {
    if (!wrap || count < 1) return;
    var isWizardVariants = wrap.hasAttribute('data-wbw-variants');
    /* Carousel / large single-slide layout is mobile-only. */
    if (isWizardVariants && isMobileViewport()) {
      applyVariantCarouselLayout(wrap, count);
      return;
    }
    if (isWizardVariants) clearVariantCarouselLayout(wrap);

    var body = wrap.closest('.wcf-step__body--variants-booking');
    var w = wrap.clientWidth || 0;
    var h = 0;
    if (body) {
      h = body.clientHeight || 0;
      if (!h && body.getBoundingClientRect) h = body.getBoundingClientRect().height;
      if (!w) w = body.clientWidth || 0;
      var inWizardBody = wizardRoot && wizardRoot.contains(body);
      var bottomReserve = inWizardBody ? 172 : 0;
      if (inWizardBody) {
        var topEl = body.querySelector('.wbw-variants-booking-top');
        var topH = 0;
        if (topEl) {
          topH = topEl.clientHeight || 0;
          if (!topH && topEl.getBoundingClientRect) topH = topEl.getBoundingClientRect().height;
        }
        if (topH > 80) {
          h = topH;
        } else {
          var bottomEl = body.querySelector('.wbw-variants-booking-mid');
          if (!bottomEl) {
            var stepEl = body.closest('[data-wbw-step="variants"]');
            bottomEl = stepEl && stepEl.querySelector('.wbw-variant-step-foot');
          }
          if (bottomEl) {
            var bottomH = bottomEl.offsetHeight || 0;
            if (!bottomH && bottomEl.getBoundingClientRect) bottomH = bottomEl.getBoundingClientRect().height;
            bottomReserve = Math.max(bottomReserve, bottomH);
          }
          h = Math.max(120, h - bottomReserve);
        }
      }
    }
    if (!w && wrap.getBoundingClientRect) w = wrap.getBoundingClientRect().width;

    var layout = variantCardLayout(wizardRoot);
    var gap = layout === 'stacked' ? variantGridGapPx() : VARIANT_GRID_GAP_PX;
    var cols =
      layout === 'stacked'
        ? pickStackedGridColumns(count, w || 320, h, gap, wizardRoot)
        : pickVariantGridColumns(count, w || 320, h, layout);
    var rows = Math.ceil(count / cols);
    wrap.style.setProperty('--wcf-variant-cols', String(cols));
    wrap.style.setProperty('--wcf-variant-rows', String(rows));
    wrap.setAttribute('data-wcf-cols', String(cols));
    wrap.setAttribute('data-wcf-rows', String(rows));
    wrap.classList.toggle('wcf-variants--layout-stacked', layout === 'stacked');
    wrap.classList.toggle('wcf-variants--layout-horizontal', layout === 'horizontal');

    var compact = layout === 'horizontal' && w > 0 && w < 990;
    wrap.classList.toggle('wcf-variants--compact', compact);

    if (layout === 'stacked' && w > 0) {
      var thumbPx = stackedThumbPx(cols, w, h, count, gap, wizardRoot);
      wrap.style.setProperty('--wcf-variant-gap', gap + 'px');
      wrap.style.setProperty('--wcf-variant-thumb', thumbPx + 'px');
      wrap.setAttribute(
        'data-wcf-density',
        isMobileViewport() ? 'mobile' : isDesktopViewport() ? 'desktop' : 'tablet'
      );
      wrap.classList.remove('wcf-variants--fit');
    } else if (h > 0 && rows > 0 && !compact) {
      var rowH = Math.floor((h - Math.max(0, rows - 1) * gap) / rows);
      var rowMax = wizardRoot && wizardRoot.contains(wrap) ? 108 : 120;
      rowH = Math.max(VARIANT_ROW_MIN_H_PX, Math.min(rowH, rowMax));
      wrap.style.setProperty('--wcf-variant-title-size', rowH < 62 ? '0.5625rem' : rowH < 78 ? '0.625rem' : '0.6875rem');
      wrap.style.setProperty('--wcf-variant-price-size', rowH < 62 ? '0.6875rem' : '0.75rem');
      wrap.style.setProperty('--wcf-variant-pad', rowH < 58 ? '0.16rem' : '0.22rem');
      wrap.classList.add('wcf-variants--fit');
    } else {
      wrap.classList.remove('wcf-variants--fit');
    }
  }

  function bindVariantGridResize(wrap, wizardRoot) {
    if (!wrap) return;
    function relayout() {
      var n = wrap.querySelectorAll('.wcf-variant-row').length;
      if (n) applyVariantGridLayout(wrap, n, wizardRoot);
    }
    relayout();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        relayout();
        requestAnimationFrame(relayout);
      });
    }
    window.setTimeout(relayout, 60);
    if (typeof ResizeObserver === 'undefined') return;
    if (wrap.__wbwGridRo) wrap.__wbwGridRo.disconnect();
    var body = wrap.closest('.wcf-step__body--variants-booking');
    wrap.__wbwGridRo = new ResizeObserver(relayout);
    wrap.__wbwGridRo.observe(body || wrap);
    wrap.__wbwGridRo.observe(wrap);
  }

  function variantQtyControlHtml(variantId, qty) {
    var q = qty || 0;
    var id = vQtyKey(variantId);
    return (
      '<div class="wcf-qty wcf-qty--variant wcf-qty--horizontal wbw-qty-variant" data-wbw-variant-qty data-variant-id="' +
      id +
      '">' +
      '<button type="button" class="wcf-qty__btn" data-wbw-qty-dec aria-label="Decrease quantity"' +
      (q <= 0 ? ' disabled' : '') +
      '>−</button>' +
      '<span class="wcf-qty__val" data-wbw-qty-val aria-live="polite">' +
      q +
      '</span>' +
      '<button type="button" class="wcf-qty__btn" data-wbw-qty-inc aria-label="Increase quantity">+</button></div>'
    );
  }

  function splitFullName(full) {
    var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { first: '', last: '' };
    return { first: parts[0], last: parts.slice(1).join(' ') || parts[0] };
  }

  function initRoot(wizardRoot) {
    if (!wizardRoot || wizardRoot.__wbwBound) return;
    wizardRoot.__wbwBound = true;
    cleanupOrphanTimeDdPanels();

    var data = parseData(wizardRoot);
    if (!data) return;

    var sectionId = data.sectionId || wizardRoot.getAttribute('data-section-id') || '';
    var venueWorkshopIndexRows = parseVenueWorkshopIndex(sectionId);
    var venueWorkshopMaps = buildVenueWorkshopMaps(venueWorkshopIndexRows);
    var venueWorkshopMap = venueWorkshopMaps.byRef;
    var venueWorkshopMapByName = venueWorkshopMaps.byName;
    var siblingPromoData = parseSiblingPromoData(sectionId);
    var siblingWorkshops = ensureSiblingWorkshops(
      siblingPromoData && Array.isArray(siblingPromoData.siblingWorkshops)
        ? siblingPromoData.siblingWorkshops
        : [],
      data.productHandle || wizardRoot.getAttribute('data-product-handle')
    );
    var workshopCatalog =
      siblingPromoData && Array.isArray(siblingPromoData.workshopCatalog)
        ? siblingPromoData.workshopCatalog
        : [];
    var promoCatalogByHandle = new Map();
    function indexPromoCatalog(entry) {
      if (!entry || !entry.handle) return;
      var h = String(entry.handle).trim().toLowerCase();
      if (!h) return;
      var prev = promoCatalogByHandle.get(h) || {};
      promoCatalogByHandle.set(h, {
        handle: h,
        title: String(entry.title || entry.label || prev.title || h).trim(),
        url: String(entry.url || prev.url || '/products/' + encodeURIComponent(h)).trim(),
        image: entry.image || prev.image || '',
      });
    }
    siblingWorkshops.forEach(indexPromoCatalog);
    workshopCatalog.forEach(indexPromoCatalog);
    var siblingPromoEyebrow = String(
      (siblingPromoData && siblingPromoData.siblingPromoEyebrow) || 'Also available as'
    ).trim();
    ensureSiblingPromoDom(wizardRoot, sectionId);

    var variants = Array.isArray(data.variants) ? data.variants.slice() : [];
    var addonVariantIdKey = (function () {
      if (wizardRoot.getAttribute('data-addon-enabled') !== 'true') return '';
      var raw = wizardRoot.getAttribute('data-addon-variant-id');
      return raw ? vQtyKey(raw) : '';
    })();

    function addonVariantObject() {
      if (!addonVariantIdKey) return null;
      var cents = parseInt(wizardRoot.getAttribute('data-addon-price-cents') || '0', 10);
      if (!Number.isFinite(cents)) cents = 0;
      return {
        id: addonVariantIdKey,
        label: wbwAddonDisplayTitle(wizardRoot),
        title: wbwAddonDisplayTitle(wizardRoot),
        price: cents,
        image_url: String(wizardRoot.getAttribute('data-addon-image') || '').trim(),
        _isAddon: true,
      };
    }

    function isAddonVariantId(id) {
      return !!addonVariantIdKey && vQtyKey(id) === addonVariantIdKey;
    }

    var bookingRoot = wizardRoot.querySelector('.pdp-workshop-booking');
    var eventsRoot = bookingRoot ? bookingRoot.querySelector('[data-workshop-events]') : null;
    var venueWaitlistCatalog = parseVenueWaitlistCatalog(bookingRoot);
    var productId = String(data.productId || wizardRoot.getAttribute('data-product-id') || '');

    var state = {
      branch: 'venue',
      flow: 'booking',
      selectedVenueCard: null,
      selectedVenue: null,
      venueDisplayLabel: '',
      slotList: [],
      daysWithEvents: {},
      viewMonth: new Date(),
      selectedDate: '',
      selectedSlot: null,
      variantQty: {},
      focusedVariantId: '',
      lockedVariantId: readInitialVariantIdFromUrl(),
    };
    var liveHelper = getWizardLive();
    var liveController =
      liveHelper && typeof liveHelper.createController === 'function'
        ? liveHelper.createController(wizardRoot, {
            productHandle: data.productHandle || wizardRoot.getAttribute('data-product-handle') || '',
          })
        : null;

    var ALL_STEPS = ['venue', 'waitlist', 'datetime', 'variants'];

    function slotMatchKey(slot) {
      if (!slot) return '';
      var liveApi = getLiveApi();
      if (liveApi && typeof liveApi.canonicalEventId === 'function') {
        var liveKey = liveApi.canonicalEventId(slot);
        if (liveKey) return liveKey;
      }
      var raw = slot._raw || {};
      return String(
        slot.canonical_event_id ||
          raw.canonical_event_id ||
          raw.event_metaobject_gid ||
          raw.event_id ||
          raw.id ||
          slot.gid ||
          ''
      ).trim();
    }

    function replaceSelectedSlotFromList(slots) {
      if (!state.selectedSlot || !Array.isArray(slots)) return;
      var key = slotMatchKey(state.selectedSlot);
      if (!key) return;
      for (var i = 0; i < slots.length; i++) {
        if (slotMatchKey(slots[i]) === key) {
          state.selectedSlot = slots[i];
          return;
        }
      }
    }

    function syncSelectedVenueEventsFromSlots(slots) {
      if (!state.selectedVenue || !Array.isArray(slots)) return;
      state.selectedVenue.events = slots.map(function (slot) {
        return slot && slot._raw ? slot._raw : slot;
      });
    }

    var livePollStarted = false;
    var lastLiveApplyAt = 0;
    var lastLiveBatchAsOf = 0;

    function batchAsOfMs(slots) {
      var max = 0;
      (slots || []).forEach(function (slot) {
        if (!slot || !slot.capacity_as_of) return;
        var t = Date.parse(String(slot.capacity_as_of));
        if (Number.isFinite(t) && t > max) max = t;
      });
      return max;
    }

    function shouldApplyLiveSlots(slots, meta) {
      var at = meta && meta.at != null ? meta.at : Date.now();
      var asOfMs = batchAsOfMs(slots);
      if (asOfMs > 0) {
        if (asOfMs < lastLiveBatchAsOf) return false;
        lastLiveBatchAsOf = asOfMs;
      } else if (at < lastLiveApplyAt) {
        return false;
      }
      lastLiveApplyAt = at;
      return true;
    }

    function ensureLivePoll() {
      if (!liveController || livePollStarted) return;
      if (typeof liveController.startPoll !== 'function') return;
      liveController.startPoll(
        function () {
          return state.slotList || [];
        },
        applyLiveSlots,
        { immediate: false }
      );
      livePollStarted = true;
    }

    /** Date keys only — bookable/capacity flips must not rebuild the whole calendar grid. */
    function daysKeysFingerprint(daysMap) {
      return Object.keys(daysMap || {}).sort().join('|');
    }

    /** Structure only — ignores capacity/bookable ticks so live poll does not rebuild the calendar DOM. */
    function slotStructureFingerprint(slots) {
      return (slots || [])
        .map(function (s) {
          if (!s) return '';
          return [slotDateKey(s) || '', String(s.gid || ''), slotVisible(s) ? '1' : '0'].join(':');
        })
        .sort()
        .join('|');
    }

    function isCalTimeDdOpen() {
      var parts = getCalTimeDdParts(wizardRoot);
      return !!(parts && parts.dd && parts.dd.classList.contains('is-open'));
    }

    function softRefreshDatetimeDayButtons() {
      var step = stepEl('datetime');
      if (!step) return;
      var grid = step.querySelector('[data-wbw-cal-grid]');
      if (!grid) return;
      grid.querySelectorAll('[data-wbw-cal-day]').forEach(function (btn) {
        var key = btn.getAttribute('data-wbw-cal-day') || '';
        var info = state.daysWithEvents[key];
        btn.classList.toggle('wcf-cal-day--muted', !info);
        btn.classList.toggle('wcf-cal-day--has-event', !!info);
        btn.classList.toggle('wcf-cal-day--soldout-only', !!(info && !info.bookable));
        btn.classList.toggle('wcf-cal-day--selected', key === state.selectedDate);
        btn.disabled = !info;
      });
    }

    function softRefreshDatetimeTimeUi() {
      var step = stepEl('datetime');
      if (!step) return;
      softRefreshDatetimeDayButtons();
      var daySlots = slotsForDate(state.selectedDate).filter(slotVisible);
      var wasOpen = isCalTimeDdOpen();
      renderCalTimeNativeSelect(step, daySlots, { allowAutoSelectSingle: false });
      syncCalTimeDdFromSelect(step);
      /*
       * Soft refresh must not re-stamp timeDdOpenedAtMs (that blocked outside-click close)
       * and must not flip open→close. Keep portal open; only re-open if sync left it closed.
       */
      if (wasOpen) {
        var parts = getCalTimeDdParts(wizardRoot);
        if (parts && parts.panel && parts.panel.hidden) {
          openCalTimeDd({ keepOpenStamp: true });
        } else if (parts) {
          positionTimeDdPanel(parts);
        }
      }
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      if (!state.selectedSlot) {
        if (toBtn) toBtn.disabled = true;
      } else if (!slotBookable(state.selectedSlot)) {
        if (toBtn) toBtn.disabled = true;
      } else if (toBtn) {
        toBtn.disabled = false;
      }
      syncCapacityRing();
    }

    function slotBookabilityFingerprint(slots) {
      return (slots || [])
        .map(function (s) {
          if (!s) return '';
          return [
            String(s.gid || ''),
            slotBookable(s) ? '1' : '0',
            String(s.capacity_remaining != null ? s.capacity_remaining : ''),
          ].join(':');
        })
        .sort()
        .join('|');
    }

    function applyLiveSlots(slots, meta) {
      if (!Array.isArray(slots) || !slots.length) return;
      if (!shouldApplyLiveSlots(slots, meta)) return;
      var prevDaysFp = daysKeysFingerprint(state.daysWithEvents);
      var prevStructFp = slotStructureFingerprint(state.slotList);
      var prevBookFp = slotBookabilityFingerprint(state.slotList);
      var prevSelectedGid = state.selectedSlot && state.selectedSlot.gid ? String(state.selectedSlot.gid) : '';
      state.slotList = slots;
      state.daysWithEvents = buildDaysMap(state.slotList);
      syncSelectedVenueEventsFromSlots(state.slotList);
      replaceSelectedSlotFromList(state.slotList);
      if (state.selectedSlot && !slotVisible(state.selectedSlot)) state.selectedSlot = null;
      var nextSelectedGid = state.selectedSlot && state.selectedSlot.gid ? String(state.selectedSlot.gid) : '';
      var daysChanged = prevDaysFp !== daysKeysFingerprint(state.daysWithEvents);
      var structureChanged = prevStructFp !== slotStructureFingerprint(state.slotList);
      var bookabilityChanged = prevBookFp !== slotBookabilityFingerprint(state.slotList);
      var selectionChanged = prevSelectedGid !== nextSelectedGid;
      if (state.branch === 'datetime') {
        if (daysChanged || structureChanged || selectionChanged) {
          renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
        } else {
          softRefreshDatetimeTimeUi();
        }
      } else if (state.branch === 'variants') {
        if (state.selectedVenue && !isStoreVenue(state.selectedVenue)) {
          if (daysChanged || structureChanged || selectionChanged || bookabilityChanged) {
            refreshPopupDatetimeControls({
              preferredDate: state.selectedDate,
              preferredGid: state.selectedSlot && state.selectedSlot.gid,
              apply: true,
            });
          }
        } else if (daysChanged || structureChanged || selectionChanged || bookabilityChanged) {
          renderVariants();
          updateVariantStepUi();
        }
        syncCapacityRing();
        return;
      }
      syncCapacityRing();
    }

    function enrichSlotsForCurrentVenue(slots) {
      if (!liveController || typeof liveController.enrichSlots !== 'function') {
        return Promise.resolve(slots || []);
      }
      return liveController
        .enrichSlots(slots || [])
        .then(function (freshSlots) {
          return freshSlots || slots || [];
        })
        .catch(function () {
          return slots || [];
        });
    }

    function refreshVenueEventsLive(venue) {
      if (!venue || !Array.isArray(venue.events) || !venue.events.length) {
        return Promise.resolve(venue);
      }
      var slots = eventsToSlots(venue.events);
      if (!slots.length) return Promise.resolve(venue);
      return enrichSlotsForCurrentVenue(slots)
        .then(function (freshSlots) {
          venue.events = freshSlots.map(function (slot) {
            return slot && slot._raw ? slot._raw : slot;
          });
          if (state.selectedVenue === venue) {
            state.slotList = freshSlots;
            state.daysWithEvents = buildDaysMap(state.slotList);
            syncSelectedVenueEventsFromSlots(state.slotList);
            replaceSelectedSlotFromList(state.slotList);
          }
          return venue;
        })
        .catch(function () {
          return venue;
        });
    }

    function resolveVenueHandleForUrl() {
      var t = venueUrlToken(state.selectedVenue);
      if (t) return t;
      t = venueHandleFromSlotRaw(state.selectedSlot && state.selectedSlot._raw);
      if (t) return t;
      if (state.selectedVenueCard) {
        var ref = String(state.selectedVenueCard.getAttribute('data-venue-ref-id') || '').trim();
        t = extractNumericVenueRefForUrl(ref) || ref;
        if (t) return t;
      }
      return '';
    }

    function clearBookingUrlEventIdKeepVariant() {
      var patch = { eventId: '' };
      if (state.lockedVariantId) patch.variantId = state.lockedVariantId;
      updateWizardBookingUrl(patch);
    }

    function syncBookingUrlForVenueStep(venue) {
      var token = venueUrlToken(venue);
      updateWizardBookingUrl({
        venue: token || '',
        eventId: '',
      });
    }

    function syncBookingUrlForDatetimeStep(slot) {
      var patch = { venue: resolveVenueHandleForUrl() || venueUrlToken(state.selectedVenue) || '' };
      if (slot) {
        var raw = slot._raw || {};
        patch.eventId = String(raw.id || raw.gid || slot.gid || '').trim();
      } else {
        patch.eventId = '';
      }
      if (state.lockedVariantId) patch.variantId = state.lockedVariantId;
      updateWizardBookingUrl(patch);
    }

    function syncBookingUrlVariantOnStep3(variantId) {
      if (state.branch !== 'variants') return;
      var id = vQtyKey(variantId);
      if (!id) return;
      state.lockedVariantId = id;
      state.focusedVariantId = id;
      updateWizardBookingUrl({
        variantId: id,
        venue: resolveVenueHandleForUrl() || venueUrlToken(state.selectedVenue) || '',
      });
    }

    function ensureLockedVariantFromUrlOrSlot() {
      if (state.lockedVariantId) return;
      var fromUrl = readInitialVariantIdFromUrl();
      if (fromUrl) {
        state.lockedVariantId = fromUrl;
        return;
      }
    }

    function findSlotByEventId(eventId) {
      var urlNum = extractNumericEventIdForUrl(eventId);
      if (!urlNum || !state.slotList.length) return null;
      for (var si = 0; si < state.slotList.length; si++) {
        var s = state.slotList[si];
        var raw = s._raw || {};
        var num = extractNumericEventIdForUrl(raw.id || raw.gid || s.gid || '');
        if (num && num === urlNum) return s;
      }
      return null;
    }

    function findVenueCardByUrlToken(token) {
      if (!eventsRoot || !token) return null;
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var ci = 0; ci < cards.length; ci++) {
        var card = cards[ci];
        if (card._wbVenue && venueMatchesUrlToken(card._wbVenue, token)) return card;
      }
      return null;
    }

    function applySlotToDatetimeStep(slot) {
      if (!slot) return;
      state.selectedDate = slotDateKey(slot);
      if (state.selectedDate) {
        var dp = state.selectedDate.split('-').map(Number);
        if (dp.length >= 2) state.viewMonth = new Date(dp[0], dp[1] - 1, 1);
      }
      state.selectedSlot = slot;
      setBranch('datetime');
      renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
      var step = stepEl('datetime');
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (select && slot.gid) {
        select.value = slot.gid;
        onTimeSelectChange();
      }
    }

    function applySlotToVariantStep(slot) {
      if (!slot || !slotBookable(slot)) return false;
      state.selectedSlot = slot;
      state.selectedDate = slotDateKey(slot);
      if (state.selectedDate) {
        var dp = state.selectedDate.split('-').map(Number);
        if (dp.length >= 2) state.viewMonth = new Date(dp[0], dp[1] - 1, 1);
      }
      syncWorkshopSelection(slot);
      setBranch('variants');
      renderVariants();
      updateVariantStepUi();
      syncBookingUrlForDatetimeStep(slot);
      syncCapacityRing();
      syncSiblingWorkshopPromo();
      return true;
    }

    function findVenueCardByEventId(eventId) {
      var urlNum = extractNumericEventIdForUrl(eventId);
      if (!urlNum || !eventsRoot) return null;
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var ci = 0; ci < cards.length; ci++) {
        var card = cards[ci];
        var venue = card._wbVenue;
        if (!venue || !Array.isArray(venue.events)) continue;
        for (var ei = 0; ei < venue.events.length; ei++) {
          var ev = venue.events[ei];
          var num = extractNumericEventIdForUrl(
            String((ev && ev.id) || '') || String((ev && ev.event_metaobject_gid) || '')
          );
          if (num && num === urlNum) return card;
        }
      }
      return null;
    }

    function findVenueCardForDeepLink(eventId, venueToken) {
      if (venueToken) {
        var byVenue = findVenueCardByUrlToken(venueToken);
        if (byVenue) return byVenue;
      }
      if (eventId) {
        var byEvent = findVenueCardByEventId(eventId);
        if (byEvent) return byEvent;
        var row = findIndexRowByEventId(venueWorkshopIndexRows, eventId);
        if (row) {
          var ref = extractNumericVenueRefForUrl(row.venue_ref_id);
          if (ref) {
            var byRef = findVenueCardByUrlToken(ref);
            if (byRef) return byRef;
          }
          var handle = String(row.venue_handle || '').trim();
          if (handle) {
            var byHandle = findVenueCardByUrlToken(handle);
            if (byHandle) return byHandle;
          }
        }
      }
      if (venueToken && venueWaitlistCatalog.length) {
        var catalogVenue = findCatalogVenueByToken(venueWaitlistCatalog, venueToken);
        if (catalogVenue) {
          var catalogRef = extractNumericVenueRefForUrl(catalogVenue.venue_ref_id);
          if (catalogRef) {
            var byCatalogRef = findVenueCardByUrlToken(catalogRef);
            if (byCatalogRef) return byCatalogRef;
          }
        }
      }
      return null;
    }

    function resolveDeepLinkEventId(eventId, venueToken) {
      eventId = String(eventId || '').trim();
      if (!eventId || !state.selectedVenue) return eventId;
      if (slotListContainsEventId(state.slotList, eventId)) return eventId;
      if (!venueToken) return eventId;
      var productHandle = data.productHandle || wizardRoot.getAttribute('data-product-handle');
      var corrected = resolveEventIdForProductAtVenue(
        productHandle,
        state.selectedVenue,
        state.selectedVenueCard,
        eventId,
        venueWorkshopIndexRows
      );
      return corrected || eventId;
    }

    function primeVenueLabelFromUrl() {
      if (state.venueDisplayLabel) return;
      var label = resolveVenueLabelFromDeepLink();
      if (label) state.venueDisplayLabel = label;
    }

    function tryApplyWizardUrlDeepLink() {
      if (wizardRoot.__wbwUrlDeepLinkComplete) return;
      if (wizardRoot.__wbwUserReachedDatetime) return;
      if (!eventsRoot) return;
      /* Typing / filtering venues must never auto-jump to Step 2. */
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) return;
      if (state.branch === 'datetime' || state.branch === 'variants') return;

      var venueToken = getVenueTokenFromUrl();
      var eventId = getEventIdFromUrl();
      var wbwStep = getWbwStepFromUrl();
      if (!venueToken && !eventId) return;

      primeVenueLabelFromUrl();

      var venueCard = findVenueCardForDeepLink(eventId, venueToken);
      if (!venueCard) {
        if (state.venueDisplayLabel && state.branch !== 'venue') updateProductVenueSeoCopy();
        return;
      }

      if (eventId && venueCardIsWaitlistOnly(venueCard) && !urlHasWizardDeepLink()) return;

      selectVenueCard(venueCard, { updatePageCopy: true });
      if (state.flow === 'waitlist') {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        return;
      }
      var advanceToDatetime = !!(venueToken || eventId || wbwStep === 'datetime');
      if (!advanceToDatetime) return;
      /* One-shot: mark before async so list re-renders cannot re-enter. */
      wizardRoot.__wbwUrlDeepLinkComplete = true;
      var startStep = isStoreVenue(state.selectedVenue) ? startDatetimeStep : startPopupBookingStep;
      startStep()
        .then(function () {
        clearWbwStepFromUrl();
        if (!eventId) {
          if (state.branch === 'datetime' || state.branch === 'variants') {
            updateProductVenueSeoCopy();
          }
          return;
        }

        var resolvedEventId = resolveDeepLinkEventId(eventId, venueToken);
        var slot = findSlotByEventId(resolvedEventId);
        if (!slot || !slotVisible(slot)) return;

        if (resolvedEventId !== eventId) {
          syncBookingUrlForDatetimeStep(slot);
        }

        if (state.branch === 'waitlist') {
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
        }

        var variantId = readInitialVariantIdFromUrl();
        if (variantId && slotBookable(slot)) {
          applySlotToVariantStep(slot);
          if (!isStoreVenue(state.selectedVenue)) {
            refreshPopupDatetimeControls({
              preferredDate: slotDateKey(slot),
              preferredGid: slot.gid,
              apply: false,
            });
            syncPopupDatetimePanel();
          }
          state.lockedVariantId = variantId;
          previewWizardVariant(variantId);
          var qKey = vQtyKey(variantId);
          if (!state.variantQty[qKey]) state.variantQty[qKey] = 1;
          refreshVariantRowUI(qKey);
          updateVariantStepUi();
          updateProductVenueSeoCopy();
          return;
        }

        if (!isStoreVenue(state.selectedVenue)) {
          state.selectedDate = slotDateKey(slot);
          state.selectedSlot = slot;
          refreshPopupDatetimeControls({
            preferredDate: state.selectedDate,
            preferredGid: slot.gid,
            apply: true,
          });
          ensureLockedVariantFromUrlOrSlot();
          window.__WB_LOCK_VARIANT_URL__ = true;
          syncWorkshopSelection(slot);
          syncBookingUrlForDatetimeStep(slot);
          renderVariants();
          updateVariantStepUi();
          updateProductVenueSeoCopy();
          return;
        }

        applySlotToDatetimeStep(slot);
        updateProductVenueSeoCopy();
      })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          try {
            console.warn('[wbw] deep-link step start failed', err);
          } catch (_) {}
        });
    }

    function stepEl(name) {
      return wizardRoot.querySelector('[data-wbw-step="' + name + '"]');
    }

    function updateProgressLabels() {
      var popupBooking =
        state.flow === 'booking' && state.selectedVenue && !isStoreVenue(state.selectedVenue);
      var total = popupBooking ? 2 : 3;
      var labels = popupBooking
        ? { venue: 1, waitlist: 1, datetime: 2, variants: 2 }
        : { venue: 1, waitlist: 1, datetime: 2, variants: 3 };
      wizardRoot.querySelectorAll('[data-wbw-progress]').forEach(function (p) {
        var step = state.branch;
        var n = labels[step] || 1;
        p.textContent = 'Step ' + n + ' of ' + total;
      });
      var venueFoot = stepEl('venue');
      if (venueFoot) {
        var solo = venueFoot.querySelector('[data-wbw-progress]');
        if (solo) solo.textContent = 'Step 1 of ' + total;
      }
    }

    function syncVenueKindAttr() {
      var kind = 'store';
      if (state.selectedVenue) {
        kind = isStoreVenue(state.selectedVenue) ? 'store' : 'popup';
      }
      wizardRoot.setAttribute('data-wbw-venue-kind', kind);
      return kind;
    }

    function setBranch(branch) {
      if (branch !== 'datetime') closeCalTimeDd();
      state.branch = branch;
      wizardRoot.setAttribute('data-wbw-branch', branch);
      syncVenueKindAttr();
      if (branch === 'datetime') {
        window.__WB_LOCK_VARIANT_URL__ = true;
      } else if (branch !== 'variants') {
        window.__WB_LOCK_VARIANT_URL__ = false;
      }
      ALL_STEPS.forEach(function (s) {
        var el = stepEl(s);
        if (!el) return;
        var on = s === branch;
        el.hidden = !on;
        el.classList.toggle('wcf-step--on', on);
      });
      updateProgressLabels();
      syncPopupDatetimePanel();
      if (branch === 'datetime') {
        syncCapacityRing();
        if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
        else if (state.selectedVenue) syncBookingUrlForVenueStep(state.selectedVenue);
      } else if (branch === 'variants' && state.selectedSlot) {
        syncBookingUrlForDatetimeStep(state.selectedSlot);
      }
      /* Step 1: never write ?venue= here (select / Back clear URL explicitly). */
      syncSiblingWorkshopPromo();
      updateProductVenueSeoCopy();
    }

    function venueProductHandles(venue) {
      var out = Object.create(null);
      if (!venue) return out;
      venueRefAliasKeys(venue.venue_ref_id).forEach(function (ref) {
        if (ref && venueWorkshopMap[ref]) {
          Object.keys(venueWorkshopMap[ref]).forEach(function (h) {
            out[h] = true;
          });
        }
      });
      var nameKey = venueNameLookupKey(venue.venue_name || venue.name || venue.city_name);
      if (nameKey && venueWorkshopMapByName[nameKey]) {
        Object.keys(venueWorkshopMapByName[nameKey]).forEach(function (h) {
          out[h] = true;
        });
      }
      if (nameKey && nameKey.length >= 4) {
        Object.keys(venueWorkshopMapByName).forEach(function (idxKey) {
          if (idxKey === nameKey) return;
          if (idxKey.indexOf(nameKey) >= 0 || nameKey.indexOf(idxKey) >= 0) {
            Object.keys(venueWorkshopMapByName[idxKey]).forEach(function (h) {
              out[h] = true;
            });
          }
        });
      }
      var cityKey = venueNameLookupKey(venue.city || venue.city_name || '');
      if (cityKey && cityKey.length >= 4 && cityKey !== nameKey) {
        Object.keys(venueWorkshopMapByName).forEach(function (idxKey) {
          if (idxKey.indexOf(cityKey) >= 0) {
            Object.keys(venueWorkshopMapByName[idxKey]).forEach(function (h) {
              out[h] = true;
            });
          }
        });
      }
      var evs = Array.isArray(venue.events) ? venue.events : [];
      evs.forEach(function (ev) {
        if (!ev) return;
        var ph = String(ev.product_handle || ev.productHandle || '')
          .trim()
          .toLowerCase();
        if (ph) out[ph] = true;
        collectAlsoAvailableHandles(ev, out);
        var av = ev.available_variants;
        if (Array.isArray(av)) {
          av.forEach(function (it) {
            var h3 = String((it && (it.product_handle || it.productHandle)) || '')
              .trim()
              .toLowerCase();
            if (h3) out[h3] = true;
          });
        }
      });
      if (state.selectedSlot && state.selectedSlot._raw) {
        collectAlsoAvailableHandles(state.selectedSlot._raw, out);
        var slotAv = state.selectedSlot._raw.available_variants;
        if (Array.isArray(slotAv)) {
          slotAv.forEach(function (it) {
            var h4 = String((it && (it.product_handle || it.productHandle)) || '')
              .trim()
              .toLowerCase();
            if (h4) out[h4] = true;
          });
        }
      }
      return out;
    }

    function venueDisplayName(venue) {
      if (!venue) return '';
      var fromVenue = String(venue.venue_name || venue.name || venue.city_name || '').trim();
      if (fromVenue) return fromVenue;
      if (state.selectedVenueCard) {
        return String(state.selectedVenueCard.getAttribute('data-wbw-city-label') || '').trim();
      }
      return '';
    }

    function promoImageForHandle(handle) {
      var h = String(handle || '')
        .trim()
        .toLowerCase();
      var entry = promoCatalogByHandle.get(h);
      return entry && entry.image ? entry.image : '';
    }

    function promoMetaForHandle(handle) {
      var h = String(handle || '')
        .trim()
        .toLowerCase();
      return promoCatalogByHandle.get(h) || null;
    }

    function findPromoEventIdFromIndex(targetHandle) {
      return resolvePromoDeepLinkFromIndex(
        targetHandle,
        data.productHandle || wizardRoot.getAttribute('data-product-handle'),
        state.selectedVenue,
        state.selectedVenueCard,
        state.selectedSlot,
        venueWorkshopIndexRows
      ).eventId;
    }

    function absorbAlsoAvailableEventId(targetHandle) {
      targetHandle = String(targetHandle || '')
        .trim()
        .toLowerCase();
      if (!targetHandle) return '';

      function scanSource(source) {
        if (!source) return '';
        if (Array.isArray(source.also_available_products)) {
          for (var ai = 0; ai < source.also_available_products.length; ai++) {
            var p = source.also_available_products[ai];
            if (!handlesMatchForPromo(p && p.handle, targetHandle)) continue;
            var fromAa = extractPromoEventIdFromProduct(p);
            if (fromAa) return fromAa;
          }
        }
        if (Array.isArray(source.available_variants)) {
          for (var vi = 0; vi < source.available_variants.length; vi++) {
            var it = source.available_variants[vi];
            if (!handlesMatchForPromo(it && (it.product_handle || it.productHandle), targetHandle)) {
              continue;
            }
            var fromAv = extractPromoEventIdFromProduct(it);
            if (fromAv) return fromAv;
          }
        }
        return '';
      }

      var fromSlot = scanSource(state.selectedSlot && state.selectedSlot._raw);
      if (fromSlot) return fromSlot;
      if (state.selectedVenue && Array.isArray(state.selectedVenue.events)) {
        for (var ei = 0; ei < state.selectedVenue.events.length; ei++) {
          var fromEv = scanSource(state.selectedVenue.events[ei]);
          if (fromEv) return fromEv;
        }
      }
      return '';
    }

    function resolvePromoDeepLink(targetHandle) {
      targetHandle = String(targetHandle || '')
        .trim()
        .toLowerCase();
      if (!targetHandle) return { eventId: '', venueHandle: '' };

      var venueToken = venueUrlToken(state.selectedVenue) || '';

      if (state.selectedSlot) {
        var fromSessionAnchor = resolveSiblingEventIdFromSessionAnchor(
          targetHandle,
          state.selectedSlot,
          state.selectedVenue,
          state.selectedVenueCard,
          venueWorkshopIndexRows
        );
        if (fromSessionAnchor) {
          return { eventId: fromSessionAnchor, venueHandle: venueToken };
        }
      }

      var fromIndex = resolvePromoDeepLinkFromIndex(
        targetHandle,
        data.productHandle || wizardRoot.getAttribute('data-product-handle'),
        state.selectedVenue,
        state.selectedVenueCard,
        state.selectedSlot,
        venueWorkshopIndexRows
      );
      if (fromIndex.eventId) return fromIndex;

      var fromAa = absorbAlsoAvailableEventId(targetHandle);
      if (
        fromAa &&
        promoEventIdMatchesVenueContext(
          fromAa,
          state.selectedVenue,
          state.selectedVenueCard,
          state.selectedSlot,
          venueWorkshopIndexRows
        )
      ) {
        return { eventId: fromAa, venueHandle: venueToken };
      }

      if (!state.selectedVenue || !state.selectedSlot) return { eventId: '', venueHandle: '' };
      var curDate = slotDateKey(state.selectedSlot);
      var curTime = normalizeTimeLabel(state.selectedSlot.time_label);
      var evs = Array.isArray(state.selectedVenue.events) ? state.selectedVenue.events : [];

      for (var ei = 0; ei < evs.length; ei++) {
        var ev = evs[ei];
        if (!ev) continue;
        if (!handlesMatchForPromo(ev.product_handle || ev.productHandle, targetHandle)) continue;
        var slot = normalizeEventToSlot(ev);
        if (!slot) continue;
        if (curDate && slotDateKey(slot) !== curDate) continue;
        if (curTime && normalizeTimeLabel(slot.time_label) !== curTime) continue;
        var num = extractNumericEventIdForUrl(
          ev.id || ev.gid || ev.event_metaobject_gid || slot.gid || ''
        );
        if (num) {
          return {
            eventId: num,
            venueHandle: String(ev.venue_handle || '').trim(),
          };
        }
      }

      for (var ej = 0; ej < evs.length; ej++) {
        var ev2 = evs[ej];
        if (!ev2) continue;
        if (!handlesMatchForPromo(ev2.product_handle || ev2.productHandle, targetHandle)) continue;
        var slot2 = normalizeEventToSlot(ev2);
        if (!slot2) continue;
        if (curDate && slotDateKey(slot2) !== curDate) continue;
        var num2 = extractNumericEventIdForUrl(
          ev2.id || ev2.gid || ev2.event_metaobject_gid || slot2.gid || ''
        );
        if (num2) {
          return {
            eventId: num2,
            venueHandle: String(ev2.venue_handle || '').trim(),
          };
        }
      }

      return { eventId: '', venueHandle: '' };
    }

    function findPromoEventIdForHandle(targetHandle) {
      return resolvePromoDeepLink(targetHandle).eventId;
    }

    function buildPromoProductUrl(prod) {
      var base = String((prod && prod.url) || '').trim();
      if (!base && prod && prod.handle) base = '/products/' + encodeURIComponent(prod.handle);
      if (!base) return '#';
      var targetHandle = prod && prod.handle;
      var currentHandle = data.productHandle || wizardRoot.getAttribute('data-product-handle');
      var eventId = resolveVenueAnchoredPromoEventId(
        targetHandle,
        currentHandle,
        state.selectedVenue,
        state.selectedVenueCard,
        state.selectedSlot,
        venueWorkshopIndexRows,
        (prod && prod.promoEventId) || ''
      );
      if (!eventId && prod && prod.url) eventId = extractEventIdFromUrl(prod.url);
      var venueToken =
        venueUrlToken(state.selectedVenue) ||
        venueHandleFromSlotRaw(state.selectedSlot && state.selectedSlot._raw) ||
        '';
      try {
        var u = new URL(base, window.location.origin);
        var eid = eventId ? extractNumericEventIdForUrl(eventId) : '';
        if (venueToken) u.searchParams.set('venue', venueToken);
        if (eid) u.searchParams.set('event_id', eid);
        return u.pathname + u.search;
      } catch (_) {
        var qs = [];
        var eid2 = eventId ? extractNumericEventIdForUrl(eventId) : '';
        if (venueToken) qs.push('venue=' + encodeURIComponent(venueToken));
        if (eid2) qs.push('event_id=' + encodeURIComponent(eid2));
        return base + (base.indexOf('?') > -1 ? '&' : '?') + qs.join('&');
      }
    }

    function collectPromoWorkshops() {
      var current = String(data.productHandle || wizardRoot.getAttribute('data-product-handle') || '')
        .trim()
        .toLowerCase();
      var map = new Map();

      function putPromo(h, opts) {
        opts = opts || {};
        h = String(h || '')
          .trim()
          .toLowerCase();
        if (!h) return;
        var key = canonicalPromoHandle(h);
        if (!key || handlesMatchForPromo(key, current) || map.has(key)) return;
        var fromAlsoAvailable = !!opts.fromAlsoAvailable;
        var fromSessionIndex = !!opts.fromSessionIndex;
        var promoEventId = extractNumericEventIdForUrl(opts.promoEventId || '');
        if (state.selectedSlot && (fromAlsoAvailable || fromSessionIndex || !promoEventId)) {
          promoEventId =
            resolveVenueAnchoredPromoEventId(
              key,
              current,
              state.selectedVenue,
              state.selectedVenueCard,
              state.selectedSlot,
              venueWorkshopIndexRows,
              opts.promoEventId || ''
            ) || promoEventId;
        }
        if (!promoEventId && !fromAlsoAvailable && !fromSessionIndex) return;
        var meta = promoMetaForHandle(key) || promoMetaForHandle(h);
        map.set(key, {
          handle: key,
          title: String(
            opts.title || (meta && meta.title) || WB_SIBLING_LABELS[key] || WB_SIBLING_LABELS[h] || key
          ).trim(),
          url: String(
            opts.url || (meta && meta.url) || '/products/' + encodeURIComponent(key)
          ).trim(),
          image: String(opts.image || (meta && meta.image) || promoImageForHandle(key) || '').trim(),
          promoEventId: promoEventId || '',
          fromAlsoAvailable: fromAlsoAvailable,
        });
      }

      function absorbAlsoAvailable(source) {
        if (!source) return;
        var arr = source.also_available_products;
        if (Array.isArray(arr)) {
          arr.forEach(function (p) {
            if (!p) return;
            var h = String(p.handle || p.product_handle || p.productHandle || '')
              .trim()
              .toLowerCase();
            if (!h) return;
            putPromo(h, {
              title: p.title || p.product_title || p.productTitle,
              url: p.url || p.product_url || p.productUrl,
              image: p.image || p.featured_image || p.product_image || p.productImage,
              promoEventId: extractPromoEventIdFromProduct(p),
              fromAlsoAvailable: true,
            });
          });
        }
        if (Array.isArray(source.available_variants)) {
          source.available_variants.forEach(function (it) {
            if (!it) return;
            var h = String(it.product_handle || it.productHandle || '')
              .trim()
              .toLowerCase();
            if (!h) return;
            putPromo(h, {
              title: it.product_title || it.productTitle || it.title,
              url: it.product_url || it.productUrl,
              image: it.product_image || it.productImage || it.image,
              promoEventId: extractPromoEventIdFromProduct(it),
              fromAlsoAvailable: true,
            });
          });
        }
      }

      function promoAlsoAvailableSources() {
        var out = [];
        if (!state.selectedSlot) return out;
        var seen = Object.create(null);
        function add(src) {
          if (!src || typeof src !== 'object') return;
          var id = extractNumericEventIdForUrl(
            src.id || src.gid || src.event_metaobject_gid || src.event_id || ''
          );
          var dk = String(src.date_key || '').trim();
          var tl = normalizeTimeLabel(src.time_label || '');
          var key = (id || 'x') + '|' + dk + '|' + tl;
          if (seen[key]) return;
          seen[key] = true;
          out.push(src);
        }

        var curKey = slotMatchKey(state.selectedSlot);
        var curDate = slotDateKey(state.selectedSlot);
        var curTime = normalizeTimeLabel(state.selectedSlot.time_label);
        if (!curDate || !curTime) return out;

        if (state.selectedSlot._raw) add(state.selectedSlot._raw);

        var evs =
          state.selectedVenue && Array.isArray(state.selectedVenue.events)
            ? state.selectedVenue.events
            : [];
        evs.forEach(function (ev) {
          var slot = normalizeEventToSlot(ev);
          if (!slot) return;
          if (curKey && slotMatchKey(slot) === curKey) {
            add(ev);
            return;
          }
          if (slotDateKey(slot) === curDate && normalizeTimeLabel(slot.time_label) === curTime) {
            add(ev);
          }
        });

        return out;
      }

      promoAlsoAvailableSources().forEach(absorbAlsoAvailable);

      if (state.selectedVenue && state.selectedSlot && venueWorkshopIndexRows.length) {
        WB_HANDLE_ALIAS_GROUPS.forEach(function (group) {
          if (group.some(function (gh) { return handlesMatchForPromo(gh, current); })) return;
          var targetHandle = group[0];
          var eventId = resolveSiblingEventIdFromSessionAnchor(
            targetHandle,
            state.selectedSlot,
            state.selectedVenue,
            state.selectedVenueCard,
            venueWorkshopIndexRows
          );
          if (!eventId) return;
          putPromo(targetHandle, { fromSessionIndex: true, promoEventId: eventId });
        });
      }

      return Array.from(map.values());
    }

    function buildPromoCardHtml(prod, subtitle) {
      var label = prod.title || prod.handle || 'Workshop';
      var href = buildPromoProductUrl(prod);
      var imgHtml = prod.image
        ? '<span class="wbw-sibling-promo-card__media"><img class="wbw-sibling-promo-card__img" src="' +
          escapeHtml(prod.image) +
          '" alt="' +
          escapeHtml(label) +
          '" width="200" height="150" loading="lazy" decoding="async"></span>'
        : '<span class="wbw-sibling-promo-card__media wbw-sibling-promo-card__media--placeholder" aria-hidden="true"><span class="wbw-sibling-promo-card__placeholder-mark">✦</span></span>';
      var subtitleHtml = subtitle
        ? '<span class="wbw-sibling-promo-card__subtitle">' + escapeHtml(subtitle) + '</span>'
        : '';
      return (
        '<a class="wbw-sibling-promo-card" href="' +
        escapeHtml(href) +
        '">' +
        imgHtml +
        '<span class="wbw-sibling-promo-card__body">' +
        '<span class="wbw-sibling-promo-card__title">' +
        escapeHtml(label) +
        '</span>' +
        subtitleHtml +
        '<span class="wbw-sibling-promo-card__cta">Explore <span aria-hidden="true">→</span></span>' +
        '</span></a>'
      );
    }

    function buildPromoListHtml(items) {
      var eyebrow = escapeHtml(siblingPromoEyebrow || 'Also available as');
      var venueName = items.length === 1 ? venueDisplayName(state.selectedVenue) : '';
      var cardsHtml = items
        .map(function (p) {
          var subtitle = venueName ? 'Available in ' + venueName : '';
          return buildPromoCardHtml(p, subtitle);
        })
        .join('');
      return (
        '<div class="wbw-sibling-promo-panel">' +
        '<p class="wbw-sibling-promo-panel__eyebrow">' +
        eyebrow +
        '</p>' +
        '<div class="wbw-sibling-promo-grid' +
        (items.length === 1 ? ' wbw-sibling-promo-grid--single' : '') +
        '">' +
        cardsHtml +
        '</div></div>'
      );
    }

    function getPromoNodes() {
      ensureSiblingPromoDom(wizardRoot, sectionId);
      var hosts = siblingPromoHosts(wizardRoot, sectionId);
      var host = null;
      var slot = wizardRoot.querySelector('[data-wbw-promo-slot]');
      if (slot) {
        host = slot.querySelector('[data-workshop-sibling-promo]');
      }
      if (!host && hosts.length) host = hosts[0];
      return {
        hosts: hosts,
        host: host,
        wrap: host && host.querySelector('[data-wbw-sibling-promo-wrap]'),
        list: host && host.querySelector('[data-wbw-sibling-promo-list]'),
      };
    }

    function applyPromoPanelState(hosts, show, listHtml) {
      (hosts || []).forEach(function (host) {
        if (!host) return;
        var wrap = host.querySelector('[data-wbw-sibling-promo-wrap]');
        var list = host.querySelector('[data-wbw-sibling-promo-list]');
        if (!wrap || !list) return;
        if (!show) {
          wrap.hidden = true;
          wrap.setAttribute('aria-hidden', 'true');
          list.innerHTML = '';
          return;
        }
        list.innerHTML = listHtml;
        wrap.hidden = false;
        wrap.setAttribute('aria-hidden', 'false');
      });
    }

    function syncSiblingWorkshopPromo() {
      var promoNodes = getPromoNodes();
      var hosts = promoNodes.hosts || [];
      var wrap = promoNodes.wrap;
      var list = promoNodes.list;
      var show =
        state.branch === 'variants' &&
        state.selectedVenue &&
        state.flow === 'booking' &&
        state.selectedSlot;
      var diagBase = {
        show: show,
        branch: state.branch,
        flow: state.flow,
        hasVenue: !!state.selectedVenue,
        hasSlot: !!state.selectedSlot,
        hostCount: hosts.length,
        hasWrap: !!wrap,
        hasList: !!list,
        slotAaLen:
          state.selectedSlot &&
          state.selectedSlot._raw &&
          Array.isArray(state.selectedSlot._raw.also_available_products)
            ? state.selectedSlot._raw.also_available_products.length
            : 0,
        venueEvents: state.selectedVenue && state.selectedVenue.events ? state.selectedVenue.events.length : 0,
        itemCount: 0,
      };
      if (!hosts.length || !wrap || !list) {
        diagBase.phase = 'no-promo-nodes';
        try {
          window.__wbwPromoDiag = diagBase;
        } catch (_diagErr0) {}
        return;
      }
      var step = stepEl('variants');
      if (step) {
        step.querySelectorAll('[data-wbw-also-available]').forEach(function (node) {
          node.remove();
        });
      }
      if (!show) {
        diagBase.phase = 'hidden';
        try {
          window.__wbwPromoDiag = diagBase;
        } catch (_diagErr1) {}
        applyPromoPanelState(hosts, false, '');
        return;
      }
      var items = collectPromoWorkshops();
      diagBase.itemCount = items.length;
      diagBase.phase = 'sync';
      try {
        window.__wbwPromoDiag = diagBase;
      } catch (_diagErr2) {}
      if (!items.length) {
        applyPromoPanelState(hosts, false, '');
        return;
      }
      applyPromoPanelState(hosts, true, buildPromoListHtml(items));
    }

    function getPriceContext(slot) {
      var raw = (slot && slot._raw) || {};
      var venue = state.selectedVenue || {};
      return {
        eventId: String(raw.id || raw.gid || (slot && slot.gid) || '').trim(),
        state: String(raw.state || venue.state || '').trim(),
        city: String(raw.city || venue.city || venue.city_name || '').trim(),
        cityKey: '',
        venueName: String(raw.venue_name || raw.venue || venue.venue_name || venue.name || '').trim(),
        venueHandle: String(raw.venue_handle || venue.venue_handle || '').trim(),
      };
    }

    function resolveVariantPriceCents(variant, slot) {
      if (variant && variant._isAddon) return Number(variant.price) || 0;
      var base = Number(variant && variant.price) || 0;
      if (!slot || typeof window.resolveWorkshopPrice !== 'function') return base;
      var ctx = getPriceContext(slot);
      try {
        return window.resolveWorkshopPrice({
          basePriceCents: base,
          eventId: ctx.eventId,
          state: ctx.state,
          city: ctx.city,
          cityKey: ctx.cityKey,
          venueName: ctx.venueName,
          venueHandle: ctx.venueHandle,
          variantId: String(variant.id),
          workshopId: productId,
        });
      } catch (_) {
        return base;
      }
    }

    function resolveVenueDisplayLabel(venue, card) {
      if (card) {
        var fromCard = String(card.getAttribute('data-wbw-city-label') || '').trim();
        if (fromCard) return fromCard;
      }
      if (!venue) return '';
      return String(venue.city_name || venue.city || venue.venue_name || venue.name || '').trim();
    }

    function resolveVenueLabelFromDeepLink() {
      if (state.venueDisplayLabel) return state.venueDisplayLabel;
      if (state.selectedVenueCard || state.selectedVenue) {
        var live = resolveVenueDisplayLabel(state.selectedVenue, state.selectedVenueCard);
        if (live) return live;
      }

      var venueToken = getVenueTokenFromUrl();
      var eventId = getEventIdFromUrl();
      if (!venueToken && !eventId) return '';

      var row = eventId ? findIndexRowByEventId(venueWorkshopIndexRows, eventId) : null;
      if (!row && venueToken) {
        var tokenNum = extractNumericVenueRefForUrl(venueToken);
        for (var ri = 0; ri < venueWorkshopIndexRows.length; ri++) {
          var indexRow = venueWorkshopIndexRows[ri];
          if (!indexRow) continue;
          if (extractNumericVenueRefForUrl(indexRow.venue_ref_id) === tokenNum) {
            row = indexRow;
            break;
          }
        }
      }
      if (row) return String(row.city || row.venue_name || '').trim();

      var catalogVenue = findCatalogVenueByToken(venueWaitlistCatalog, venueToken);
      if (catalogVenue) return String(catalogVenue.venue_name || '').trim();
      return '';
    }

    function venueLabelForWizard() {
      if (state.venueDisplayLabel) return state.venueDisplayLabel;
      var card = state.selectedVenueCard;
      if (card) {
        var fromCard = String(card.getAttribute('data-wbw-city-label') || '').trim();
        if (fromCard) return fromCard;
      }
      var v = state.selectedVenue;
      if (!v) return resolveVenueLabelFromDeepLink();
      return String(v.city_name || v.city || v.venue_name || v.name || '').trim();
    }

    var wbwCityDescLeadClass = 'wbw-city-desc-lead';
    var wbwCityDescAnchorPattern = /inspired patterns/i;

    function normalizeWorkshopLabel(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function isNodeAfter(anchor, node) {
      if (!anchor || !node) return false;
      return !!(anchor.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
    }

    function findWorkshopEyebrow(rte, baseTitle) {
      if (!rte) return null;
      var marked = rte.querySelector('[data-wbw-base-eyebrow]');
      if (marked) return marked;
      var baseNorm = normalizeWorkshopLabel(baseTitle);
      if (!baseNorm) return null;
      var nodes = rte.querySelectorAll('p, span, strong, em, label, h2, h3, h4, h5, h6');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var norm = normalizeWorkshopLabel(el.textContent);
        if (!norm || norm.length > 120) continue;
        if (norm === baseNorm) return el;
        if (
          baseNorm.length >= 10 &&
          norm.length >= 10 &&
          (norm.indexOf(baseNorm) >= 0 || baseNorm.indexOf(norm) >= 0)
        ) {
          return el;
        }
      }
      return null;
    }

    function syncWorkshopEyebrow(rte, baseTitle, city) {
      var el = findWorkshopEyebrow(rte, baseTitle);
      if (!el) return;
      if (!el.dataset.wbwBaseEyebrow) {
        el.dataset.wbwBaseEyebrow = String(el.textContent || '').trim();
      }
      var base = el.dataset.wbwBaseEyebrow;
      el.textContent = city ? base + ' in ' + city : base;
    }

    function findCityDescAnchor(rte, eyebrowEl) {
      if (!rte) return null;
      var paragraphs = rte.querySelectorAll('p');
      for (var i = 0; i < paragraphs.length; i++) {
        var p = paragraphs[i];
        if (p.classList.contains(wbwCityDescLeadClass)) continue;
        if (eyebrowEl && !isNodeAfter(eyebrowEl, p)) continue;
        var text = String(p.textContent || '').trim();
        if (text.length < 30) continue;
        if (/what you.ll do/i.test(text)) break;
        if (/^(duration|level|materials|take home)$/i.test(text)) continue;
        return p;
      }
      for (var j = 0; j < paragraphs.length; j++) {
        var legacy = paragraphs[j];
        if (legacy.classList.contains(wbwCityDescLeadClass)) continue;
        if (wbwCityDescAnchorPattern.test(String(legacy.textContent || ''))) return legacy;
      }
      for (var k = 0; k < paragraphs.length; k++) {
        var fallback = paragraphs[k];
        if (fallback.classList.contains(wbwCityDescLeadClass)) continue;
        if (String(fallback.textContent || '').trim().length >= 50) return fallback;
      }
      return null;
    }

    function placeCityDescLead(rte, lead, anchor) {
      if (!rte || !lead) return;
      if (anchor && anchor.parentNode) {
        if (lead.parentNode !== anchor.parentNode || lead.previousElementSibling !== anchor) {
          anchor.parentNode.insertBefore(lead, anchor.nextSibling);
        }
        return;
      }
      if (lead.parentNode !== rte) {
        rte.appendChild(lead);
      }
    }

    function updateProductVenueSeoCopy() {
      var baseTitle = String(wizardRoot.getAttribute('data-wbw-product-title') || '').trim();
      var sectionId = String(wizardRoot.getAttribute('data-section-id') || '').trim();
      var city = '';
      if (state.branch !== 'venue') {
        city = venueLabelForWizard() || resolveVenueLabelFromDeepLink();
      }
      var productRoot = sectionId ? document.querySelector('.main-product-' + sectionId) : null;

      if (baseTitle && productRoot) {
        var titleEl = productRoot.querySelector('.product-title');
        if (titleEl) {
          titleEl.textContent = city ? baseTitle + ' in ' + city : baseTitle;
        }
      }

      if (!sectionId) return;

      var rte = document.querySelector('#product-description-block-' + sectionId + ' .rte');
      if (!rte) return;

      var lead = rte.querySelector('.' + wbwCityDescLeadClass);
      if (!city) {
        if (lead) lead.remove();
        syncWorkshopEyebrow(rte, baseTitle, '');
        return;
      }

      syncWorkshopEyebrow(rte, baseTitle, city);

      var leadText = 'Join us in ' + city + ' for this hands-on workshop experience.';
      var eyebrow = findWorkshopEyebrow(rte, baseTitle);
      var anchor = findCityDescAnchor(rte, eyebrow);

      if (!lead) {
        lead = document.createElement('p');
        lead.className = wbwCityDescLeadClass;
        lead.textContent = leadText;
        placeCityDescLead(rte, lead, anchor);
        return;
      }

      lead.textContent = leadText;
      placeCityDescLead(rte, lead, anchor);
    }

    function updateBranchTitles() {
      var vn = venueLabelForWizard() || resolveVenueLabelFromDeepLink();
      var dt = stepEl('datetime');
      if (dt) {
        var calTitle = dt.querySelector('[data-wbw-cal-title]');
        if (calTitle) {
          calTitle.textContent = vn
            ? 'Select an Event Date for ' + vn
            : 'Select an Event Date';
        }
      }
      var wl = stepEl('waitlist');
      if (wl) {
        var wlTitle = wl.querySelector('[data-wbw-wl-title]');
        if (wlTitle) {
          wlTitle.textContent = vn
            ? 'No workshops scheduled for ' + vn + ' yet'
            : 'No workshops scheduled yet';
        }
      }
    }

    function findVenueCardByRef(refId) {
      var want = String(refId || '').trim();
      if (!want || !eventsRoot) return null;
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var cref = String((c && c.getAttribute && c.getAttribute('data-venue-ref-id')) || '').trim();
        if (cref && cref === want) return c;
        if (c && c._wbVenue && String(c._wbVenue.venue_ref_id || '').trim() === want) return c;
      }
      return null;
    }

    /** Keep selection after venue list re-render (geo / refetch wipes DOM nodes). */
    function rebindSelectedVenueCard() {
      if (!state.selectedVenue) return null;
      var card = state.selectedVenueCard;
      if (card && eventsRoot && eventsRoot.contains(card) && card._wbVenue) return card;
      var ref = String(state.selectedVenue.venue_ref_id || '').trim();
      var next = findVenueCardByRef(ref);
      if (!next || !next._wbVenue) return null;
      var prev = state.selectedVenue;
      state.selectedVenueCard = next;
      state.selectedVenue = next._wbVenue;
      if (prev && prev !== state.selectedVenue) {
        if (Array.isArray(prev.events) && prev.events.length) {
          if (!Array.isArray(state.selectedVenue.events) || !state.selectedVenue.events.length) {
            state.selectedVenue.events = prev.events;
          }
        }
        if (prev._wbLoadedMonths) {
          if (!state.selectedVenue._wbLoadedMonths) {
            state.selectedVenue._wbLoadedMonths = Object.create(null);
          }
          Object.keys(prev._wbLoadedMonths).forEach(function (ym) {
            state.selectedVenue._wbLoadedMonths[ym] = true;
          });
        }
      }
      if (state.selectedVenue.has_events !== true && state.flow !== 'waitlist') {
        state.flow = venueIsWaitlistOnly(state.selectedVenue, next) ? 'waitlist' : 'booking';
        wizardRoot.setAttribute('data-wbw-flow', state.flow);
      }
      next.classList.add('wbw-venue-selected');
      next.setAttribute('aria-pressed', 'true');
      return next;
    }

    function setDatetimeCalLoading(isLoading, message) {
      var step = stepEl('datetime');
      if (!step) return;
      var block = step.querySelector('.wcf-cal-block');
      if (!block) return;
      var on = !!isLoading;
      block.classList.toggle('is-cal-loading', on);
      block.setAttribute('aria-busy', on ? 'true' : 'false');
      var sheet = block.querySelector('.wcf-cal-sheet') || block;
      var overlay = sheet.querySelector('[data-wbw-cal-loading]');
      if (on) {
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'wcf-cal-loading-overlay';
          overlay.setAttribute('data-wbw-cal-loading', '1');
          overlay.setAttribute('role', 'status');
          sheet.appendChild(overlay);
        }
        overlay.textContent = message || 'Loading dates\u2026';
        overlay.hidden = false;
        overlay.classList.toggle('is-error', !!message && message !== 'Loading dates\u2026');
      } else if (overlay) {
        overlay.hidden = true;
        overlay.classList.remove('is-error');
      }
    }

    function updateVenueContinue() {
      var btn = wizardRoot.querySelector('[data-wbw-action="to-next"]');
      if (!btn) return;
      rebindSelectedVenueCard();
      var valid =
        !!state.selectedVenue &&
        state.flow !== 'waitlist' &&
        state.selectedVenue.has_events === true &&
        !!String(state.selectedVenue.venue_ref_id || '').trim();
      btn.disabled = !valid;
    }

    function syncVenueFlipState() {
      if (!eventsRoot) return;
      eventsRoot.querySelectorAll('.wbw-venue-flip-card').forEach(function (c) {
        c.classList.remove('wbw-venue-flipped');
      });
      var card = state.selectedVenueCard;
      if (
        card &&
        card.classList &&
        card.classList.contains('wbw-venue-flip-card') &&
        card.classList.contains('wbw-venue-selected') &&
        state.flow === 'waitlist'
      ) {
        card.classList.add('wbw-venue-flipped');
      }
    }

    function closeWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
    }

    function openWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      var vn = venueLabelForWizard();
      var title = modal.querySelector('[data-wbw-wl-modal-title]');
      if (title) {
        title.textContent = vn
          ? 'No workshops scheduled for ' + vn + ' yet'
          : 'No workshops scheduled yet';
      }
      var err = modal.querySelector('[data-wbw-wl-modal-error]');
      var ok = modal.querySelector('[data-wbw-wl-modal-success]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      if (ok) ok.hidden = true;
      ['[data-wbw-wl-modal-name]', '[data-wbw-wl-modal-email]', '[data-wbw-wl-modal-notes]'].forEach(function (sel) {
        var el = modal.querySelector(sel);
        if (el) el.value = '';
      });
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      var nameIn = modal.querySelector('[data-wbw-wl-modal-name]');
      try {
        if (nameIn) nameIn.focus();
      } catch (_) {}
    }

    function wbwEmitVenueMapSelection(venue) {
      if (!venue || typeof venue !== 'object') return;
      var lat = venue.venue_lat != null ? venue.venue_lat : venue.lat != null ? venue.lat : venue.latitude;
      var lng = venue.venue_lng != null ? venue.venue_lng : venue.lng != null ? venue.lng : venue.longitude;
      lat = lat != null && lat !== '' ? Number(lat) : NaN;
      lng = lng != null && lng !== '' ? Number(lng) : NaN;
      var detail = {
        title: String(venue.venue_name || venue.name || venue.city_name || '').trim(),
        address: String(venue.venue_address || venue.address || '').trim(),
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
      };
      if (!detail.title && !detail.address && detail.lat == null) return;
      try {
        document.dispatchEvent(new CustomEvent('wbw:venue-selected', { detail: detail }));
      } catch (_) {}
    }

    function clearVenueSelection(options) {
      options = options || {};
      state.selectedVenueCard = null;
      state.selectedVenue = null;
      state.flow = 'booking';
      state.slotList = [];
      state.selectedDate = '';
      state.selectedSlot = null;
      if (!options.preserveVenueLabel) state.venueDisplayLabel = '';
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = false;
      if (!options.preserveUrl) {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        wizardRoot.__wbwUserReachedDatetime = false;
      }
      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      closeWizardWaitlistModal();
      if (!options.preserveUrl) {
        var urlPatch = { venue: '', eventId: '' };
        if (state.lockedVariantId) urlPatch.variantId = state.lockedVariantId;
        updateWizardBookingUrl(urlPatch);
      }
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncVenueKindAttr();
      syncSiblingWorkshopPromo();
      updateProductVenueSeoCopy();
    }

    function onVenueResetEvent(e) {
      var detail = (e && e.detail) || {};
      if (detail.bookingRoot && bookingRoot && detail.bookingRoot !== bookingRoot) return;
      /* Inventory search recenter / filter re-render must not re-arm URL auto-advance. */
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) {
        if (state.branch === 'datetime' || state.branch === 'variants') return;
        clearVenueSelection({ preserveUrl: true, preserveVenueLabel: true });
        return;
      }
      /* Places proximity search: never re-arm URL deep-link (would jump back to ?venue=). */
      var locSource =
        (typeof window !== 'undefined' &&
          window.__WORKSHOP_LOCATION__ &&
          window.__WORKSHOP_LOCATION__.source) ||
        '';
      if (locSource === 'places') {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        if (state.branch === 'datetime' || state.branch === 'variants') return;
        clearVenueSelection();
        return;
      }
      if (urlHasWizardDeepLink() && !wizardRoot.__wbwUserReachedDatetime) {
        wizardRoot.__wbwUrlDeepLinkComplete = false;
        if (state.branch === 'waitlist') {
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
          setBranch('venue');
        }
        clearVenueSelection({ preserveUrl: true, preserveVenueLabel: true });
        return;
      }
      clearVenueSelection();
    }

    function selectVenueCard(card, options) {
      if (!card) return;
      var venue = card._wbVenue;
      if (!venue) return;

      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('wbw-venue-selected');
      card.setAttribute('aria-pressed', 'true');
      state.selectedVenueCard = card;
      state.selectedVenue = venue;
      state.venueDisplayLabel = resolveVenueDisplayLabel(venue, card);
      state.flow = venueIsWaitlistOnly(venue, card) ? 'waitlist' : 'booking';
      wizardRoot.setAttribute('data-wbw-flow', state.flow);
      syncVenueKindAttr();
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = true;
      wbwEmitVenueMapSelection(venue);
      syncVenueFlipState();
      /* Do not write ?venue= on Step 1 select — only when entering datetime. */
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncSiblingWorkshopPromo();
      if (options && options.updatePageCopy) updateProductVenueSeoCopy();
    }

    function bindVenueSelection() {
      if (!eventsRoot) return;
      eventsRoot.addEventListener('click', function (e) {
        if (e.target.closest('[data-wbw-wl-signup]')) {
          e.preventDefault();
          e.stopPropagation();
          var wlCard = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
          if (wlCard && wlCard._wbVenue) selectVenueCard(wlCard, { updatePageCopy: true });
          openWizardWaitlistModal();
          return;
        }
        if (e.target.closest('[data-wb-waitlist-open]')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        var card = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
        if (!card || !wizardRoot.contains(card)) return;
        if (!card._wbVenue) return;
        e.preventDefault();
        activateVenueCard(card);
      });
      eventsRoot.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.wb-venue-pick-card[role="button"], .wb-venue-card[role="button"]');
        if (!card || !wizardRoot.contains(card) || !card._wbVenue) return;
        if (e.target.closest('[data-wbw-wl-signup]')) return;
        e.preventDefault();
        activateVenueCard(card);
      });
      wizardRoot.querySelectorAll('[data-wbw-wl-modal-dismiss]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeWizardWaitlistModal();
        });
      });
      document.addEventListener('wbw:open-waitlist-modal', function (e) {
        var d = (e && e.detail) || {};
        if (d.bookingRoot && bookingRoot && d.bookingRoot !== bookingRoot) return;
        openWizardWaitlistModal();
      });
    }

    function slotsForDate(dateKey) {
      return state.slotList.filter(function (s) {
        return slotDateKey(s) === dateKey;
      });
    }

    /** Keep the user's calendar day/time across background enrich/live refreshes. */
    function applyDatetimeSelectionAfterSlots(opts) {
      opts = opts || {};
      var priorDate = opts.priorDate != null ? String(opts.priorDate || '') : String(state.selectedDate || '');
      var priorGid =
        opts.priorGid != null
          ? String(opts.priorGid || '')
          : state.selectedSlot && state.selectedSlot.gid
            ? String(state.selectedSlot.gid)
            : '';
      var deepLinkSlot = opts.deepLinkSlot || null;
      var allowDeepLink = opts.allowDeepLink === true && !state._wbwUserPickedCalDate;

      state.daysWithEvents = buildDaysMap(state.slotList);
      var keys = Object.keys(state.daysWithEvents).sort();

      if (allowDeepLink && deepLinkSlot && slotVisible(deepLinkSlot)) {
        state.selectedDate = slotDateKey(deepLinkSlot);
        state.selectedSlot = deepLinkSlot;
      } else if (priorDate && state.daysWithEvents[priorDate]) {
        state.selectedDate = priorDate;
        state.selectedSlot = null;
        if (priorGid) {
          var daySlots = slotsForDate(priorDate);
          for (var i = 0; i < daySlots.length; i++) {
            if (String(daySlots[i].gid || '') === priorGid && slotVisible(daySlots[i])) {
              state.selectedSlot = daySlots[i];
              break;
            }
          }
        }
      } else if (state._wbwUserPickedCalDate && priorDate) {
        /* User day missing from map — keep selection; do not snap to keys[0]. */
        state.selectedDate = priorDate;
        state.selectedSlot = null;
      } else if (keys.length) {
        state.selectedDate = keys[0];
        state.selectedSlot = null;
      } else {
        state.selectedDate = '';
        state.selectedSlot = null;
      }

      if (opts.syncViewMonth && state.selectedDate) {
        var parts = state.selectedDate.split('-').map(Number);
        if (parts.length >= 2) state.viewMonth = new Date(parts[0], parts[1] - 1, 1);
      }
    }

    function renderCalendar(opts) {
      opts = opts || {};
      var step = stepEl('datetime');
      if (!step) return;
      var y = state.viewMonth.getFullYear();
      var m = state.viewMonth.getMonth();
      var label = step.querySelector('[data-wbw-cal-month-label]');
      if (label) label.textContent = MONTHS[m] + ' ' + y;

      var dowEl = step.querySelector('[data-wbw-cal-dow]');
      if (dowEl) {
        dowEl.innerHTML = calendarDowLabels()
          .map(function (d) {
            return '<span class="wcf-cal-dow">' + d + '</span>';
          })
          .join('');
      }

      var grid = step.querySelector('[data-wbw-cal-grid]');
      if (!grid) return;
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
      for (var d = 1; d <= daysInMonth; d++) {
        var key = calDateKey(y, m, d);
        var info = state.daysWithEvents[key];
        var cls = 'wcf-cal-day';
        if (!info) cls += ' wcf-cal-day--muted';
        else {
          cls += ' wcf-cal-day--has-event';
          if (!info.bookable) cls += ' wcf-cal-day--soldout-only';
        }
        if (state.selectedDate === key) cls += ' wcf-cal-day--selected';
        var disabled = !info ? ' disabled' : '';
        html +=
          '<span class="wcf-cal-day-wrap"><button type="button" class="' +
          cls +
          '" data-wbw-cal-day="' +
          key +
          '"' +
          disabled +
          '>' +
          d +
          '</button></span>';
      }
      grid.innerHTML = html;
      renderTimeOptions(opts);
    }

    function loadCalendarMonthForView() {
      if (!state.selectedVenue) {
        setDatetimeCalLoading(false);
        renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
        return Promise.resolve();
      }
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return Promise.reject(new Error('venue calendar fetch unavailable'));
      }
      state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
      var loadSeq = state._wbCalLoadSeq;
      var hasLocal =
        Array.isArray(state.selectedVenue.events) && state.selectedVenue.events.length > 0;
      if (hasLocal) {
        state.slotList = eventsToSlots(state.selectedVenue.events || []);
        state.daysWithEvents = buildDaysMap(state.slotList);
      }
      renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
      setDatetimeCalLoading(!hasLocal);
      return bookingRoot
        .__wbEnsureVenueCalendar(state.selectedVenue, state.viewMonth, { lookahead: 0, prefetch: true })
        .then(function () {
          if (loadSeq !== state._wbCalLoadSeq) return;
          var paintedSlots = Array.isArray(state.slotList) ? state.slotList.slice() : [];
          var slots = eventsToSlots(state.selectedVenue.events || []);
          if (!slots.length && paintedSlots.length) {
            state.slotList = paintedSlots;
            state.daysWithEvents = buildDaysMap(state.slotList);
            syncSelectedVenueEventsFromSlots(state.slotList);
            setDatetimeCalLoading(false);
            renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
            ensureLivePoll();
            return state.slotList;
          }
          return enrichSlotsForCurrentVenue(slots).then(function (fresh) {
            if (loadSeq !== state._wbCalLoadSeq) return state.slotList;
            if (!Array.isArray(fresh)) throw new Error('live enrich failed');
            if (!fresh.length && paintedSlots.length) {
              state.slotList = paintedSlots;
              state.daysWithEvents = buildDaysMap(state.slotList);
              syncSelectedVenueEventsFromSlots(state.slotList);
              setDatetimeCalLoading(false);
              renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
              ensureLivePoll();
              return state.slotList;
            }
            state.slotList = fresh;
            syncSelectedVenueEventsFromSlots(state.slotList);
            applyDatetimeSelectionAfterSlots({
              priorDate: state.selectedDate,
              priorGid: state.selectedSlot && state.selectedSlot.gid,
              allowDeepLink: false,
              syncViewMonth: false,
            });
            setDatetimeCalLoading(false);
            renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
            ensureLivePoll();
            return state.slotList;
          });
        })
        .catch(function (err) {
          if (loadSeq !== state._wbCalLoadSeq) return;
          if (err && err.name === 'AbortError') {
            setDatetimeCalLoading(false);
            return;
          }
          var msg =
            err && err.message === 'bad_request'
              ? 'Invalid date range. Try another month.'
              : "Couldn't load dates. Try again.";
          setDatetimeCalLoading(true, msg);
        });
    }

    var timeDdOpenedAtMs = 0;

    function closeCalTimeDd() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts) return;
      if (parts.panel) {
        parts.panel.hidden = true;
        parts.panel.setAttribute('hidden', '');
        resetTimeDdPanelStyle(parts.panel);
        parts.dd.appendChild(parts.panel);
      }
      if (parts.btn) parts.btn.setAttribute('aria-expanded', 'false');
      parts.dd.classList.remove('is-open');
    }

    function openCalTimeDd(opts) {
      opts = opts || {};
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || !parts.panel || !parts.btn || parts.btn.disabled) return;
      bindTimeDdReposition(wizardRoot);
      ensureTimeDdPortal().appendChild(parts.panel);
      parts.panel.hidden = false;
      parts.panel.removeAttribute('hidden');
      parts.btn.setAttribute('aria-expanded', 'true');
      parts.dd.classList.add('is-open');
      /* Soft/background reopen must not reset the outside-click grace window. */
      if (!opts.keepOpenStamp) timeDdOpenedAtMs = Date.now();
      positionTimeDdPanel(parts);
      var selected = parts.panel.querySelector('.wcf-cal-time__dd-opt.is-selected');
      if (selected && typeof selected.scrollIntoView === 'function') {
        selected.scrollIntoView({ block: 'nearest' });
      }
    }

    var lastTimeCueDate = '';

    function syncCalTimeAwaitingCue(step) {
      if (!step) return;
      var dd = step.querySelector('[data-wbw-cal-time-dd]');
      var select = step.querySelector('[data-wbw-time-select]');
      var calTime = step.querySelector('[data-wbw-cal-time]');
      var awaiting = !!(
        state.selectedDate &&
        select &&
        !select.disabled &&
        !String(select.value || '').trim()
      );

      if (dd) {
        if (awaiting) {
          if (lastTimeCueDate !== state.selectedDate) {
            lastTimeCueDate = state.selectedDate;
            dd.classList.remove('is-awaiting-time');
            void dd.offsetWidth;
          }
          dd.classList.add('is-awaiting-time');
        } else {
          if (!state.selectedDate) lastTimeCueDate = '';
          dd.classList.remove('is-awaiting-time');
        }
      }
      if (calTime) calTime.classList.toggle('is-awaiting-time', awaiting);
    }

    function syncCalTimeDdFromSelect(step) {
      var dd = step && step.querySelector('[data-wbw-cal-time-dd]');
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (!dd || !select) return;

      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || parts.dd !== dd) return;
      var btn = parts.btn;
      var panel = parts.panel;
      if (!btn || !panel) return;

      btn.disabled = select.disabled;
      var selectedOpt = select.options[select.selectedIndex];
      var hasValue = !!select.value;
      btn.textContent =
        hasValue && selectedOpt && selectedOpt.textContent
          ? selectedOpt.textContent
          : 'Select a time';
      btn.classList.toggle('is-placeholder', !hasValue);
      syncCalTimeAwaitingCue(step);

      panel.innerHTML = '';

      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (!opt.value) continue;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'wcf-cal-time__dd-opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-gid', opt.value);
        item.textContent = opt.textContent;
        if (opt.selected) item.classList.add('is-selected');
        if (/sold out/i.test(opt.textContent)) item.classList.add('is-soldout');
        item.addEventListener('mousedown', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        });
        item.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var gid = ev.currentTarget.getAttribute('data-gid');
          if (!gid) return;
          select.value = gid;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeCalTimeDd();
        });
        panel.appendChild(item);
      }
      if (!panel.__wbwPanelClickStop) {
        panel.__wbwPanelClickStop = true;
        panel.addEventListener('click', function (ev) {
          ev.stopPropagation();
        });
        panel.addEventListener('mousedown', function (ev) {
          ev.stopPropagation();
        });
      }
    }

    function onTimeSelectChange() {
      var step = stepEl('datetime');
      if (!step) return;
      var select = step.querySelector('[data-wbw-time-select]');
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      if (!select) return;

      var gid = String(select.value || '').trim();
      if (!gid) {
        state.selectedSlot = null;
        if (toBtn) toBtn.disabled = true;
        clearBookingUrlEventIdKeepVariant();
        syncCalTimeDdFromSelect(step);
        syncCapacityRing();
        return;
      }

      var daySlots = slotsForDate(state.selectedDate);
      var slot = null;
      for (var i = 0; i < daySlots.length; i++) {
        if (daySlots[i].gid === gid) {
          slot = daySlots[i];
          break;
        }
      }
      if (!slot || !slotVisible(slot)) {
        state.selectedSlot = null;
        if (toBtn) toBtn.disabled = true;
        syncCalTimeDdFromSelect(step);
        syncCapacityRing();
        return;
      }

      state.selectedSlot = slot;
      if (!slotBookable(slot)) {
        if (toBtn) toBtn.disabled = true;
      } else {
        if (toBtn) toBtn.disabled = false;
        syncWorkshopSelection(slot);
      }
      syncCalTimeDdFromSelect(step);
      syncCapacityRing();
    }

    function renderCalTimeNativeSelect(step, daySlots, opts) {
      opts = opts || {};
      var select = step.querySelector('[data-wbw-time-select]');
      if (!select) return;

      if (!state.selectedDate) {
        select.disabled = true;
        select.innerHTML = '<option value="">Select a date first</option>';
        return;
      }

      select.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = daySlots.length ? 'Select a time' : 'No sessions this day';
      select.appendChild(placeholder);

      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.gid || '';
        opt.textContent = formatSlotOptionText(slot);
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) opt.selected = true;
        select.appendChild(opt);
      });

      select.disabled = !daySlots.length;

      /* Only user-driven date entry may auto-pick a lone time — never background soft refresh. */
      if (opts.allowAutoSelectSingle === true && !state.selectedSlot && daySlots.length === 1) {
        select.value = daySlots[0].gid || '';
        onTimeSelectChange();
      }
    }

    function renderTimeOptions(opts) {
      opts = opts || {};
      var step = stepEl('datetime');
      if (!step) return;
      var hint = step.querySelector('[data-wbw-cal-time-hint]');
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      var daySlots = slotsForDate(state.selectedDate).filter(slotVisible);
      var hasBookableSlots = daySlots.some(slotBookable);
      var wasOpen = isCalTimeDdOpen();
      /* Default: background refreshes must NOT close an open time dropdown. */
      var shouldClose = opts.closeTimeDd === true;
      var allowAuto =
        opts.allowAutoSelectSingle === true || (opts.closeTimeDd === true && opts.allowAutoSelectSingle !== false);

      renderCalTimeNativeSelect(step, daySlots, { allowAutoSelectSingle: allowAuto });
      syncCalTimeDdFromSelect(step);
      if (shouldClose) {
        closeCalTimeDd();
      } else if (wasOpen) {
        openCalTimeDd({ keepOpenStamp: true });
      }

      if (hint) {
        if (state.selectedDate && !daySlots.length) {
          hint.textContent = 'Pick another date with a bold number.';
          hint.hidden = false;
        } else if (state.selectedDate && daySlots.length && !hasBookableSlots) {
          hint.textContent = '';
          hint.hidden = true;
        } else {
          hint.textContent = '';
          hint.hidden = true;
        }
      }

      if (!state.selectedSlot) {
        if (toBtn) toBtn.disabled = true;
      } else if (!slotBookable(state.selectedSlot)) {
        if (toBtn) toBtn.disabled = true;
      } else if (toBtn) {
        toBtn.disabled = false;
      }
      syncCalTimeAwaitingCue(step);
      syncCapacityRing();
    }

    function bindCalTimeControls() {
      var step = stepEl('datetime');
      if (!step) return;
      var select = step.querySelector('[data-wbw-time-select]');
      if (select && !select.__wbwTimeBound) {
        select.__wbwTimeBound = true;
        select.addEventListener('change', onTimeSelectChange);
      }

      var dd = step.querySelector('[data-wbw-cal-time-dd]');
      if (!dd || dd.__wbwDdBound) return;
      dd.__wbwDdBound = true;
      var btn = dd.querySelector('[data-wbw-cal-time-dd-btn]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parts = getCalTimeDdParts(wizardRoot);
        if (parts && parts.panel && !parts.panel.hidden) closeCalTimeDd();
        else openCalTimeDd();
      });

      if (!wizardRoot.__wbwCalTimeDdDocClose) {
        wizardRoot.__wbwCalTimeDdDocClose = true;
        document.addEventListener('click', function (e) {
          var parts = getCalTimeDdParts(wizardRoot);
          if (!parts || !parts.dd.classList.contains('is-open')) return;
          /* Same-click / immediate re-entry after open must not close the menu. */
          if (timeDdOpenedAtMs && Date.now() - timeDdOpenedAtMs < 200) return;
          if (e.target.closest('[data-wbw-cal-time-dd]')) return;
          if (e.target.closest('[data-wbw-time-dd-portal]')) return;
          closeCalTimeDd();
        });
      }
    }

    function syncWorkshopSelection(slot) {
      if (!slot) return;
      var raw = slot._raw || {};
      var eventId = String(raw.id || raw.gid || slot.gid || '').trim();
      var eventHandle = String(raw.handle || slot.handle || '').trim();
      window.__WORKSHOP_SELECTION__ = {
        eventId: eventId,
        eventHandle: eventHandle,
        city: String(raw.city || '').trim(),
        state: String(raw.state || '').trim(),
        venue: String(raw.venue_name || raw.venue || (state.selectedVenue && state.selectedVenue.venue_name) || '').trim(),
        datetime: formatBookingSubLabel(slot),
      };
      try {
        document.dispatchEvent(new CustomEvent('wb:selection', { detail: window.__WORKSHOP_SELECTION__ }));
      } catch (_) {}
      syncBookingUrlForDatetimeStep(slot);
      window.__WB_INITIAL_EVENT_ID__ = null;
    }

    function startWaitlistStep() {
      var step = stepEl('waitlist');
      if (!step) return;
      updateBranchTitles();
      var err = step.querySelector('[data-wbw-wl-error]');
      var ok = step.querySelector('[data-wbw-wl-success]');
      if (err) err.hidden = true;
      if (ok) ok.hidden = true;
      setBranch('waitlist');
    }

    function startDatetimeStep() {
      rebindSelectedVenueCard();
      if (!state.selectedVenue) return Promise.resolve();
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return Promise.reject(new Error('venue calendar fetch unavailable'));
      }
      if (!state.selectedVenue.venue_ref_id) {
        return Promise.reject(new Error('venue_ref_id missing'));
      }
      if (state.selectedVenue.has_events !== true) {
        return Promise.reject(new Error('venue has_events is not true'));
      }
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = true;
      /* Prevent search/list re-renders from re-triggering URL deep-link advance. */
      wizardRoot.__wbwUrlDeepLinkComplete = true;
      wizardRoot.__wbwUserReachedDatetime = true;
      state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
      var loadSeq = state._wbCalLoadSeq;
      var viewSeed = state.viewMonth instanceof Date ? state.viewMonth : new Date();
      if (
        state.selectedVenue.next_date_key &&
        /^\d{4}-\d{2}/.test(String(state.selectedVenue.next_date_key))
      ) {
        var nd = String(state.selectedVenue.next_date_key);
        viewSeed = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }
      state.viewMonth = viewSeed;

      state.flow = 'booking';
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      state._wbwUserPickedCalDate = false;
      state.selectedDate = '';
      state.selectedSlot = null;
      updateBranchTitles();
      syncBookingUrlForVenueStep(state.selectedVenue);
      setBranch('datetime');

      function stillOnDatetimeIntent() {
        return loadSeq === state._wbCalLoadSeq && state.branch === 'datetime';
      }

      var hasLocal =
        Array.isArray(state.selectedVenue.events) && state.selectedVenue.events.length > 0;
      if (hasLocal) {
        state.slotList = eventsToSlots(state.selectedVenue.events || []);
        state.daysWithEvents = buildDaysMap(state.slotList);
        var localKeys = Object.keys(state.daysWithEvents).sort();
        if (localKeys.length) {
          state.selectedDate = localKeys[0];
          var lp = localKeys[0].split('-').map(Number);
          if (lp.length >= 2) state.viewMonth = new Date(lp[0], lp[1] - 1, 1);
        }
      } else {
        state.slotList = [];
        state.daysWithEvents = {};
      }
      renderCalendar({ allowAutoSelectSingle: true });
      setDatetimeCalLoading(!hasLocal);

      return bookingRoot
        .__wbEnsureVenueCalendar(state.selectedVenue, state.viewMonth, { lookahead: 1, prefetch: true })
        .then(function () {
          if (!stillOnDatetimeIntent()) return;
          var paintedSlots = Array.isArray(state.slotList) ? state.slotList.slice() : [];
          rebindSelectedVenueCard();
          if (!state.selectedVenue) return;
          var baseSlots = eventsToSlots(state.selectedVenue.events || []);
          if (!baseSlots.length && paintedSlots.length) {
            /* Calendar window came back empty — keep the sessions already painted from discovery. */
            state.slotList = paintedSlots;
            state.daysWithEvents = buildDaysMap(state.slotList);
            syncSelectedVenueEventsFromSlots(state.slotList);
            setDatetimeCalLoading(false);
            renderCalendar({
              closeTimeDd: false,
              allowAutoSelectSingle: !state._wbwUserPickedCalDate,
            });
            ensureLivePoll();
            return state.slotList;
          }
          if (!baseSlots.length) {
            state.slotList = [];
            state.daysWithEvents = {};
            state.selectedDate = '';
            state.selectedSlot = null;
            setDatetimeCalLoading(false);
            renderCalendar({ closeTimeDd: true, allowAutoSelectSingle: false });
            return state.slotList;
          }
          return enrichSlotsForCurrentVenue(baseSlots).then(function (freshSlots) {
            if (!stillOnDatetimeIntent()) return state.slotList;
            if (!Array.isArray(freshSlots)) throw new Error('live enrich failed');
            if (!freshSlots.length && paintedSlots.length) {
              state.slotList = paintedSlots;
              state.daysWithEvents = buildDaysMap(state.slotList);
              syncSelectedVenueEventsFromSlots(state.slotList);
              setDatetimeCalLoading(false);
              renderCalendar({
                closeTimeDd: false,
                allowAutoSelectSingle: !state._wbwUserPickedCalDate,
              });
              ensureLivePoll();
              return state.slotList;
            }
            state.slotList = freshSlots;
            syncSelectedVenueEventsFromSlots(state.slotList);

            var deepLinkEventId = getEventIdFromUrl();
            if (deepLinkEventId) {
              deepLinkEventId = resolveDeepLinkEventId(deepLinkEventId, getVenueTokenFromUrl());
            }
            var deepLinkSlot = deepLinkEventId ? findSlotByEventId(deepLinkEventId) : null;

            applyDatetimeSelectionAfterSlots({
              priorDate: state.selectedDate,
              priorGid: state.selectedSlot && state.selectedSlot.gid,
              deepLinkSlot: deepLinkSlot,
              allowDeepLink: true,
              syncViewMonth: !state._wbwUserPickedCalDate,
            });
            setDatetimeCalLoading(false);
            renderCalendar({
              closeTimeDd: false,
              allowAutoSelectSingle: !state._wbwUserPickedCalDate,
            });
            ensureLivePoll();
            return state.slotList;
          });
        })
        .catch(function (err) {
          if (!stillOnDatetimeIntent()) return;
          if (err && err.name === 'AbortError') {
            setDatetimeCalLoading(false);
            return;
          }
          var msg =
            err && err.message === 'bad_request'
              ? 'Invalid date range. Try another month.'
              : "Couldn't load dates. Try again.";
          setDatetimeCalLoading(true, msg);
        });
    }

    function goToNextFromVenue() {
      rebindSelectedVenueCard();
      if (!state.selectedVenue || !String(state.selectedVenue.venue_ref_id || '').trim()) {
        clearVenueSelection();
        return;
      }
      if (state.flow === 'waitlist' || state.selectedVenue.has_events !== true) return;
      var start = isStoreVenue(state.selectedVenue) ? startDatetimeStep : startPopupBookingStep;
      return Promise.resolve()
        .then(function () {
          return start();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          try {
            console.warn('[wbw] continue from venue failed', err);
          } catch (_) {}
          if (isStoreVenue(state.selectedVenue)) {
            setDatetimeCalLoading(true, "Couldn't load dates. Try again.");
          } else {
            setPopupDatetimeLoading(false);
            setPopupDatetimeHint("Couldn't load dates. Try again.", true);
          }
        });
    }

    function popupDateSelect() {
      return wizardRoot.querySelector('[data-wbw-popup-date]');
    }

    function popupTimeSelect() {
      return wizardRoot.querySelector('[data-wbw-popup-time]');
    }

    function popupDatetimePanel() {
      return wizardRoot.querySelector('[data-wbw-popup-datetime]');
    }

    function setPopupDatetimeHint(msg, isError) {
      var hint = wizardRoot.querySelector('[data-wbw-popup-datetime-hint]');
      if (!hint) return;
      if (!msg) {
        hint.hidden = true;
        hint.textContent = '';
        hint.classList.remove('is-error');
        return;
      }
      hint.hidden = false;
      hint.textContent = msg;
      hint.classList.toggle('is-error', !!isError);
    }

    function setPopupDatetimeLoading(on) {
      var panel = popupDatetimePanel();
      if (!panel) return;
      panel.classList.toggle('is-loading', !!on);
      panel.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function uniquePopupDateKeys() {
      var map = Object.create(null);
      (state.slotList || []).forEach(function (s) {
        if (!s || slotHidden(s)) return;
        var dk = slotDateKey(s);
        if (dk) map[dk] = true;
      });
      return Object.keys(map).sort();
    }

    function syncPopupDatetimePanel() {
      var panel = popupDatetimePanel();
      if (!panel) return;
      var show =
        state.branch === 'variants' &&
        state.flow === 'booking' &&
        state.selectedVenue &&
        !isStoreVenue(state.selectedVenue);
      if (show) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
      } else {
        panel.hidden = true;
        panel.setAttribute('hidden', '');
      }
    }

    function fillPopupDateSelect(preferredDate) {
      var sel = popupDateSelect();
      if (!sel) return;
      var keys = uniquePopupDateKeys();
      var keep = preferredDate && keys.indexOf(preferredDate) >= 0 ? preferredDate : '';
      sel.innerHTML = '<option value="">Select Workshop Date</option>';
      keys.forEach(function (dk) {
        var opt = document.createElement('option');
        opt.value = dk;
        opt.textContent = formatPopupDateLabel(dk);
        sel.appendChild(opt);
      });
      sel.value = keep || '';
      sel.disabled = keys.length === 0;
    }

    function fillPopupTimeSelect(dateKey, preferredGid) {
      var sel = popupTimeSelect();
      if (!sel) return;
      sel.innerHTML = '<option value="">Select Session Time</option>';
      if (!dateKey) {
        sel.value = '';
        sel.disabled = true;
        return;
      }
      var daySlots = slotsForDate(dateKey).filter(function (s) {
        return s && !slotHidden(s);
      });
      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = String(slot.gid || '');
        opt.textContent = formatSlotOptionText(slot);
        opt.disabled = !slotBookable(slot);
        sel.appendChild(opt);
      });
      var keep =
        preferredGid && daySlots.some(function (s) { return String(s.gid) === String(preferredGid); })
          ? String(preferredGid)
          : '';
      if (!keep && daySlots.length === 1 && slotBookable(daySlots[0])) {
        keep = String(daySlots[0].gid || '');
      }
      sel.disabled = daySlots.length === 0;
      sel.value = keep || '';
    }

    function clampVariantQtyToCapacity() {
      var max = maxBookableQty();
      if (!(max >= 0)) return;
      var total = 0;
      Object.keys(state.variantQty).forEach(function (k) {
        if (isAddonVariantId(k)) return;
        total += state.variantQty[k] || 0;
      });
      if (total <= max) return;
      var keys = Object.keys(state.variantQty).filter(function (k) {
        return !isAddonVariantId(k) && (state.variantQty[k] || 0) > 0;
      });
      var over = total - max;
      for (var i = keys.length - 1; i >= 0 && over > 0; i--) {
        var id = keys[i];
        var q = state.variantQty[id] || 0;
        var cut = Math.min(q, over);
        var next = q - cut;
        if (next <= 0) delete state.variantQty[id];
        else state.variantQty[id] = next;
        over -= cut;
      }
    }

    function applyPopupSlotFromSelects() {
      var dateSel = popupDateSelect();
      var timeSel = popupTimeSelect();
      var dateKey = dateSel ? String(dateSel.value || '').trim() : '';
      var gid = timeSel ? String(timeSel.value || '').trim() : '';
      state.selectedDate = dateKey;
      if (!dateKey || !gid) {
        state.selectedSlot = null;
        renderVariants();
        updateVariantStepUi();
        clearBookingUrlEventIdKeepVariant();
        return;
      }
      var slot = null;
      for (var i = 0; i < state.slotList.length; i++) {
        if (String(state.slotList[i].gid) === gid) {
          slot = state.slotList[i];
          break;
        }
      }
      if (!slot || !slotBookable(slot)) {
        state.selectedSlot = null;
        renderVariants();
        updateVariantStepUi();
        return;
      }
      state.selectedSlot = slot;
      clampVariantQtyToCapacity();
      ensureLockedVariantFromUrlOrSlot();
      window.__WB_LOCK_VARIANT_URL__ = true;
      syncWorkshopSelection(slot);
      syncBookingUrlForDatetimeStep(slot);
      renderVariants();
      if (state.lockedVariantId) previewWizardVariant(state.lockedVariantId);
      updateVariantStepUi();
      syncCapacityRing();
      syncSiblingWorkshopPromo();
    }

    function refreshPopupDatetimeControls(opts) {
      opts = opts || {};
      fillPopupDateSelect(opts.preferredDate != null ? opts.preferredDate : state.selectedDate);
      var dateSel = popupDateSelect();
      var dateKey = dateSel ? String(dateSel.value || '').trim() : '';
      fillPopupTimeSelect(
        dateKey,
        opts.preferredGid != null
          ? opts.preferredGid
          : state.selectedSlot && state.selectedSlot.gid
      );
      if (opts.apply !== false) applyPopupSlotFromSelects();
      syncPopupDatetimePanel();
    }

    function bindPopupDatetimeControls() {
      var dateSel = popupDateSelect();
      var timeSel = popupTimeSelect();
      if (dateSel && !dateSel.__wbwBound) {
        dateSel.__wbwBound = true;
        dateSel.addEventListener('change', function () {
          state.selectedDate = String(dateSel.value || '').trim();
          state.selectedSlot = null;
          fillPopupTimeSelect(state.selectedDate, '');
          applyPopupSlotFromSelects();
        });
      }
      if (timeSel && !timeSel.__wbwBound) {
        timeSel.__wbwBound = true;
        timeSel.addEventListener('change', function () {
          applyPopupSlotFromSelects();
        });
      }
    }

    function startPopupBookingStep() {
      rebindSelectedVenueCard();
      if (!state.selectedVenue) return Promise.resolve();
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return Promise.reject(new Error('venue calendar fetch unavailable'));
      }
      if (!state.selectedVenue.venue_ref_id) {
        return Promise.reject(new Error('venue_ref_id missing'));
      }
      if (state.selectedVenue.has_events !== true) {
        return Promise.reject(new Error('venue has_events is not true'));
      }
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = true;
      wizardRoot.__wbwUrlDeepLinkComplete = true;
      wizardRoot.__wbwUserReachedDatetime = true;
      state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
      var loadSeq = state._wbCalLoadSeq;
      var viewSeed = state.viewMonth instanceof Date ? state.viewMonth : new Date();
      if (
        state.selectedVenue.next_date_key &&
        /^\d{4}-\d{2}/.test(String(state.selectedVenue.next_date_key))
      ) {
        var nd = String(state.selectedVenue.next_date_key);
        viewSeed = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }
      state.viewMonth = viewSeed;
      state.flow = 'booking';
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      state._wbwUserPickedCalDate = false;
      state.selectedDate = '';
      state.selectedSlot = null;
      state.variantQty = {};
      updateBranchTitles();
      syncBookingUrlForVenueStep(state.selectedVenue);
      syncVenueKindAttr();
      setBranch('variants');
      bindPopupDatetimeControls();
      setPopupDatetimeHint('');
      setPopupDatetimeLoading(true);

      function stillOnPopupIntent() {
        return (
          loadSeq === state._wbCalLoadSeq &&
          state.branch === 'variants' &&
          state.selectedVenue &&
          !isStoreVenue(state.selectedVenue)
        );
      }

      var hasLocal =
        Array.isArray(state.selectedVenue.events) && state.selectedVenue.events.length > 0;
      if (hasLocal) {
        state.slotList = eventsToSlots(state.selectedVenue.events || []);
        state.daysWithEvents = buildDaysMap(state.slotList);
      } else {
        state.slotList = [];
        state.daysWithEvents = {};
      }
      refreshPopupDatetimeControls({ apply: true });
      renderVariants();
      updateVariantStepUi();

      return bookingRoot
        .__wbEnsureVenueCalendar(state.selectedVenue, state.viewMonth, { lookahead: 1, prefetch: true })
        .then(function () {
          if (!stillOnPopupIntent()) return;
          var paintedSlots = Array.isArray(state.slotList) ? state.slotList.slice() : [];
          rebindSelectedVenueCard();
          if (!state.selectedVenue) return;
          var baseSlots = eventsToSlots(state.selectedVenue.events || []);
          if (!baseSlots.length && paintedSlots.length) {
            state.slotList = paintedSlots;
            state.daysWithEvents = buildDaysMap(state.slotList);
            syncSelectedVenueEventsFromSlots(state.slotList);
            setPopupDatetimeLoading(false);
            refreshPopupDatetimeControls({ apply: true });
            renderVariants();
            updateVariantStepUi();
            ensureLivePoll();
            return state.slotList;
          }
          if (!baseSlots.length) {
            state.slotList = [];
            state.daysWithEvents = {};
            state.selectedDate = '';
            state.selectedSlot = null;
            setPopupDatetimeLoading(false);
            setPopupDatetimeHint('No sessions found for this venue.', true);
            refreshPopupDatetimeControls({ apply: true });
            renderVariants();
            updateVariantStepUi();
            return state.slotList;
          }
          return enrichSlotsForCurrentVenue(baseSlots).then(function (freshSlots) {
            if (!stillOnPopupIntent()) return state.slotList;
            if (!Array.isArray(freshSlots)) throw new Error('live enrich failed');
            state.slotList = freshSlots.length ? freshSlots : paintedSlots;
            state.daysWithEvents = buildDaysMap(state.slotList);
            syncSelectedVenueEventsFromSlots(state.slotList);
            setPopupDatetimeLoading(false);
            setPopupDatetimeHint(state.slotList.length ? '' : 'No sessions found for this venue.', !state.slotList.length);
            refreshPopupDatetimeControls({ apply: true });
            renderVariants();
            updateVariantStepUi();
            ensureLivePoll();
            return state.slotList;
          });
        })
        .catch(function (err) {
          if (!stillOnPopupIntent()) return;
          setPopupDatetimeLoading(false);
          if (err && err.name === 'AbortError') return;
          setPopupDatetimeHint(
            err && err.message === 'bad_request'
              ? 'Invalid date range. Try again.'
              : "Couldn't load dates. Try again.",
            true
          );
        });
    }

    function activateVenueCard(card) {
      if (!card || !card._wbVenue) return;
      selectVenueCard(card, { updatePageCopy: true });
      if (
        card.getAttribute('data-wb-waitlist-venue') === '1' ||
        card._wbVenue._wbWaitlistVenue === true
      ) {
        return;
      }
      return goToNextFromVenue();
    }

    function totalVariantQty(includeAddon) {
      var n = 0;
      Object.keys(state.variantQty).forEach(function (k) {
        if (!includeAddon && isAddonVariantId(k)) return;
        n += state.variantQty[k] || 0;
      });
      return n;
    }

    function hasSelectedVariants() {
      return totalVariantQty(false) > 0;
    }

    /** Seats left for selected event — from capacity_remaining only (per event, no fixed cap). */
    function parseSlotCapacityRemaining(slot) {
      if (!slot) return null;
      var cap = slot.capacity_remaining;
      if (cap == null || cap === '') {
        var raw = slot._raw;
        if (raw && raw.capacity_remaining != null && raw.capacity_remaining !== '') {
          cap = raw.capacity_remaining;
        }
      }
      if (cap == null || cap === '') return null;
      var n = Number(cap);
      return Number.isFinite(n) ? n : null;
    }

    function maxBookableQty() {
      if (!state.selectedSlot) {
        /* Popup step: allow picking styles before date/time; ATC still requires a slot. */
        if (state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking') {
          return 99;
        }
        return 0;
      }
      if (!slotBookable(state.selectedSlot)) return 0;
      if (liveController && typeof liveController.maxBookableQty === 'function') {
        return liveController.maxBookableQty(state.selectedSlot);
      }
      var cap = parseSlotCapacityRemaining(state.selectedSlot);
      if (cap == null) return 1;
      return cap > 0 ? cap : 0;
    }

    function formatWizardVariantPricesOuter(v, slotForPrice) {
      var slot = slotForPrice !== undefined ? slotForPrice : state.selectedSlot;
      var open =
        slotBookable(slot) ||
        (!slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking');
      var base = Number(v && v.price) || 0;
      var resolved = resolveVariantPriceCents(v, slot);
      if (!open) {
        return (
          '<div class="wcf-variant-card__prices">' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--current">' +
          escapeHtml(formatMoney(resolved)) +
          '</span></div>'
        );
      }
      if (resolved < base && base > 0) {
        return (
          '<div class="wcf-variant-card__prices wcf-variant-card__prices--discount">' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--compare">' +
          '<s>' +
          escapeHtml(formatMoney(base)) +
          '</s></span>' +
          '<span class="wcf-variant-card__price wcf-variant-card__price--sale">' +
          escapeHtml(formatMoney(resolved)) +
          '</span></div>'
        );
      }
      return (
        '<div class="wcf-variant-card__prices">' +
        '<span class="wcf-variant-card__price wcf-variant-card__price--current">' +
        escapeHtml(formatMoney(resolved)) +
        '</span></div>'
      );
    }

    function capacityRingModel(slot) {
      if (!slot || slotHidden(slot)) return null;
      var raw = slot._raw || {};
      var rem = Number(
        raw.capacity_remaining != null && raw.capacity_remaining !== ''
          ? raw.capacity_remaining
          : slot.capacity_remaining
      );
      var tot = Number(
        raw.capacity_total != null && raw.capacity_total !== '' ? raw.capacity_total : slot.capacity_total
      );
      if (slotSoldOut(slot)) {
        return {
          rem: 0,
          tot: tot > 0 && Number.isFinite(tot) ? tot : 1,
          used: tot > 0 && Number.isFinite(tot) ? tot : 1,
          pctUsed: 100,
          pctRem: 0,
          soldOut: true,
        };
      }
      if (!(tot > 0) || !Number.isFinite(rem) || rem < 0) return null;
      var used = Math.max(0, Math.min(tot, tot - rem));
      var pctUsed = (used / tot) * 100;
      pctUsed = Math.max(0, Math.min(100, pctUsed));
      var pctRem = (rem / tot) * 100;
      pctRem = Math.max(0, Math.min(100, pctRem));
      return { rem: rem, tot: tot, used: used, pctUsed: pctUsed, pctRem: pctRem };
    }

    /** Tier by occupancy (booked %): empty event = green, nearly full = red. */
    function capacityRingTier(pctUsed) {
      var pct = Math.round(pctUsed);
      if (pct >= 100) return 'soldout';
      if (pct >= 66) return 'low';
      if (pct >= 33) return 'medium';
      return 'high';
    }

    function capacityRingAriaLabel(m) {
      if (!m || !(m.tot > 0)) return 'Capacity — select a time to see availability';
      if (m.soldOut || m.rem <= 0) return 'Capacity — sold out';
      return (
        Math.round(m.used) +
        ' of ' +
        Math.round(m.tot) +
        ' spots booked, ' +
        (Math.round(m.pctUsed * 10) / 10) +
        ' percent full'
      );
    }

    function capacityRingPctText(m) {
      if (!m) return '';
      if (m.soldOut || m.rem <= 0) return '';
      if (m.used <= 0) return '0%';
      if (m.used >= m.tot) return '100%';
      var tenths = Math.round(m.pctUsed * 10) / 10;
      return (tenths % 1 === 0 ? String(Math.round(tenths)) : tenths.toFixed(1)) + '%';
    }

    function syncCapacityRingEmpty(ring) {
      ring.hidden = false;
      ring.classList.add('is-empty');
      ring.setAttribute('data-capacity-tier', 'empty');
      ring.setAttribute('aria-label', 'Capacity — select a time to see availability');
      var frac = ring.querySelector('[data-wbw-cap-frac]');
      var pct = ring.querySelector('[data-wbw-cap-pct]');
      var prog = ring.querySelector('.wbw-cal-cap-ring__prog');
      if (frac) frac.textContent = '—';
      if (pct) pct.textContent = '';
      if (prog) {
        prog.style.strokeDasharray = '';
        prog.style.strokeDashoffset = '';
        prog.style.stroke = '';
      }
    }

    function applyCapacityRingProgress(prog, m) {
      var tot = Math.round(m.tot);
      var used = Math.round(m.used);
      if (tot < 1) tot = 1;
      if (used < 0) used = 0;
      if (used > tot) used = tot;

      /* Ring fill = booked (empty → 0%, sold out → solid). Segmented when tot ≤ 40. */
      if (used <= 0) {
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '100';
        return;
      }

      if (used >= tot) {
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '0';
        return;
      }

      if (tot <= 40) {
        var segLen = 100 / tot;
        var gap = Math.min(0.55, segLen * 0.14);
        var draw = Math.max(0.08, segLen - gap);
        var parts = [];
        var empty = Math.max(0, tot - used);
        var i;
        for (i = 0; i < tot; i++) {
          if (i < used) {
            parts.push(draw.toFixed(3), gap.toFixed(3));
          } else {
            parts.push('0', segLen.toFixed(3));
          }
        }
        prog.style.strokeDasharray = parts.join(' ');
        prog.style.strokeDashoffset = '0';
        return;
      }

      var pctExact = (used / tot) * 100;
      pctExact = Math.max(0, Math.min(100, pctExact));
      prog.style.strokeDasharray = '100 100';
      if (pctExact >= 100) {
        prog.style.strokeDashoffset = '0';
      } else if (pctExact <= 0) {
        prog.style.strokeDashoffset = '100';
      } else {
        prog.style.strokeDashoffset = String(pctExact - 100);
      }
    }

    function capacityRingEnabled() {
      var attr = wizardRoot.getAttribute('data-wbw-show-capacity-ring');
      return attr !== 'false';
    }

    function syncCapacityRing() {
      if (!capacityRingEnabled()) return;
      var ring = wizardRoot.querySelector('[data-wbw-capacity-ring]');
      if (!ring) return;
      if (state.branch !== 'datetime') {
        ring.hidden = true;
        return;
      }
      ring.hidden = false;
      var m = capacityRingModel(state.selectedSlot);
      if (!m) {
        syncCapacityRingEmpty(ring);
        return;
      }
      var tier = capacityRingTier(m.pctUsed);
      ring.classList.remove('is-empty');
      ring.setAttribute('data-capacity-tier', tier);
      ring.setAttribute('aria-label', capacityRingAriaLabel(m));
      var frac = ring.querySelector('[data-wbw-cap-frac]');
      var pct = ring.querySelector('[data-wbw-cap-pct]');
      var prog = ring.querySelector('.wbw-cal-cap-ring__prog');
      if (frac) frac.textContent = m.soldOut || m.rem <= 0 ? 'Sold out' : Math.round(m.used) + '/' + Math.round(m.tot);
      if (pct) pct.textContent = capacityRingPctText(m);
      if (prog) applyCapacityRingProgress(prog, m);
    }

    function updateSelectionSummary() {
      var wrap = wizardRoot.querySelector('[data-wbw-selection-summary-wrapper]');
      var sum = wizardRoot.querySelector('[data-wbw-selection-summary]');
      if (!wrap || !sum) return;
      var lines = [];
      var slot = state.selectedSlot;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var v = findWizardVariant(k);
        if (!v) return;
        var label = String(v.label || v.title || 'Workshop').trim();
        var unit = resolveVariantPriceCents(v, slot);
        var lt = unit * q;
        lines.push(
          '<div class="wbw-sel-line">' +
          '<span class="wbw-sel-line__pill">' +
          escapeHtml(String(q) + ' × ' + label) +
          '</span>' +
          '<span class="wbw-sel-line__line-total">' +
          escapeHtml(formatMoney(lt)) +
          '</span></div>'
        );
      });
      sum.innerHTML = lines.join('');
    }

    function renderVariants() {
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var slot = state.selectedSlot;
      var popupPreSlot =
        !slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
      var eventOpen = slotBookable(slot) || popupPreSlot;
      var list = variants.slice();
      var addonV = addonVariantObject();
      if (addonV) list.push(addonV);

      if (!list.length) {
        wrap.innerHTML =
          '<div class="wcf-variants-empty"><p class="wcf-variants-empty__text">No workshop styles found for this product.</p></div>';
        updateVariantStepUi();
        return;
      }

      list.forEach(function (v, idx) {
        var id = vQtyKey(v.id);
        var qty = state.variantQty[id] || 0;
        var isAddon = !!v._isAddon;
        var row = document.createElement('div');
        row.className =
          'wcf-variant-row wbw-variant-row--wizard' +
          (qty > 0 ? ' is-active' : '') +
          (isAddon ? ' wbw-variant-row--addon' : '');
        row.setAttribute('data-variant-id', id);
        if (isAddon) row.setAttribute('data-wbw-addon-variant', 'true');

        var label = v.label || v.title || 'Workshop';
        var card = document.createElement('div');
        card.className = 'wcf-variant-card';
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', label);
        if (!eventOpen) {
          /* Store calendar path without a slot: visual only. Popup keeps controls usable. */
          if (!(state.selectedVenue && !isStoreVenue(state.selectedVenue))) {
            row.classList.add('is-disabled');
          }
        }
        var imgUrl = v.image_url || '';
        var eager = idx < 3;
        var imgInner = imgUrl
          ? '<img class="wcf-variant-card__img" src="' +
            escapeHtml(imgUrl) +
            '" alt="" width="720" height="720" decoding="async"' +
            (eager ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') +
            '>'
          : '<div class="wcf-variant-card__img wcf-variant-card__img--placeholder" aria-hidden="true"></div>';
        card.innerHTML =
          '<div class="wcf-variant-card__title">' + escapeHtml(label) + '</div>' +
          '<div class="wcf-variant-card__media">' + imgInner + '</div>';

        var buyRow = document.createElement('div');
        buyRow.className = 'wbw-variant-buy-row';
        buyRow.innerHTML =
          '<div class="wcf-variant-qty-col">' +
          variantQtyControlHtml(id, qty) +
          '</div>' +
          formatWizardVariantPricesOuter(v, slot);

        function onQtyClick(delta, e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          if (!eventOpen && !(state.selectedVenue && !isStoreVenue(state.selectedVenue))) return;
          adjustVariantQty(id, delta);
        }

        var incBtn = buyRow.querySelector('[data-wbw-qty-inc]');
        var decBtn = buyRow.querySelector('[data-wbw-qty-dec]');
        if (incBtn) {
          incBtn.addEventListener('click', function (e) {
            onQtyClick(1, e);
          });
        }
        if (decBtn) {
          decBtn.addEventListener('click', function (e) {
            onQtyClick(-1, e);
          });
        }

        var mediaEl = card.querySelector('.wcf-variant-card__media');
        if (mediaEl && !isAddon) {
          mediaEl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openWizardVariantImageZoom(id);
          });
        }

        card.addEventListener('click', function () {
          if (!isAddon) previewWizardVariant(id);
        });

        row.appendChild(card);
        row.appendChild(buyRow);
        wrap.appendChild(row);
      });

      /* Warm CDN cache for remaining slides so swipes feel instant. */
      list.forEach(function (v, idx) {
        if (idx < 3 || !v.image_url) return;
        var warm = new Image();
        warm.decoding = 'async';
        warm.src = v.image_url;
      });

      bindVariantGridResize(wrap, wizardRoot);
      updateVariantStepUi();
    }

    function openWizardVariantImageZoom(variantId) {
      var id = vQtyKey(variantId);
      var v = findWizardVariant(id);
      if (!v) return;
      /* Do not sync PDP options on zoom open — Impulse prepends/refreshes media to index 0. */
      previewWizardVariant(id, { syncPdp: false, scrollCarousel: true });
      var sectionRoot = getSectionRoot(wizardRoot, data);
      var sectionId =
        (data && data.sectionId) || (wizardRoot && wizardRoot.getAttribute('data-section-id')) || '';
      if (sectionRoot && !sectionId) {
        var sidMatch = (sectionRoot.id || '').match(/^shopify-section-(.+)$/);
        if (sidMatch) sectionId = sidMatch[1];
      }
      if (!sectionRoot) {
        openWizardVariantImageFallback(v.image_url);
        scheduleWizardZoomHud(id, sectionId);
        return;
      }
      var styleIdx =
        data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      ensureVariantMediaMeta(v, sectionRoot, styleIdx);
      var shopifyVariant = findShopifyVariantByWizard(sectionRoot, v, styleIdx);
      var mediaTarget = shopifyVariant || {
        featured_media: v.featured_media_id ? { id: v.featured_media_id } : null,
        featured_media_id: v.featured_media_id,
        featured_image: v.image_url ? { src: v.image_url } : null,
        id: v.id,
      };
      var opened = false;
      if (mediaTarget && (mediaTarget.featured_media || mediaTarget.featured_media_id)) {
        opened = openImpulseProductZoom(sectionRoot, mediaTarget);
      }
      if (!opened) {
        openWizardVariantImageFallback(v.image_url);
      }
      scheduleWizardZoomHud(id, sectionId);
    }

    var zoomHudTeardown = null;
    var zoomHudScheduleTimer = null;

    function isZoomLayerVisible(el) {
      if (!el) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      /* Alpine leave keeps display until transition ends — opacity 0 means closing. */
      if (parseFloat(style.opacity) < 0.05) return false;
      return true;
    }

    function resolveVisibleZoomSectionId(preferred) {
      if (preferred && isZoomLayerVisible(document.getElementById('ProductModal-' + preferred))) {
        return preferred;
      }
      var nodes = document.querySelectorAll('[id^="ProductModal-"]');
      for (var i = 0; i < nodes.length; i++) {
        if (!isZoomLayerVisible(nodes[i])) continue;
        return String(nodes[i].id || '').replace(/^ProductModal-/, '');
      }
      return preferred || '';
    }

    function isAlpineZoomOpen(sectionId) {
      if (!sectionId || !window.Alpine) return null;
      var mediaHost = document.getElementById('product-media-' + sectionId);
      if (!mediaHost) return null;
      try {
        var alpine = window.Alpine.$data(mediaHost);
        if (!alpine || typeof alpine.zoomIsOpen === 'undefined') return null;
        return !!alpine.zoomIsOpen;
      } catch (_) {
        return null;
      }
    }

    function isWizardZoomUiOpen(sectionId) {
      if (isZoomLayerVisible(document.querySelector('[data-wbw-image-zoom]'))) return true;
      var alpineOpen = isAlpineZoomOpen(sectionId);
      if (alpineOpen === false) return false;
      if (alpineOpen === true) return true;
      return !!resolveVisibleZoomSectionId(sectionId);
    }

    function teardownWizardZoomHud() {
      if (zoomHudScheduleTimer) {
        window.clearInterval(zoomHudScheduleTimer);
        zoomHudScheduleTimer = null;
      }
      if (zoomHudTeardown) {
        zoomHudTeardown();
        zoomHudTeardown = null;
      }
      document.querySelectorAll('[data-wbw-zoom-hud]').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('.wbw-zoom-gallery--with-hud').forEach(function (el) {
        el.classList.remove('wbw-zoom-gallery--with-hud');
      });
    }

    function closeWizardZoomOverlay(sectionId) {
      var sid = resolveVisibleZoomSectionId(sectionId) || sectionId;
      teardownWizardZoomHud();
      if (sid) closeImpulseProductZoom(sid);
      var fallback = document.querySelector('[data-wbw-image-zoom]');
      if (fallback) {
        fallback.remove();
        document.dispatchEvent(new CustomEvent('wbw:image-zoom-closed'));
      }
    }

    function wizardZoomQtyAllowed() {
      var slot = state.selectedSlot;
      var popupPreSlot =
        !slot && state.selectedVenue && !isStoreVenue(state.selectedVenue) && state.flow === 'booking';
      return !!(slotBookable(slot) || popupPreSlot);
    }

    function scheduleWizardZoomHud(variantId, sectionId) {
      teardownWizardZoomHud();
      var tries = 0;
      zoomHudScheduleTimer = window.setInterval(function () {
        tries += 1;
        var sid = resolveVisibleZoomSectionId(sectionId);
        var openSid = sid || sectionId;
        if (isWizardZoomUiOpen(openSid) || document.querySelector('[data-wbw-image-zoom]')) {
          window.clearInterval(zoomHudScheduleTimer);
          zoomHudScheduleTimer = null;
          mountWizardZoomHud(variantId, openSid);
          return;
        }
        if (tries >= 40) {
          window.clearInterval(zoomHudScheduleTimer);
          zoomHudScheduleTimer = null;
        }
      }, 80);
    }

    function mediaIdFromZoomThumbEl(el, sectionId) {
      return parseZoomThumbMediaId(el, sectionId);
    }

    function getActiveZoomMediaId(sectionId) {
      if (!sectionId) return '';
      var thumbsRoot = document.getElementById('x-zoom-thumbnail-' + sectionId);
      var gallery = document.getElementById('media-gallery-' + sectionId);
      var modal = document.getElementById('ProductModal-' + sectionId);
      var thumbs = thumbsRoot ? thumbsRoot.getElementsByClassName('x-thumbnail') : [];
      var i;

      /* 1) Active zoom slide first — thumb opacity often lags on first media (Candle Holder). */
      var activeSlide =
        (gallery && gallery.querySelector('.splide__slide.is-active, .x-splide-slide.is-active')) ||
        (modal && modal.querySelector('.splide__slide.is-active, .x-splide-slide.is-active'));
      if (activeSlide) {
        var fromSlide = parseZoomSlideMediaId(activeSlide, sectionId);
        if (fromSlide) return fromSlide;
      }

      /* 2) Match active slide image src to a thumb src */
      var activeImg = activeSlide && activeSlide.querySelector('img');
      if (activeImg && thumbs.length) {
        var src = String(activeImg.currentSrc || activeImg.src || '');
        var srcKey = src.split('?')[0].replace(/_\d+x\d*(@2x)?\./, '.');
        for (i = 0; i < thumbs.length; i++) {
          var tImg = thumbs[i].querySelector('img');
          if (!tImg) continue;
          var tSrc = String(tImg.currentSrc || tImg.src || '')
            .split('?')[0]
            .replace(/_\d+x\d*(@2x)?\./, '.');
          if (srcKey && tSrc && (srcKey.indexOf(tSrc) !== -1 || tSrc.indexOf(srcKey) !== -1 || src.indexOf(tSrc) !== -1)) {
            var fromSrc = mediaIdFromZoomThumbEl(thumbs[i], sectionId);
            if (fromSrc) return fromSrc;
          }
        }
      }

      /* 3) Splide index → thumb */
      if (gallery && gallery.splide && Number.isFinite(gallery.splide.index) && thumbs[gallery.splide.index]) {
        var fromIdx = mediaIdFromZoomThumbEl(thumbs[gallery.splide.index], sectionId);
        if (fromIdx) return fromIdx;
      }

      /* 4) Thumb without opacity-30 (last — can stick on first variant) */
      for (i = 0; i < thumbs.length; i++) {
        if (!thumbs[i].classList.contains('opacity-30')) {
          var fromActive = mediaIdFromZoomThumbEl(thumbs[i], sectionId);
          if (fromActive) return fromActive;
        }
      }
      return '';
    }

    function findWizardVariantByLabelText(text) {
      var raw = String(text || '')
        .toLowerCase()
        .replace(/#.*$/, '')
        .trim();
      if (!raw) return null;
      var best = null;
      var bestLen = 0;
      var i;
      for (i = 0; i < variants.length; i++) {
        if (isAddonVariantId(variants[i].id)) continue;
        var label = String(variants[i].label || variants[i].title || '')
          .toLowerCase()
          .trim();
        if (!label) continue;
        if (raw === label || raw.indexOf(label) !== -1 || label.indexOf(raw) !== -1) {
          if (label.length > bestLen) {
            bestLen = label.length;
            best = variants[i];
          }
        }
      }
      return best;
    }

    function findWizardVariantByFeaturedMediaId(mediaId, sectionRoot) {
      if (!mediaId) return null;
      mediaId = String(mediaId);
      var styleIdx = data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      var i;
      for (i = 0; i < variants.length; i++) {
        if (isAddonVariantId(variants[i].id)) continue;
        ensureVariantMediaMeta(variants[i], sectionRoot, styleIdx);
        if (String(variants[i].featured_media_id || '') === mediaId) return variants[i];
      }
      var list = parseVariantsJson(sectionRoot);
      var optKey = 'option' + (styleIdx + 1);
      for (i = 0; i < list.length; i++) {
        var sv = list[i];
        var fm =
          (sv.featured_media && sv.featured_media.id) ||
          sv.featured_media_id ||
          (sv.featured_image && sv.featured_image.id);
        if (String(fm || '') !== mediaId) continue;
        var styleVal = normalizeOptionValue(sv[optKey] || '');
        var j;
        for (j = 0; j < variants.length; j++) {
          if (isAddonVariantId(variants[j].id)) continue;
          if (String(variants[j].id) === String(sv.id)) return variants[j];
          var wStyle = normalizeOptionValue(
            styleValueFromVariant(variants[j], styleIdx) || variants[j].label || ''
          );
          if (styleVal && wStyle && wStyle === styleVal) return variants[j];
        }
      }
      return null;
    }

    /**
     * Map zoom media → style variant.
     * Prefer image alt ("Moon Lamp") — reliable even with liquid clones / multi-shot runs.
     */
    function findWizardVariantForZoomMedia(mediaId, sectionId, sectionRoot) {
      var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
      var activeImg =
        modal &&
        modal.querySelector('.splide__slide.is-active img, .x-splide-slide.is-active img');
      var altMatch = findWizardVariantByLabelText(activeImg && activeImg.getAttribute('alt'));
      if (altMatch) return altMatch;

      if (!mediaId) return null;
      mediaId = String(mediaId);
      var exact = findWizardVariantByFeaturedMediaId(mediaId, sectionRoot);
      if (exact) return exact;

      var styleIdx = data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      var featuredToVariant = {};
      var i;
      for (i = 0; i < variants.length; i++) {
        if (isAddonVariantId(variants[i].id)) continue;
        ensureVariantMediaMeta(variants[i], sectionRoot, styleIdx);
        var fid = String(variants[i].featured_media_id || '');
        if (fid) featuredToVariant[fid] = variants[i];
      }

      var thumbsRoot = sectionId ? document.getElementById('x-zoom-thumbnail-' + sectionId) : null;
      var thumbs = thumbsRoot ? thumbsRoot.getElementsByClassName('x-thumbnail') : [];
      var owner = null;
      for (i = 0; i < thumbs.length; i++) {
        var tid = mediaIdFromZoomThumbEl(thumbs[i], sectionId);
        if (!tid) continue;
        if (featuredToVariant[tid]) owner = featuredToVariant[tid];
        if (tid === mediaId) return owner;
      }
      return null;
    }

    function findWizardZoomMediaEl(sectionId) {
      var fallback = document.querySelector('[data-wbw-image-zoom] .wbw-image-zoom__img');
      if (fallback) return fallback;
      var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
      if (!modal) return null;
      var activeSlide = modal.querySelector('.splide__slide.is-active img, .x-splide-slide.is-active img');
      if (activeSlide) return activeSlide;
      var candidates = modal.querySelectorAll(
        'img.image-magnify-lightbox, .pswp__img, .zoomImg, [id*="-image-zoom-"] img, .product-media-modal__image img, .media-zoom img, img'
      );
      var best = null;
      var bestArea = 0;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!el || !el.getBoundingClientRect) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 80 || r.height < 80) continue;
        if (r.bottom <= 0 || r.top >= window.innerHeight) continue;
        /* Skip thumbnail strip images */
        if (el.closest && el.closest('[id^="x-zoom-thumbnail-"]')) continue;
        var area = r.width * r.height;
        if (area > bestArea) {
          bestArea = area;
          best = el;
        }
      }
      return best;
    }

    function findWizardZoomThumbnailEl(sectionId) {
      if (!sectionId) return null;
      return document.getElementById('x-zoom-thumbnail-' + sectionId);
    }

    function mountHudIntoZoomChrome(hud, sectionId) {
      var thumbs = findWizardZoomThumbnailEl(sectionId);
      if (thumbs && thumbs.parentNode) {
        hud.classList.add('wbw-zoom-hud--docked');
        thumbs.parentNode.insertBefore(hud, thumbs);
        var gallery = document.getElementById('media-gallery-' + sectionId);
        if (gallery) {
          gallery.classList.add('wbw-zoom-gallery--with-hud');
          if (gallery.splide && typeof gallery.splide.refresh === 'function') {
            window.requestAnimationFrame(function () {
              try {
                gallery.splide.refresh();
              } catch (_) {}
              positionZoomGalleryArrows(sectionId);
            });
          } else {
            positionZoomGalleryArrows(sectionId);
          }
        }
        return true;
      }
      document.body.appendChild(hud);
      return false;
    }

    /** Pin <> arrows to the visible photo (object-contain), not the tall gallery box. */
    function positionZoomGalleryArrows(sectionId) {
      var gallery = sectionId ? document.getElementById('media-gallery-' + sectionId) : null;
      if (!gallery || !gallery.classList.contains('wbw-zoom-gallery--with-hud')) return;
      var img = gallery.querySelector(
        '.splide__slide.is-active img, .x-splide-slide.is-active img, .splide__slide img'
      );
      var prev = gallery.querySelector('.splide__arrow--prev');
      var next = gallery.querySelector('.splide__arrow--next');
      if (!img || (!prev && !next)) return;
      var gRect = gallery.getBoundingClientRect();
      if (gRect.height < 40) return;
      var iRect = img.getBoundingClientRect();
      var top = iRect.top;
      var bottom = iRect.bottom;
      var left = iRect.left;
      var right = iRect.right;
      var nw = Number(img.naturalWidth) || 0;
      var nh = Number(img.naturalHeight) || 0;
      if (nw > 0 && nh > 0 && iRect.width > 0 && iRect.height > 0) {
        var er = iRect.width / iRect.height;
        var ir = nw / nh;
        var cw;
        var ch;
        if (er > ir) {
          ch = iRect.height;
          cw = ch * ir;
          left = iRect.left + (iRect.width - cw) / 2;
          right = left + cw;
        } else {
          cw = iRect.width;
          ch = cw / ir;
          top = iRect.top + (iRect.height - ch) / 2;
          bottom = top + ch;
        }
      }
      var midY = (top + bottom) / 2 - gRect.top;
      var inset = 6;
      if (prev) {
        prev.style.top = midY + 'px';
        prev.style.marginTop = '0';
        prev.style.transform = 'translateY(-50%)';
        prev.style.left = Math.max(inset, left - gRect.left + inset) + 'px';
        prev.style.right = 'auto';
      }
      if (next) {
        next.style.top = midY + 'px';
        next.style.marginTop = '0';
        next.style.transform = 'translateY(-50%)';
        next.style.right = Math.max(inset, gRect.right - right + inset) + 'px';
        next.style.left = 'auto';
      }
    }

    function positionWizardZoomHudPanel(hud) {
      if (!hud || hud.classList.contains('wbw-zoom-hud--docked')) return;
      var panel = hud.querySelector('.wbw-zoom-hud__bottom');
      if (!panel) return;
      /* Non-docked fallback only (no thumbnail strip): keep bottom-anchored. */
      panel.style.removeProperty('--wbw-zoom-hud-top');
      panel.style.removeProperty('top');
      panel.style.removeProperty('max-height');
      panel.style.setProperty(
        '--wbw-zoom-hud-bottom',
        'calc(4.85rem + env(safe-area-inset-bottom, 0px))'
      );
      panel.style.bottom = 'calc(4.85rem + env(safe-area-inset-bottom, 0px))';
    }

    function mountWizardZoomHud(variantId, sectionId) {
      var id = vQtyKey(variantId);
      var v = findWizardVariant(id);
      if (!v) return;
      if (!isWizardZoomUiOpen(sectionId) && !document.querySelector('[data-wbw-image-zoom]')) return;

      document.querySelectorAll('[data-wbw-zoom-hud]').forEach(function (el) {
        el.remove();
      });
      if (zoomHudTeardown) {
        zoomHudTeardown();
        zoomHudTeardown = null;
      }

      var lastActiveMediaId = '';
      var slideSyncReady = false;
      var sectionRoot = getSectionRoot(wizardRoot, data);
      var styleIdxOpen =
        data && data.styleOptionIndex != null ? Number(data.styleOptionIndex) : 0;
      ensureVariantMediaMeta(v, sectionRoot, styleIdxOpen);
      var openedMediaId = String(v.featured_media_id || '');
      lastActiveMediaId = openedMediaId;

      function paintHudContent() {
        var current = findWizardVariant(id);
        if (!current) return;
        var qty = state.variantQty[id] || 0;
        var label = current.label || current.title || 'Workshop';
        var priceHtml = formatWizardVariantPricesOuter(current, state.selectedSlot);
        var labelEl = hud.querySelector('.wbw-zoom-hud__variant');
        if (labelEl) labelEl.textContent = label;
        var qtyEl = hud.querySelector('[data-wbw-zoom-qty-val]');
        if (qtyEl) qtyEl.textContent = String(qty);
        var priceEl = hud.querySelector('.wbw-zoom-hud__price');
        if (priceEl) priceEl.innerHTML = priceHtml;
        hud.setAttribute('data-wbw-zoom-variant-id', id);
      }

      function syncHudFromActiveZoomSlide() {
        if (!slideSyncReady) return;
        var mediaId = getActiveZoomMediaId(sectionId);
        if (!mediaId || mediaId === lastActiveMediaId) return;
        lastActiveMediaId = mediaId;
        var mapped = findWizardVariantForZoomMedia(mediaId, sectionId, sectionRoot);
        /* Unowned detail shots keep current HUD. */
        if (!mapped) return;
        var nextId = vQtyKey(mapped.id);
        if (nextId === id) {
          paintHudContent();
          return;
        }
        id = nextId;
        previewWizardVariant(id, { syncPdp: false, scrollCarousel: false });
        paintHudContent();
      }

      function armSlideSync() {
        if (slideSyncReady) return;
        slideSyncReady = true;
        var nowId = getActiveZoomMediaId(sectionId);
        /*
         * Anchor to whatever the gallery reports now WITHOUT rewriting HUD.
         * Calling sync here stole the title back to the first slide (Candle Holder)
         * when thumbs lagged behind the opened variant image.
         */
        if (nowId) {
          var mappedNow = findWizardVariantForZoomMedia(nowId, sectionId, sectionRoot);
          if (mappedNow && vQtyKey(mappedNow.id) === id) {
            lastActiveMediaId = nowId;
          } else {
            lastActiveMediaId = nowId;
          }
        } else if (openedMediaId) {
          lastActiveMediaId = openedMediaId;
        }
      }

      var qty = state.variantQty[id] || 0;
      var label = v.label || v.title || 'Workshop';
      var priceHtml = formatWizardVariantPricesOuter(v, state.selectedSlot);
      var dateKey = state.selectedSlot ? slotDateKey(state.selectedSlot) : '';
      var dateLabel = dateKey ? formatPopupDateLabel(dateKey) : '';
      var timeLabel = state.selectedSlot ? String(state.selectedSlot.time_label || '').trim() : '';
      var hud = document.createElement('div');
      hud.className = 'wbw-zoom-hud';
      hud.setAttribute('data-wbw-zoom-hud', '');
      hud.setAttribute('data-wbw-zoom-variant-id', id);
      hud.innerHTML =
        '<div class="wbw-zoom-hud__bottom">' +
        '<div class="wbw-zoom-hud__variant">' +
        escapeHtml(label) +
        '</div>' +
        '<div class="wbw-zoom-hud__buy">' +
        '<div class="wbw-zoom-hud__qty" role="group" aria-label="Quantity">' +
        '<button type="button" class="wbw-zoom-hud__qty-btn" data-wbw-zoom-qty-dec aria-label="Decrease quantity">&minus;</button>' +
        '<span class="wbw-zoom-hud__qty-val" data-wbw-zoom-qty-val>' +
        escapeHtml(String(qty)) +
        '</span>' +
        '<button type="button" class="wbw-zoom-hud__qty-btn" data-wbw-zoom-qty-inc aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<div class="wbw-zoom-hud__price">' +
        priceHtml +
        '</div>' +
        '</div>' +
        '<div class="wbw-zoom-hud__when-row">' +
        (dateLabel
          ? '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--date"><span class="wbw-zoom-hud__when-label">Date</span><span class="wbw-zoom-hud__when-value">' +
            escapeHtml(dateLabel) +
            '</span></div>'
          : '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--muted wbw-zoom-hud__when--date"><span class="wbw-zoom-hud__when-label">Date</span><span class="wbw-zoom-hud__when-value">Not selected</span></div>') +
        (timeLabel
          ? '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--time"><span class="wbw-zoom-hud__when-label">Time</span><span class="wbw-zoom-hud__when-value">' +
            escapeHtml(timeLabel) +
            '</span></div>'
          : '<div class="wbw-zoom-hud__when wbw-zoom-hud__when--muted wbw-zoom-hud__when--time"><span class="wbw-zoom-hud__when-label">Time</span><span class="wbw-zoom-hud__when-value">Not selected</span></div>') +
        '</div>' +
        '</div>';

      hud.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      hud.addEventListener(
        'touchstart',
        function (e) {
          e.stopPropagation();
        },
        { passive: true }
      );

      function onQtyDelta(delta, e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (!wizardZoomQtyAllowed()) return;
        closeWizardZoomOverlay(sectionId);
        adjustVariantQty(id, delta);
      }

      var inc = hud.querySelector('[data-wbw-zoom-qty-inc]');
      var dec = hud.querySelector('[data-wbw-zoom-qty-dec]');
      if (inc) {
        inc.addEventListener('click', function (e) {
          onQtyDelta(1, e);
        });
      }
      if (dec) {
        dec.addEventListener('click', function (e) {
          onQtyDelta(-1, e);
        });
      }

      mountHudIntoZoomChrome(hud, sectionId);
      positionWizardZoomHudPanel(hud);
      window.setTimeout(armSlideSync, 480);
      window.setTimeout(function () {
        positionZoomGalleryArrows(sectionId);
      }, 100);
      window.setTimeout(function () {
        positionZoomGalleryArrows(sectionId);
      }, 320);

      function onZoomDismiss() {
        teardownWizardZoomHud();
      }

      function onDocEsc(e) {
        if (e.key === 'Escape') onZoomDismiss();
      }

      function onViewportChange() {
        positionZoomGalleryArrows(sectionId);
      }

      function onGallerySlideChange() {
        var wasReady = slideSyncReady;
        armSlideSync();
        if (!wasReady) {
          /* User moved before the arm timer — sync to the slide they landed on. */
          lastActiveMediaId = '';
        }
        syncHudFromActiveZoomSlide();
        positionZoomGalleryArrows(sectionId);
      }

      var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
      var closeBtn = sectionId ? document.getElementById('ProductModalClose-' + sectionId) : null;
      var gallery = sectionId ? document.getElementById('media-gallery-' + sectionId) : null;
      var thumbsRoot = findWizardZoomThumbnailEl(sectionId);
      if (closeBtn) closeBtn.addEventListener('click', onZoomDismiss);
      document.addEventListener('keydown', onDocEsc);
      window.addEventListener('resize', onViewportChange);
      window.addEventListener('orientationchange', onViewportChange);

      if (gallery && gallery.splide && typeof gallery.splide.on === 'function') {
        gallery.splide.on('moved', onGallerySlideChange);
        gallery.splide.on('move', onGallerySlideChange);
      }
      if (thumbsRoot) {
        thumbsRoot.addEventListener('click', onGallerySlideChange);
      }

      var observer = null;
      if (modal && typeof MutationObserver === 'function') {
        observer = new MutationObserver(function () {
          if (!isWizardZoomUiOpen(sectionId)) teardownWizardZoomHud();
          else syncHudFromActiveZoomSlide();
        });
        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
          subtree: true,
        });
      }

      var watchId = window.setInterval(function () {
        if (!isWizardZoomUiOpen(sectionId) && !document.querySelector('[data-wbw-image-zoom]')) {
          teardownWizardZoomHud();
        } else {
          syncHudFromActiveZoomSlide();
        }
      }, 120);

      function onFallbackClosed() {
        teardownWizardZoomHud();
      }
      document.addEventListener('wbw:image-zoom-closed', onFallbackClosed);

      zoomHudTeardown = function () {
        window.clearInterval(watchId);
        document.removeEventListener('wbw:image-zoom-closed', onFallbackClosed);
        document.removeEventListener('keydown', onDocEsc);
        window.removeEventListener('resize', onViewportChange);
        window.removeEventListener('orientationchange', onViewportChange);
        if (closeBtn) closeBtn.removeEventListener('click', onZoomDismiss);
        if (thumbsRoot) thumbsRoot.removeEventListener('click', onGallerySlideChange);
        if (gallery) {
          gallery.classList.remove('wbw-zoom-gallery--with-hud');
          gallery.querySelectorAll('.splide__arrow').forEach(function (btn) {
            btn.style.top = '';
            btn.style.marginTop = '';
            btn.style.transform = '';
            btn.style.left = '';
            btn.style.right = '';
          });
          if (gallery.splide && typeof gallery.splide.off === 'function') {
            gallery.splide.off('moved', onGallerySlideChange);
            gallery.splide.off('move', onGallerySlideChange);
          }
        }
        if (observer) observer.disconnect();
        if (hud.parentNode) hud.remove();
      };
    }

    function previewWizardVariant(variantId, options) {
      var opts = options || {};
      var syncPdp = opts.syncPdp !== false;
      var scrollCarousel = opts.scrollCarousel !== false;
      var id = vQtyKey(variantId);
      var v = findWizardVariant(id);
      state.focusedVariantId = id;
      if (v && syncPdp) syncVariantToPdp(wizardRoot, data, v);
      syncBookingUrlVariantOnStep3(id);
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (wrap) {
        wrap.querySelectorAll('.wcf-variant-row').forEach(function (row) {
          var rid = row.getAttribute('data-variant-id') || '';
          var on = rid === id && !(state.variantQty[id] > 0);
          row.classList.toggle('is-preview', on);
          if (scrollCarousel && rid === id) {
            /* Scroll only the carousel track — scrollIntoView also moves the PDP gallery. */
            if (wrap.classList.contains('wcf-variants--carousel')) {
              animateCarouselScrollLeft(wrap, carouselSlideScrollLeft(wrap, row), 420);
            } else {
              var left = row.offsetLeft - (wrap.clientWidth - row.offsetWidth) / 2;
              wrap.scrollTo({
                left: Math.max(0, left),
                behavior: 'smooth',
              });
            }
          }
        });
      }
    }

    function findWizardVariant(id) {
      var key = vQtyKey(id);
      if (addonVariantIdKey && key === addonVariantIdKey) return addonVariantObject();
      for (var i = 0; i < variants.length; i++) {
        if (vQtyKey(variants[i].id) === key) return variants[i];
      }
      return null;
    }

    function refreshVariantRowUI(variantId) {
      var id = vQtyKey(variantId);
      var wrap = wizardRoot.querySelector('[data-wbw-variants]');
      if (!wrap) return;
      var row = wrap.querySelector('.wcf-variant-row[data-variant-id="' + id + '"]');
      if (!row) return;
      var qty = state.variantQty[id] || 0;
      row.classList.toggle('is-active', qty > 0);
      row.classList.toggle(
        'is-preview',
        state.focusedVariantId === id && qty <= 0
      );
      var val = row.querySelector('[data-wbw-qty-val]');
      if (val) val.textContent = String(qty);
      var dec = row.querySelector('[data-wbw-qty-dec]');
      if (dec) dec.disabled = qty <= 0;
      var inc = row.querySelector('[data-wbw-qty-inc]');
      if (inc) {
        var maxTotal = maxBookableQty();
        if (isAddonVariantId(id)) {
          var addonQ = state.variantQty[id] || 0;
          inc.disabled = Number.isFinite(maxTotal) && addonQ >= maxTotal;
        } else {
          inc.disabled = Number.isFinite(maxTotal) && totalVariantQty(false) >= maxTotal;
        }
      }
      var card = row.querySelector('.wcf-variant-card');
      if (card) card.classList.toggle('is-active', qty > 0);
      var vObj = findWizardVariant(id);
      if (vObj) {
        var pricesWrap = row.querySelector('.wcf-variant-card__prices');
        if (pricesWrap) {
          pricesWrap.outerHTML = formatWizardVariantPricesOuter(vObj, state.selectedSlot);
        }
      }
    }

    function adjustVariantQty(variantId, delta) {
      var id = vQtyKey(variantId);
      var cur = state.variantQty[id] || 0;
      var maxTotal = maxBookableQty();
      var isAddon = isAddonVariantId(id);
      var others = isAddon ? cur : totalVariantQty(false) - cur;
      var v = findWizardVariant(id);

      if (delta > 0) {
        if (isAddon) {
          if (Number.isFinite(maxTotal) && cur >= maxTotal) return;
          state.variantQty[id] = Number.isFinite(maxTotal) ? Math.min(cur + 1, maxTotal) : cur + 1;
        } else {
          if (others >= maxTotal) return;
          state.variantQty[id] = Math.min(cur + 1, maxTotal - others);
          state.focusedVariantId = id;
          state.lockedVariantId = id;
        }
      } else {
        if (cur <= 1) delete state.variantQty[id];
        else state.variantQty[id] = cur - 1;
        if (!isAddon && (state.variantQty[id] || 0) > 0) {
          state.focusedVariantId = id;
          state.lockedVariantId = id;
        }
      }
      refreshVariantRowUI(id);
      updateVariantStepUi();
      if (!isAddon && v && (delta > 0 || (state.variantQty[id] || 0) > 0)) {
        syncVariantToPdp(wizardRoot, data, v);
        syncBookingUrlVariantOnStep3(id);
      }
    }

    function computeTotalCents() {
      var total = 0;
      var slot = state.selectedSlot;
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var v = findWizardVariant(k);
        if (v) total += resolveVariantPriceCents(v, slot) * q;
      });
      return total;
    }

    function updateVariantStepUi() {
      var titleHead = wizardRoot.querySelector('[data-wbw-variant-title-head]');
      var titleEl = wizardRoot.querySelector('[data-wbw-variant-title]');
      if (titleHead) titleHead.hidden = false;
      if (titleEl) {
        var storeFlow = !!(state.selectedVenue && isStoreVenue(state.selectedVenue));
        var when = storeFlow ? formatBookingSubLabel(state.selectedSlot) : '';
        if (when) {
          titleEl.innerHTML =
            'Choose Your Workshop Project <span class="wbw-variant-title__sep" aria-hidden="true">·</span> <span class="wbw-variant-title__when">' +
            escapeHtml(when) +
            '</span>';
        } else {
          titleEl.textContent = 'Choose Your Workshop Project';
        }
      }
      var tot = wizardRoot.querySelector('[data-wbw-total]');
      if (tot) {
        var cents = computeTotalCents();
        tot.textContent = formatMoney(cents);
      }
      var addBtn = wizardRoot.querySelector('[data-wbw-action="add-cart"]');
      if (addBtn) addBtn.disabled = !hasSelectedVariants() || !state.selectedSlot;
      var clearBtn = wizardRoot.querySelector('[data-wbw-action="clear-selection"]');
      if (clearBtn) {
        var hasAnyQty = false;
        Object.keys(state.variantQty).forEach(function (k) {
          if (state.variantQty[k] > 0) hasAnyQty = true;
        });
        clearBtn.disabled = !hasAnyQty;
      }
      updateSelectionSummary();
      syncSiblingWorkshopPromo();
    }

    function firstNonEmptyStr() {
      for (var i = 0; i < arguments.length; i++) {
        var s = arguments[i] == null ? '' : String(arguments[i]).trim();
        if (s) return s;
      }
      return '';
    }

    function buildLineItemProperties(slot, variantId, resolvedCents) {
      var raw = (slot && slot._raw) || {};
      var venueObj = state.selectedVenue || {};
      var eventId = String(raw.id || slot.gid || '').trim();
      var eventHandle = String(raw.handle || slot.handle || '').trim();
      var venue = String(raw.venue_name || raw.venue || venueObj.venue_name || '').trim();
      var city = String(raw.city || '').trim();
      var stateCode = String(raw.state || '').trim();
      var datetime = formatBookingSubLabel(slot);
      var displayCity = stateCode ? city + ', ' + stateCode : city;
      // Slot event first, then selected venue object (same selection context — not a silent default)
      var venueAddress = firstNonEmptyStr(
        raw.venue_address,
        raw.address,
        venueObj.venue_address,
        venueObj.address
      );
      var venuePhone = firstNonEmptyStr(raw.venue_phone, raw.phone, venueObj.venue_phone, venueObj.phone);
      var venueHours = firstNonEmptyStr(
        raw.venue_work_hours,
        raw.work_hours,
        venueObj.venue_work_hours,
        venueObj.work_hours
      );
      var props = {
        _workshop: 'true',
        _event_id: eventId,
        _event_metaobject_gid: eventId.indexOf('gid://') === 0 ? eventId : slot.gid || eventId,
        _event_handle: eventHandle,
        _display_city: displayCity,
        _display_venue: venue,
        _display_datetime: datetime,
        _unique: String(variantId) + ':' + eventId,
        _is_workshop: '1',
        'Booking Details': [venue, datetime].filter(Boolean).join(' · '),
      };
      if (venueAddress) props._venue_address = venueAddress;
      if (venuePhone) props._venue_phone = venuePhone;
      if (venueHours) props._venue_hours = venueHours;
      var slotForValidation = Object.assign({}, slot, { gid: slot.gid || eventId });
      var flow = window.WorkshopCityFlow;
      if (flow && typeof flow.appendCartValidationProperties === 'function') {
        props = flow.appendCartValidationProperties(slotForValidation, props);
      } else {
        var cap = slot && slot.capacity_remaining;
        if (cap != null && cap !== '') {
          var cn = Number(cap);
          if (Number.isFinite(cn) && cn >= 0) {
            props._capacity_remaining = String(cn);
            props._capacity_source = 'wizard_slot';
          }
        }
      }
      var centsStr = String(resolvedCents == null ? '' : resolvedCents).trim();
      if (/^[0-9]+$/.test(centsStr) && parseInt(centsStr, 10) > 0) {
        props._resolved_price_cents = centsStr;
        props._resolved_price = centsStr;
      }
      return props;
    }

    var wlFieldErrorTimers = {};

    function clearWlFieldErrors(step) {
      if (!step) return;
      step.querySelectorAll('[data-wbw-wl-field-hint]').forEach(function (hint) {
        hint.hidden = true;
        hint.textContent = '';
      });
      step.querySelectorAll('.wcf-field--err').forEach(function (field) {
        field.classList.remove('wcf-field--err');
      });
    }

    function showWlFieldError(input, message) {
      if (!input || !message) return;
      var field = input.closest('.wcf-field');
      if (!field) return;
      var key =
        input.getAttribute('data-wbw-wl-name') || input.getAttribute('data-wbw-wl-modal-name')
          ? 'name'
          : input.getAttribute('data-wbw-wl-email') || input.getAttribute('data-wbw-wl-modal-email')
            ? 'email'
            : 'other';
      if (wlFieldErrorTimers[key]) {
        clearTimeout(wlFieldErrorTimers[key]);
        wlFieldErrorTimers[key] = null;
      }
      var hint = field.querySelector('[data-wbw-wl-field-hint]');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'wcf-field-hint wcf-field-hint--err';
        hint.setAttribute('data-wbw-wl-field-hint', '');
        hint.setAttribute('role', 'alert');
        field.appendChild(hint);
      }
      hint.textContent = message;
      hint.hidden = false;
      field.classList.add('wcf-field--err');
      input.setAttribute('aria-invalid', 'true');
      wlFieldErrorTimers[key] = window.setTimeout(function () {
        hint.hidden = true;
        hint.textContent = '';
        field.classList.remove('wcf-field--err');
        input.removeAttribute('aria-invalid');
        wlFieldErrorTimers[key] = null;
      }, 2000);
    }

    function submitWaitlist() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal].is-open');
      var step = modal || stepEl('waitlist');
      if (!step) return;
      var nameIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-name]' : '[data-wbw-wl-name]'
      );
      var emailIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-email]' : '[data-wbw-wl-email]'
      );
      var notesIn = step.querySelector(
        modal ? '[data-wbw-wl-modal-notes]' : '[data-wbw-wl-notes]'
      );
      var errEl = step.querySelector(modal ? '[data-wbw-wl-modal-error]' : '[data-wbw-wl-error]');
      var okEl = step.querySelector(modal ? '[data-wbw-wl-modal-success]' : '[data-wbw-wl-success]');
      var subBtn = modal
        ? modal.querySelector('[data-wbw-action="wl-submit"]')
        : step.querySelector('[data-wbw-action="wl-submit"]');
      if (errEl) errEl.hidden = true;
      if (okEl) okEl.hidden = true;
      clearWlFieldErrors(step);

      var fullName = nameIn ? String(nameIn.value || '').trim() : '';
      var email = emailIn ? String(emailIn.value || '').trim() : '';
      var notes = notesIn ? String(notesIn.value || '').trim() : '';
      var parts = splitFullName(fullName);

      if (!fullName) {
        showWlFieldError(nameIn, 'Please enter your name.');
        if (nameIn && nameIn.focus) nameIn.focus();
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showWlFieldError(emailIn, 'Please enter a valid email.');
        if (emailIn && emailIn.focus) emailIn.focus();
        return;
      }

      var venue = state.selectedVenue || {};
      var venueRefId = venue.venue_ref_id != null ? String(venue.venue_ref_id).trim() : '';
      var venueTitle = (venue.venue_name || venue.name || '').trim();
      var loc = (window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.label) || '';
      if (!loc && bookingRoot) {
        var inp = bookingRoot.querySelector('[data-workshop-location-input]');
        if (inp) loc = String(inp.value || '').trim();
      }
      var cityForAddress = '';
      if (loc) {
        var addrParts = loc.split(',');
        if (addrParts[0]) cityForAddress = String(addrParts[0]).trim();
      }
      if (!cityForAddress && venueTitle) cityForAddress = venueTitle;

      if (subBtn) subBtn.disabled = true;

      resolveWaitlistWorkshopType(wizardRoot, bookingRoot, data)
        .then(function (workshopType) {
          if (!workshopType) {
            throw new Error(
              'Workshop type could not be determined. Add a product tag (mosaic, ceramic, resin, or flower) or set Workshop type in the booking block settings.'
            );
          }

          var shopDomain = window.Shopify && window.Shopify.shop ? String(window.Shopify.shop).trim() : '';
          var myshopifyDomain = '';
          if (/\.myshopify\.com$/i.test(shopDomain)) myshopifyDomain = shopDomain;
          if (!myshopifyDomain) {
            try {
              var pfShopDomain =
                window.__pagefly_setting__ &&
                window.__pagefly_setting__.shopDomain
                  ? String(window.__pagefly_setting__.shopDomain).trim()
                  : '';
              if (/\.myshopify\.com$/i.test(pfShopDomain)) myshopifyDomain = pfShopDomain;
            } catch (_) {}
          }
          var resolvedShopDomain = myshopifyDomain || shopDomain;
          var payload = {
            email: email,
            first_name: parts.first,
            last_name: parts.last,
            name: fullName,
            location: loc,
            venue_id: venueRefId,
            venue_name: venueTitle,
            notes: notes,
            shop_domain: resolvedShopDomain,
            shop: shopDomain,
            myshopify_domain: myshopifyDomain,
            workshop_type: workshopType,
          };
          if (cityForAddress) {
            payload.city = cityForAddress;
            payload.country = 'New Zealand';
            payload.country_code = 'NZ';
          }

          var url =
            typeof window.__WB_WAITLIST_API_URL__ === 'string' && window.__WB_WAITLIST_API_URL__.trim()
              ? window.__WB_WAITLIST_API_URL__.trim()
              : 'https://adapter.aogen.com.au/api/public/waitlist';

          var submitFn = Flow && Flow.submitWaitlist ? Flow.submitWaitlist : null;
          return submitFn
            ? submitFn(url, payload)
            : fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(payload),
                mode: 'cors',
              }).then(function (res) {
                if (res.ok) return;
                return res.text().then(function (txt) {
                  throw new Error(txt || 'Request failed');
                });
              });
        })
        .then(function () {
          if (okEl) okEl.hidden = false;
          if (modal) {
            window.setTimeout(function () {
              closeWizardWaitlistModal();
            }, 2200);
          }
        })
        .catch(function (err) {
          if (errEl) {
            errEl.textContent = err && err.message ? String(err.message).slice(0, 200) : 'Something went wrong.';
            errEl.hidden = false;
          }
        })
        .finally(function () {
          if (subBtn) subBtn.disabled = false;
        });
    }

    function submitCartForSlot(slot, addBtn) {
      var items = [];
      Object.keys(state.variantQty).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var vid = parseInt(k, 10);
        if (!Number.isFinite(vid) || vid <= 0) return;
        var v = findWizardVariant(k);
        if (isAddonVariantId(k)) {
          items.push({
            id: vid,
            quantity: q,
            properties: {
              _workshop_addon: 'true',
              _addon_for_event_id: String((slot._raw && slot._raw.id) || slot.gid || ''),
              _addon_title: wbwAddonDisplayTitle(wizardRoot),
            },
          });
          return;
        }
        var resolved = v ? resolveVariantPriceCents(v, slot) : 0;
        var handle = String((slot._raw && slot._raw.handle) || slot.handle || '');
        if (/^\d+$/.test(handle) || !handle) {
          window.alert('This workshop event is not available for booking. Please select a different time.');
          return;
        }
        items.push({
          id: vid,
          quantity: q,
          properties: buildLineItemProperties(slot, vid, resolved),
        });
      });
      if (!items.length) return;

      var payload = { items: items };
      if (Flow && Flow.getCartSections) {
        var sections = Flow.getCartSections();
        if (sections.length) {
          payload.sections = sections.join(',');
          payload.sections_url = (window.location && window.location.pathname) || '/';
        }
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (r) {
          if (!r.ok || (r.body && r.body.status === 422)) {
            window.alert((r.body && r.body.description) || 'Unable to add to cart.');
            return;
          }
          if (Flow && Flow.dispatchCartUi) Flow.dispatchCartUi(r.body);
          if (addBtn) addBtn.textContent = 'Added';
        })
        .catch(function () {
          window.alert('Unable to add to cart.');
        });
    }

    function addToCart() {
      if (!state.selectedSlot || !hasSelectedVariants()) return;
      var addBtn = wizardRoot.querySelector('[data-wbw-action="add-cart"]');
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
      }
      var freshPromise =
        liveController && typeof liveController.ensureFreshSlot === 'function'
          ? liveController.ensureFreshSlot(state.selectedSlot)
          : Promise.resolve(state.selectedSlot);
      freshPromise
        .then(function (freshSlot) {
          if (!freshSlot || !slotBookable(freshSlot)) {
            window.alert('This workshop event is sold out. Please select a different time.');
            return null;
          }
          state.selectedSlot = freshSlot;
          replaceSelectedSlotFromList([freshSlot]);
          updateVariantStepUi();
          syncCapacityRing();
          var addQty = totalVariantQty(false);
          var validatePromise;
          if (liveController && typeof liveController.validateSlotForCart === 'function') {
            validatePromise = liveController.validateSlotForCart(freshSlot, addQty);
          } else {
            var liveApi = getLiveApi();
            if (liveApi && typeof liveApi.validateAddToCart === 'function') {
              validatePromise = liveApi.validateAddToCart(freshSlot, addQty, { intent: 'add_to_cart' });
            } else {
              validatePromise = Promise.resolve({
                allowed: false,
                message: 'We could not verify workshop availability. Please try again.',
              });
            }
          }
          return validatePromise.then(function (verdict) {
            if (!verdict || verdict.allowed === false) {
              window.alert(
                (verdict && verdict.message) ||
                  'This workshop event is no longer available. Please select a different time.'
              );
              return null;
            }
            return freshSlot;
          });
        })
        .then(function (freshSlot) {
          if (!freshSlot) return;
          return submitCartForSlot(freshSlot, addBtn);
        })
        .catch(function () {
          window.alert('Unable to confirm workshop availability. Please try again.');
        })
        .finally(function () {
          if (addBtn) {
            addBtn.disabled = !hasSelectedVariants();
            addBtn.textContent = 'Add to cart';
          }
        });
    }

    wizardRoot.addEventListener('click', function (e) {
      var act = e.target.closest('[data-wbw-action]');
      if (act) {
        var action = act.getAttribute('data-wbw-action');
        if (action === 'to-next') {
          e.preventDefault();
          goToNextFromVenue();
          return;
        }
        if (action === 'to-variants') {
          e.preventDefault();
          if (!state.selectedSlot) return;
          closeCalTimeDd();
          ensureLockedVariantFromUrlOrSlot();
          window.__WB_LOCK_VARIANT_URL__ = true;
          setBranch('variants');
          renderVariants();
          if (state.lockedVariantId) previewWizardVariant(state.lockedVariantId);
          return;
        }
        if (action === 'back') {
          e.preventDefault();
          if (state.branch === 'variants') {
            if (state.selectedVenue && !isStoreVenue(state.selectedVenue)) {
              state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
              setPopupDatetimeLoading(false);
              clearVenueSelection();
              setBranch('venue');
              return;
            }
            if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
            else clearBookingUrlEventIdKeepVariant();
            setBranch('datetime');
            renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
          } else if (state.branch === 'datetime' || state.branch === 'waitlist') {
            /* Invalidate in-flight calendar → Step 2 must not reappear after Back. */
            state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
            setDatetimeCalLoading(false);
            clearVenueSelection();
            setBranch('venue');
          }
          return;
        }
        if (action === 'clear-selection') {
          e.preventDefault();
          state.variantQty = {};
          renderVariants();
          return;
        }
        if (action === 'add-cart') {
          e.preventDefault();
          addToCart();
          return;
        }
        if (action === 'wl-submit') {
          e.preventDefault();
          submitWaitlist();
          return;
        }
      }

      var calDay = e.target.closest('[data-wbw-cal-day]');
      if (calDay && !calDay.disabled && stepEl('datetime') && stepEl('datetime').contains(calDay)) {
        state._wbwUserPickedCalDate = true;
        state.selectedDate = calDay.getAttribute('data-wbw-cal-day') || '';
        state.selectedSlot = null;
        clearBookingUrlEventIdKeepVariant();
        renderCalendar({ closeTimeDd: true, allowAutoSelectSingle: true });
        return;
      }

      if (e.target.closest('[data-wbw-cal-prev]')) {
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() - 1, 1);
        closeCalTimeDd();
        loadCalendarMonthForView();
        return;
      }
      if (e.target.closest('[data-wbw-cal-next]')) {
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + 1, 1);
        closeCalTimeDd();
        loadCalendarMonthForView();
        return;
      }

    });

    window.addEventListener(
      'resize',
      function () {
        var wrap = wizardRoot.querySelector('[data-wbw-variants]');
        if (wrap && wrap.querySelectorAll('.wcf-variant-row').length) {
          applyVariantGridLayout(wrap, wrap.querySelectorAll('.wcf-variant-row').length, wizardRoot);
        }
      },
      { passive: true }
    );

    bindVenueSelection();
    document.addEventListener('wbw:venue-reset', onVenueResetEvent);
    document.addEventListener('wbw:venue-list-rendered', function () {
      rebindSelectedVenueCard();
      updateVenueContinue();
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) return;
      if (state.branch !== 'venue') return;
      var locSource =
        (typeof window !== 'undefined' &&
          window.__WORKSHOP_LOCATION__ &&
          window.__WORKSHOP_LOCATION__.source) ||
        '';
      if (locSource === 'places') return;
      tryApplyWizardUrlDeepLink();
    });
    window.setTimeout(function () {
      tryApplyWizardUrlDeepLink();
    }, 0);
    bindCalTimeControls();
    if (bookingRoot) {
      bindWizardSearchLayout(bookingRoot);
    }
    wizardRoot.setAttribute('data-wbw-flow', 'booking');
    setBranch('venue');
    updateVenueContinue();
    updateProgressLabels();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-workshop-booking-wizard]');
    roots.forEach(function (root) {
      try {
        initRoot(root);
      } catch (bootErr) {
        window.__wbwPromoDiag = {
          scriptLoaded: true,
          phase: 'initRoot-error',
          error: String(bootErr && bootErr.message ? bootErr.message : bootErr),
          wizardRoots: roots.length,
          hostCount: document.querySelectorAll('[data-workshop-sibling-promo]').length,
        };
      }
    });
    if (!window.__wbwPromoDiag || window.__wbwPromoDiag.phase === 'parsing') {
      window.__wbwPromoDiag = {
        scriptLoaded: true,
        phase: 'boot-fallback',
        show: false,
        branch: '',
        flow: '',
        hasVenue: false,
        hasSlot: false,
        hostCount: document.querySelectorAll('[data-workshop-sibling-promo]').length,
        hasWrap: !!document.querySelector('[data-wbw-sibling-promo-wrap]'),
        hasList: !!document.querySelector('[data-wbw-sibling-promo-list]'),
        slotAaLen: 0,
        venueEvents: 0,
        itemCount: 0,
        wizardRoots: roots.length,
        note: 'wizard sync did not run',
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
